import { Component, ViewChild, OnInit, OnDestroy, ChangeDetectorRef, ElementRef, HostListener } from "@angular/core";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CommonService, CrudComponent } from 'wire-frame';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Subscription } from 'rxjs';

import { TagModule } from 'primeng/tag';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { AutoComplete, AutoCompleteModule } from "primeng/autocomplete";
import { DropdownModule } from 'primeng/dropdown';
import { AccordionModule } from 'primeng/accordion';
import { ToolbarModule } from 'primeng/toolbar';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { EditorModule } from 'primeng/editor';

import { PrescriptionsService } from '../../../service/admin/prescriptions.service';
import { AnalyticsService } from '../../../service/admin/analytics.service';
import { AppointmentService } from '../../../service/admin/appointment.service';
import { CardsService } from '../../../service/admin/cards.service';
import { ClinicService } from '../../../service/admin/clinic.service';
import { UserService } from '../../../service/admin/user.service';
import { PatientRegistrationService } from '../../../service/admin/patient-registration.service';

import { ApiService } from '../../../service/admin/api.service';
import { WorkContextService } from '../../../service/admin/work-context.service';
import { DeskChatService } from '../../../service/admin/desk-chat.service';
import { ReportViewerService, ReportViewerPayload } from '../../../service/admin/report-viewer.service';
import { ReportViewerDialogComponent } from '../../shared/report-viewer/report-viewer-dialog.component';

import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';
import { InputTextModule } from 'primeng/inputtext';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { FloatLabelModule } from 'primeng/floatlabel';
import { SidebarModule } from 'primeng/sidebar';
import { TooltipModule } from 'primeng/tooltip';

import { DialogModule } from 'primeng/dialog';
import { WorkContextBarComponent } from '../../shared/work-context-bar/work-context-bar.component';
import { todayDateString, buildHourlyAppointmentWindow } from '../../../utils/clinic-date.util';
import { ToasterService } from '../../../service/common/toaster.service';
// import { PRESCRIPTION_TOAST_LIFE } from '../../../service/common/toaster.service';
import {
  DELIVERY_TYPE_OPTIONS,
  DeliveryType,
  FlowCounts,
  FlowFilter,
  deliveryBadgeIcon,
  deliveryTypeLabel,
  deliveryTypeShortLabel,
  matchesFlowFilter,
  nextDeliveryType,
  resolveAppointmentFlow,
  resolveDeliveryType,
} from '../../../utils/delivery-type.util';
import {
  downloadBlob,
  isImageReportFile,
} from '../../../utils/report-file.util';
import {
  MedicineIntent,
  medicineIntentShortLabel,
  medicineIntentTitle,
  receptionNoteTooltip,
} from '../../../utils/medicine-intent.util';
import {
  NEW_PATIENT_VISIT_FEES,
  REGULAR_PATIENT_VISIT_FEES,
  resolveDefaultVisitFees,
  applyVisitDiscount,
  normalizeDiscountPercent,
} from '../../../utils/visit-fees.util';
import {
  formatPatientAge,
  hasValidPatientAge,
  patientAgeToPayload,
  readPatientAge,
} from '../../../utils/patient-age.util';
import { extractHttpErrorMessage } from '../../../utils/http-error.util';
import { PatientAgeFieldsComponent } from '../../shared/patient-age-fields/patient-age-fields.component';

type ConsultationQueueStatusFilter = 'all' | 'waiting' | 'with_doctor' | 'paused' | 'done';

interface OpenConsultationEntry {
  patient_id: number;
  appointment_id: number;
  display_name: string;
  patient_number?: string;
  last_opened_at: string;
}

interface CommandPaletteItem {
  id: string;
  kind: 'action' | 'patient' | 'open';
  label: string;
  sublabel?: string;
  icon?: string;
  payload?: any;
}

@Component({
  selector: 'app-patients',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    TagModule,
    ToggleButtonModule,
    DropdownModule,
    ToolbarModule,
    ToastModule,
    ConfirmDialogModule,
    EditorModule,
    ButtonModule,
    TabViewModule,
    ScrollPanelModule,
    DialogModule,
    InputTextModule,
    FloatLabelModule,
    SidebarModule,
    AutoCompleteModule,
    WorkContextBarComponent,
    AccordionModule,
    PatientAgeFieldsComponent,
    TooltipModule,
    ReportViewerDialogComponent,
  ],
  providers: [ConfirmationService, CommonService, PrescriptionsService, AppointmentService, ClinicService, UserService, PatientRegistrationService, ApiService],
  templateUrl: './prescriptions.component.html',
  styleUrl: './prescriptions.component.scss'
})
export class PrescriptionsComponent implements OnInit, OnDestroy {
  @ViewChild('docUploadInput') docUploadInput?: ElementRef<HTMLInputElement>;
  @ViewChild('headerPatientSearchAuto') headerPatientSearchAuto?: AutoComplete;
  @ViewChild('patientSearchAuto') patientSearchAuto?: AutoComplete;
  @ViewChild('medicineQueueSearchInput') medicineQueueSearchInput?: ElementRef<HTMLInputElement>;
  @ViewChild('consultationQueueSearchInput') consultationQueueSearchInput?: ElementRef<HTMLInputElement>;
  @ViewChild('commandPaletteInput') commandPaletteInput?: ElementRef<HTMLInputElement>;
  public checked: boolean = false;
  activeIndex: number = 0;
  pationtIndex: number = 0;
  historyTabIndex: number = 0;
  /** Excel-style history: 2 columns × 10 rows per page. */
  readonly historyRowsPerColumn = 10;
  historySheetPage = 0;
  canCorrectTodayVisit = false;
  visitRevisionVisible = false;
  visitRevisionSaving = false;
  private visitReviseIgnoreBackdrop = false;
  visitRevisionRecord: any = null;
  visitRevisionPreview: any = null;
  visitRevisionForm = {
    chief_complaints: '',
    medicines: '',
    notes: '',
  };
  public isDirty: boolean = false;
  public draftStatus: 'idle' | 'saved' | 'error' = 'idle';
  public draftLastSavedAt: string | null = null;
  public hasTodayDraft: boolean = false;
  public todayDraftSavedAt: string | null = null;
  displayHistory: boolean = false;

  isReportDialogVisible: boolean = false;


  isPatientVisible: boolean = false;
  isMedicineVisible: boolean = false;
  notesDialogVisible: boolean = false;
  hotkeysHelpVisible = false;
  commandPaletteVisible = false;
  commandPaletteQuery = '';
  commandPaletteItems: CommandPaletteItem[] = [];
  commandPaletteIndex = 0;
  commandPaletteSearching = false;
  private commandPalettePatients: any[] = [];
  private commandPaletteSearchToken = 0;
  private readonly commandPaletteActions: CommandPaletteItem[] = [
    { id: 'save', kind: 'action', label: 'Save prescription', icon: 'pi-check' },
    { id: 'queue', kind: 'action', label: "Today's queue", icon: 'pi-users' },
    { id: 'find', kind: 'action', label: 'Find patient', icon: 'pi-search' },
    { id: 'add', kind: 'action', label: 'Add patient', icon: 'pi-user-plus' },
    { id: 'medicine', kind: 'action', label: 'Medicine queue', icon: 'pi-inbox' },
    { id: 'notes', kind: 'action', label: 'Doctor notes', icon: 'pi-file-edit' },
    { id: 'shortcuts', kind: 'action', label: 'Keyboard shortcuts', icon: 'pi-question-circle' },
    { id: 'queue-board', kind: 'action', label: 'Queue board', icon: 'pi-table' },
  ];
  queueKeyboardIndex = -1;
  
  accordionIndex: number | null = null;

  scrollToToday() {
    this.selectedIndex = 'today';
  }

  scrollToRecord(index: number) {
    this.selectHistoryRecord(index);
  }
  isMedicineCollection: boolean = false;
  public allMedicineQueue: any[] = [];

  // Quick Add Patient state
  quickAddDialogVisible: boolean = false;
  readonly maxPatientAge = 130;
  /** When true, creates a walk-in appointment and opens the prescription form after register. */
  quickStartConsultation = true;
  isNewPatientCard: boolean = false;
  quickSelectedCard: any = null;
  quickFilteredCardList: any[] = [];
  quickPatient: any = {
    full_name: '',
    age: '',
    age_months: '',
    age_days: '',
    contact_number: '',
    is_free: false,
    card_id: null
  };
  quickIsForeignContact = false;

  clinicId: number = 0; // Default clinic ID
  doctorId: number = 0; // Default clinic ID
  selectedDate: string = todayDateString();

  public patientsList: any[] = [];
  public prescriptionsList: any[] = [];
  public isSearchingPatients: boolean = false;
  public patientSearchQuery: string = '';
  selectedPatient: any;
  public clinicsList = [];
  public doctorsList = [];
  public appointmentsList = [];
  private cardSearchGeneration = 0;
  public editRecord = null;
  public queue: any[] = [];

  // Cross-clinic queue awareness: clinics (other than the one currently open)
  // where this doctor has patients waiting. Populated by the queue summary poll.
  public queueAlerts: { clinic_id: number; clinic_name: string; waiting: number; total_active: number }[] = [];
  private queueSummaryBaseline: Map<number, number> | null = null;

  public consultationFlowFilter: FlowFilter = 'all';
  public consultationQueueSearchTerm = '';
  public consultationStatusFilter: ConsultationQueueStatusFilter = 'all';
  public openConsultations: OpenConsultationEntry[] = [];
  private pendingReturnConsultation: OpenConsultationEntry | null = null;
  private readonly maxOpenConsultations = 5;
  private readonly openConsultationsStoragePrefix = 'rx_open_consultations_v1';
  private readonly openChipTones = ['blue', 'teal', 'violet', 'amber', 'rose'] as const;

  private readonly patientSalutations = [
    'Shri.', 'Smt.', 'Ku.', 'Mr.', 'Mrs.', 'Ms.', 'Dr.', 'Prof.', 'Er.', 'CA.', 'Adv.'];

  /** One-click chips for common chief complaints (clustered for fast scanning). */
  readonly commonComplaintBadgeClusters: string[][] = [
    ['Hypo / Hyper Thyroid', 'Hypertension', 'Diabetes']];

  readonly rxHotkeySections: {
    title: string;
    icon: string;
    tone: string;
    items: { keys: string; action: string }[];
  }[] = [
    {
      title: 'Workflow',
      icon: 'pi-bolt',
      tone: 'workflow',
      items: [
        { keys: 'Ctrl + S', action: 'Save' },
        { keys: 'Alt + Q', action: "Today's queue" },
        { keys: 'Alt + F', action: 'Find patient' },
        { keys: 'Ctrl + K', action: 'Command palette' },
        { keys: 'Alt + A', action: 'Add patient' },
        { keys: 'Alt + M', action: 'Medicine queue' },
        { keys: 'Alt + H', action: 'Doctor notes' },
        // { keys: 'Alt + D', action: 'Desk chat' },
      ],
    },
    {
      title: 'Queue',
      icon: 'pi-users',
      tone: 'queue',
      items: [
        { keys: 'Alt + ↓', action: 'Next patient' },
        { keys: 'Alt + ↑', action: 'Previous patient' },
        { keys: 'Alt + Enter', action: 'Open patient' }],
    },
    {
      title: 'Tabs',
      icon: 'pi-th-large',
      tone: 'tabs',
      items: [
        { keys: 'Alt + 1', action: 'Patient card' },
        { keys: 'Alt + 2', action: 'Other' },
        { keys: 'Alt + 3', action: 'Reports' },
        { keys: 'Alt + 4', action: 'History' }],
    },
    {
      title: 'Dictate',
      icon: 'pi-microphone',
      tone: 'dictation',
      items: [
        { keys: 'F2', action: 'Chief complaints' },
        { keys: 'F3', action: 'Medicines' },
        { keys: 'F4', action: 'Consultation notes' },
        { keys: 'Esc', action: 'Stop dictation' }],
    },
    {
      title: 'Visit',
      icon: 'pi-sliders-h',
      tone: 'visit',
      items: [
        { keys: 'Alt + P', action: 'Medicine pickup' },
        { keys: 'Alt + C', action: 'Cycle delivery type' },
        { keys: 'Alt + U', action: 'Upload report' }],
    },
    {
      title: 'Help',
      icon: 'pi-question-circle',
      tone: 'help',
      items: [
        { keys: 'Alt + /', action: 'Shortcuts guide' },
        { keys: 'Esc', action: 'Close sidebar or dialog' }],
    }];

  splitHotkeyKeys(keys: string): string[] {
    return keys.split(/\s*\+\s*/).map((part) => part.trim()).filter(Boolean);
  }

  get rxHotkeyCount(): number {
    return this.rxHotkeySections.reduce((total, section) => total + section.items.length, 0);
  }
  public medicineQueueFlowFilter: FlowFilter = 'all';
  public medicineQueueSearchTerm = '';
  readonly deliveryTypeOptions = DELIVERY_TYPE_OPTIONS;
  readonly reportMaxFileSizeBytes = 20 * 1024 * 1024;
  public waitingTimeTick = Date.now();
  private waitingTimeInterval: any;
  uploadsByDate: { date: Date, files: any[] }[] = [];
  reportRows: Array<{ date: any; file: any }> = [];
  selectedReportGroupIndex = 0;
  reportsDropActive = false;
  reportSearchQuery: string = '';
  reportFilterType: 'all' | 'image' | 'pdf' = 'all';
  reportViewMode: 'grid' | 'table' = 'table';
  selectedIndex: number | 'today' = 'today';
  filteredRecords: any[] = [];
  hxPanelOpen = {
    past: false,
    family: false,
  };
  otPanelOpen = {
    general: false,
    physical: false,
    exam: false,
    systemic: false,
    constitutional: false,
    mental: false,
  };
  selectedFiles: File[] = [];

  public pendingFiles: File[] = [];
  public isUploadingReports: boolean = false;
  public deletingReportId: number | null = null;
  viewingReportFile: any | null = null;
  openingReportId: number | null = null;
  reportViewerVisible = false;
  reportViewerLoading = false;
  reportViewerTitle = '';
  reportViewerIsImage = false;
  reportViewerImageUrl: string | null = null;
  reportViewerDocumentUrl: SafeResourceUrl | null = null;
  reportViewerRawUrl: string | null = null;
  reportViewerError: string | null = null;
  private reportOpenSub?: Subscription;
  private deskChatOpenSub?: Subscription;
  private dialogPreviewBlobUrl: string | null = null;
  public appointmentIntakeNote = '';
  public appointmentMedicineIntent: MedicineIntent | null = null;
  public receptionNotesHighlightActive = false;
  private receptionNotesSeed = '';
  /** Reception appointment_note for the active visit; survives draft restore. */
  private pendingReceptionAppointmentNote = '';

  public patient: any = {

    id: 0,  // number: Unique ID
    full_name: '',
    salutation: '',
    contact_number: '',  // string: Phone number
    age: 0,
    age_months: 0,
    age_days: 0,
    is_free: false,     // number: Age in years  // boolean: true = free visit
    visit_fees: null as number | null,
    card_id: 0,     // string: Courier-related info
    patient_number: '',     // string: Courier-related info

    scanned_card: null as File | null, // File upload (can be null or File)

    summary: '', // string: Summary of the visit
    medicines: '', // string: Prescribed medicines
    // other patient fields...
    diagnosis_receipt: '',
    visit_date: new Date(),
    receipt_amount: '',
    // card_dues: '',
    group_dues: '',
    fees_this_visit: '',
    mode: '',
    cash: '',
    cheque: '',

    //other 

    // Date of first visit
    first_visit: new Date(), // Date of first visit

    under_dr: '', // string: Under doctor's care (optional)
    occupation: '', // string: Occupation (optional)
    referred_by: '', // string: Referred by (optional)
    referred_by_dr: '', // string: Referred by (optional)
    other_refferce: '', // string: Other referred by (optional)
    important_notes: '', // string: Standing notes until overwritten
  };

  public prescription: any = {
    appointment_id: 0,
    summary: '',
    medicines: '',
    chief_complaints: '',
    diagnosis: '',
    past_history: '',
    menstrual_history: '',
    respiratory_system: '',
    cardiovascular_system: '',
    central_nervous_system: '',
    per_abdomen: '',
    family_history: {
      father: '',
      mother: '',
      other: ''
    },
    others: {
      nail: '',
      mentals: '',
      stool: '',
      urine: '',
      sleep: '',
      parsp: '',
      corn: '',
      mole: '',
      hair: '',
      spine: '',
      pallor: '',
      cyanosis: '',
      clubbing: '',
      icterus: '',
      thirst: '',
      craving: '',
      aversion: '',
      dreams: '',
      thermals: '',
      warts: '',
      lm: '',
      tongue: '',
    },
    personal_dues: 0,
    visit_fees: REGULAR_PATIENT_VISIT_FEES,
    discount_percent: 0,
    received_cash: 0,
    received_online: 0,
    card_dues: 0,
    notes: '',
    delivery_type: null as DeliveryType | null,
    is_courier: false,
  }
  public appointmentDeliveryType: DeliveryType | null = null;

  public patientSelectedFromSearch = false;

  public closeFormEvent: boolean = false;
  public openDeletePopup: any = null;
  public activeMenu: string = 'personal';
  private readonly draftStoragePrefix = 'prescription_draft_v1';
  private draftAutosaveInterval: any = null;
  private lastDraftFingerprint: string = '';
  private draftRestorePending = false;
  private draftSaveSuppressed = false;
  private patientLoadGeneration = 0;
  private queueRefreshTimer: ReturnType<typeof setTimeout> | null = null;
  /** Appointment we just moved to "in progress", so a fast switch can pause it before the queue reloads. */
  private pendingInProgressAppointmentId = 0;
  private sideLoadsGen = 0;
  private detailsReadyForGen = 0;
  private historyAppliedForGen = 0;
  private historyReadyForGen: { gen: number; records: any[] } | null = null;
  private parkedDraftBuffer: { gen: number; serverDraft: any | null; settled: boolean } | null = null;
  private switchFlowSource: any = null;
  private switchPatientId = 0;
  private loadedCardMembersCardId = 0;
  /** Chip the doctor just clicked, until that chart is on screen. */
  switchingPatientId = 0;
  /** Pre-discount fee locked for this consultation (discount is applied on top of this). */
  private visitFeeBaseAmount: number = REGULAR_PATIENT_VISIT_FEES;
  private lastAppliedDiscountPercent = 0;
  /** Online amount already saved on this visit. Further gateway charges collect only the difference. */
  private settledOnlineAmount = 0;
  /** Cash already saved on this visit. Typed amounts above this are new money. */
  private recordedCashAmount = 0;
  onlinePaymentInProgress = false;
  private onlinePaymentListenerAttached = false;
  private pendingOnlinePrescriptionId = 0;
  private pendingOnlineCharge = 0;
  private readonly handledPaymentTrackingIds = new Set<string>();
  cardMembers: any[] = [];
  cardMembersLoading = false;
  patientPayments: any = null;
  patientPaymentsLoading = false;
  patientPaymentsError = false;
  private patientPaymentsRequest = 0;
  private patientPaymentsFromLedger = false;
  private cardMembersRequest = 0;
  private readonly onOnlinePaymentMessage = (event: MessageEvent) => {
    this.handleOnlinePaymentMessage(event);
  };

  private apiUrl: string | undefined;

  constructor(
    public common: CommonService,
    private toaster: ToasterService, private confirmationService: ConfirmationService,
    private prescriptionsService: PrescriptionsService,
    private analytics: AnalyticsService,
    private appointmentService: AppointmentService,
    private cardsService: CardsService,
    private clinicService: ClinicService,
    private userService: UserService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private patientRegistrationService: PatientRegistrationService,
    private apiService: ApiService,
    private workContext: WorkContextService,
    private deskChat: DeskChatService,
    private router: Router,
    private reportViewerService: ReportViewerService,
    private sanitizer: DomSanitizer,
  ) {
    this.apiUrl = this.apiService.getBaseUrl();
    this.common.breadCrum = {
      title: 'Visa Card Master',
      icon: 'user',
      list: ['Visa Card Master'],
    };
    this.common.setCrudTableHeaders([
      {
        title: 'Patient Name',
        val: 'patient_name',
        id: 'id',
        showColumn: true,
        filterColmn: true,
        order: 'asc',
        searchColumn: true,
        type: 'string',
        globalSearch: true,
      }]);
    this.common.setCrudActions([
      {
        title: '',
        icon: 'pi-pencil',
        classArr: 'me-2',
        tooltip: 'Update Patient',
      },
      { title: '', icon: 'pi-trash', tooltip: 'Delete Patient' }]);
  }

  // private releaseToastLifeCaps?: () => void;

  ngOnInit() {
    this.canCorrectTodayVisit = this.readIsDoctor();
    // Shorter prescription toasts paused — restore with toaster.useLifeCaps(PRESCRIPTION_TOAST_LIFE).
    // this.releaseToastLifeCaps = this.toaster.useLifeCaps(PRESCRIPTION_TOAST_LIFE);
    // this.getPatients();
    this.loadOpenConsultationsFromStorage();
    this.loadQueue();
    this.loadQueueSummary();
    // this.loadAllMedicineQueue();

    setInterval(() => {
      if (this.common.getLoggedInUser()) {
        this.loadQueue();
        this.loadQueueSummary();
        // this.loadAllMedicineQueue();
      }
      // this.loadMedicineQueue();
    }, 30000);

    this.waitingTimeInterval = setInterval(() => {
      this.waitingTimeTick = Date.now();
      this.cdr.markForCheck();
    }, 30000);

    this.startDraftAutosave();
    this.deskChatOpenSub = this.deskChat.openPatient$.subscribe((patientId) => {
      if (!patientId) {
        return;
      }
      this.deskChat.clearOpenRequest();
      this.onPatientSelect({ value: { id: patientId, patient_id: patientId } });
    });
  }

  ngOnDestroy() {
    // this.releaseToastLifeCaps?.();
    // this.releaseToastLifeCaps = undefined;
    this.reportOpenSub?.unsubscribe();
    this.deskChatOpenSub?.unsubscribe();
    this.deskChat.setAttachablePatient(null);
    this.revokeDialogPreviewBlob();
    if (this.draftAutosaveInterval) {
      clearInterval(this.draftAutosaveInterval);
      this.draftAutosaveInterval = null;
    }
    if (this.queueRefreshTimer) {
      clearTimeout(this.queueRefreshTimer);
      this.queueRefreshTimer = null;
    }
    if (this.waitingTimeInterval) {
      clearInterval(this.waitingTimeInterval);
      this.waitingTimeInterval = null;
    }
    this.workContext.restorePreviousContext();
    if (this.onlinePaymentListenerAttached) {
      window.removeEventListener('message', this.onOnlinePaymentMessage);
      this.onlinePaymentListenerAttached = false;
    }
  }

  private getQueueSlotMinutes(): number {
    return this.clinicService.getSlotDurationMinutes(this.workContext.getClinicId());
  }

  private getAuthHeaders() {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    }
  }

  getPrescriptions() {
    this.prescriptionsService.getPrescriptions().subscribe((res: any) => {
      this.prescriptionsList = res.data;
    })
  }

  closeForm() {
    this.clearForm();
    this.closeFormEvent = true;
    setTimeout(() => {
      this.closeFormEvent = false;
    }, 1);
  }

  clearForm() {
    this.patient = {
      id: 0,  // number: Unique ID
      full_name: '',
      salutation: '',
      contact_number: '',  // string: Phone number
      age: 0,
      age_months: 0,
      age_days: 0,
      is_free: false,     // number: Age in years  // boolean: true = free visit
      visit_fees: null as number | null,
      card_id: 0,     // string: Courier-related info

      scanned_card: null as File | null, // File upload (can be null or File)

      summary: '', // string: Summary of the visit
      medicines: '', // string: Prescribed medicines
      // other patient fields...
      diagnosis_receipt: '',
      visit_date: new Date(),
      receipt_amount: '',
      card_dues: '',
      group_dues: '',
      fees_this_visit: '',
      mode: '',
      cash: '',
      cheque: '',

      //other 

      // Date of first visit
      first_visit: new Date(), // Date of first visit

      under_dr: '', // string: Under doctor's care (optional)
      occupation: '', // string: Occupation (optional)
      referred_by: '', // string: Referred by (optional)
      referred_by_dr: '', // string: Referred by (optional)
      other_refferce: '', // string: Other referred by (optional)
      important_notes: '',
    };

    this.prescription = {
      appointment_id: 0,
      summary: '',
      medicines: '',
      chief_complaints: '',
      diagnosis: '',
      past_history: '',
      menstrual_history: '',
      respiratory_system: '',
      cardiovascular_system: '',
      central_nervous_system: '',
      per_abdomen: '',
      family_history: {
        father: '',
        mother: '',
        other: ''
      },
      others: {
        nail: '',
        mentals: '',
        stool: '',
        urine: '',
        sleep: '',
        parsp: '',
        corn: '',
        mole: '',
        hair: '',
        spine: '',
        pallor: '',
        cyanosis: '',
        clubbing: '',
        icterus: '',
        thirst: '',
        craving: '',
        aversion: '',
        dreams: '',
        thermals: '',
        warts: '',
        lm: '',
        tongue: '',
      },
      personal_dues: 0,
      visit_fees: REGULAR_PATIENT_VISIT_FEES,
      discount_percent: 0,
      received_cash: 0,
      received_online: 0,
      card_dues: 0,
      notes: '',
      delivery_type: null,
      is_courier: false,
    }
    this.appointmentDeliveryType = null;
    this.visitFeeBaseAmount = REGULAR_PATIENT_VISIT_FEES;
    this.lastAppliedDiscountPercent = 0;
    this.settledOnlineAmount = 0;
    this.recordedCashAmount = 0;
    this.onlinePaymentInProgress = false;
    this.pendingOnlinePrescriptionId = 0;
    this.pendingOnlineCharge = 0;
    this.cardMembers = [];
    this.cardMembersLoading = false;
    this.cardMembersRequest += 1;

    // ✅ Reset history + reports
    this.filteredRecords = [];   // prescription history
    this.patientPayments = null;
    this.patientPaymentsLoading = false;
    this.patientPaymentsError = false;
    this.patientPaymentsFromLedger = false;
    this.patientPaymentsRequest += 1;
    this.resetHistorySheetPage();
    this.selectedIndex = 'today';
    this.uploadsByDate = [];
    this.reportRows = [];
    this.viewingReportFile = null;
    this.resetSelectedFiles();
    this.resetDraftUiState();
    this.appointmentIntakeNote = '';
    this.appointmentMedicineIntent = null;
    this.pendingReceptionAppointmentNote = '';
    this.clearReceptionNotesHighlight();
    this.deskChat.setAttachablePatient(null);
  }

  resetSelectedFiles() {
    this.pendingFiles = [];
    this.selectedFiles = [];
    if (this.docUploadInput?.nativeElement) {
      this.docUploadInput.nativeElement.value = '';
    }
  }

  processPatients() {
    if (this.patient?.id) {
      this.updatePatients();
    } else {
      this.addPrescriptions();
    }
  }

  addPrescriptions() {
    this.draftSaveSuppressed = true;
    if (this.patientSelectedFromSearch) {
      this.saveAppointmentAndPrescription();
      this.patientSelectedFromSearch = false; // reset flag
    } else {
      this.savePrescriptionOnly();
    }
  }


  // savePrescriptionOnly() {
  //   this.prescriptionsService.addPrescriptions(this.prescription).subscribe((res: any) => {
  //     if (res.success) {
  //       const prescription = res.data;

  //       // ✅ Upload reports if there are any files waiting
  //       if (this.pendingFiles && this.pendingFiles.length > 0) {
  //         const formData = new FormData();
  //         formData.append('patient_id', this.patient.patient_id.toString());
  //         formData.append('prescription_id', prescription.id.toString());
  //         this.pendingFiles.forEach((file: File) => {
  //           formData.append('files[]', file, file.name);
  //         });

  //         this.prescriptionsService.uploadReports(formData).subscribe({
  //           next: (uploadRes: any) => {
  //             if (uploadRes.success) {
  //               this.mergeReports(uploadRes.data); // merge into gallery
  //             }
  //           },
  //           error: (err) => console.error('Report upload failed:', err)
  //         });
  //       }

  //       this.toaster.success(res.message);
  //       this.getPrescriptions();

  //       // Change appointment status to 'completed'
  //       if (this.prescription.appointment_id) {
  //         this.appointmentService.changeStatus(this.prescription.appointment_id, 'completed').subscribe({
  //           next: () => this.loadQueue(), // Optionally refresh the queue
  //           error: (err) => console.error('Error changing status:', err)
  //         });
  //       }

  //       this.clearForm();
  //       this.closeForm();

  //     } else {
  //       this.toaster.error(res.message);
  //     }
  //   });
  // }

  savePrescriptionOnly() {
    if (this.rejectExcessPayment()) {
      return;
    }
    if (!this.getCurrentPatientId()) {
      this.draftSaveSuppressed = false;
      console.error('No patient selected!');
      this.toaster.error('Please select a patient first.');
      return;
    }

    const patientValidationError = this.getPatientSaveValidationError();
    if (patientValidationError) {
      this.draftSaveSuppressed = false;
      this.toaster.error(patientValidationError);
      return;
    }

    this.syncDeliveryFlags();

    const savedPatientId = this.getCurrentPatientId();
    this.updatePatientDetailsBeforeSave({
      onSuccess: () => this.persistPrescription(savedPatientId),
      onError: () => { this.draftSaveSuppressed = false; },
    });
  }

  private persistPrescription(savedPatientId: number) {
    const saveObservable = this.prescription.id
      ? this.prescriptionsService.updatePrescriptions(this.prescription)
      : this.prescriptionsService.addPrescriptions(this.prescription);

    saveObservable.subscribe({
      next: (res: any) => {
        if (!res.success) {
          this.draftSaveSuppressed = false;
          this.toaster.error(res.message);
          return;
        }

        this.completeSavedConsultation(savedPatientId);

        const prescription = res.data;
        this.prescription.id = prescription.id;

        if (this.pendingFiles && this.pendingFiles.length > 0) {
          const formData = new FormData();
          formData.append('patient_id', this.getCurrentPatientId().toString());
          formData.append('prescription_id', this.prescription.id.toString());

          this.pendingFiles.forEach((file: File) => {
            formData.append('files[]', file, file.name);
          });

          this.prescriptionsService.uploadReports(formData).subscribe({
            next: (uploadRes: any) => {
              if (uploadRes.success) {
                this.resetSelectedFiles();
              } else {
                console.error('Report upload failed:', uploadRes.message);
              }
            },
            error: (err) => console.error('Report upload failed:', err)
          });
        }

        this.toaster.success(res.message);
        this.persistAppointmentDeliveryFlag(this.prescription.appointment_id || prescription?.appointment_id);

        this.getPrescriptions();
        if (this.prescription.appointment_id) {
          this.appointmentService.changeStatus(this.prescription.appointment_id, 'medicine').subscribe({
            next: () => this.loadQueue(),
            error: (err) => console.error('Error changing status:', err)
          });
        }

        this.restoreWorkContextAfterConsultation();
        this.invalidatePatientLoad();
        this.clearForm();
        this.closeForm();
        this.tryResumePendingConsultationAfterSave();
      },
      error: (err) => {
        this.draftSaveSuppressed = false;
        console.error('Error saving prescription:', err);
        this.toaster.error(err?.error?.message || 'Failed to save prescription.');
      }
    });
  }

  updatePatients() {
    this.prescriptionsService.updatePrescriptions(this.patient).subscribe((res: any) => {
      if (res.data) {
        this.toaster.success(res.message);
        this.getPrescriptions();
        this.closeForm();
      } else {
        this.toaster.error(res.message);
      }
    });
  }

  // deletePatients(item: any) {
  //   this.prescriptionsService.deletePrescriptions(item).subscribe((res: any) => {
  //     this.toaster.add({
  //       severity: 'success',
  //       summary: 'Success',
  //       detail: 'Visa Card deleted successfully',
  //     });

  //     this.getPrescriptions();
  //     this.closeForm();
  //   })
  // }

  // deleteRecord(event: any) {
  //   if(event) {
  //     this.deletePatients(event);
  //   }
  // }

  handleEvent(event: any) {
    // console.log(event);
    if (event.action.tooltip == "Update Patient") {
      this.editRecord = event.data;
      this.patient = event.data;
      setTimeout(() => {
        this.editRecord = null;
      }, 1);
    } else if (event.action.tooltip == "Delete Patient") {
      this.editRecord = event.data;
      this.delRecPopupOpen({ title: this.editRecord?.['first_name  '], obj: this.editRecord });
    }
  }

  delRecPopupOpen(item: any) {
    this.openDeletePopup = item;
    setTimeout(() => {
      this.openDeletePopup = null;
    }, 1);
  }

  onCardUpload(event: any) {
    const file = event.target.files[0];
    this.patient.scanned_card = file ?? null;
  }

  onPrintReceipt() {
    console.log('Printing receipt...');
  }


  onShowReceiptHistory() {
    console.log('Showing receipt history...');
  }

  onShowOutstandingAll() {
    console.log('Showing all outstanding balances...');
  }

  markDirty() {
    this.isDirty = true;
  }

  // Reset dirty state after saving/updating
  resetDirty() {
    this.isDirty = false;
  }

  patientHistory: any[] = [
    { date: '2025-08-01', summary: 'Follow-up checkup, BP stable' },
    { date: '2025-08-10', summary: 'Blood test results normal' },
    { date: '2025-08-15', summary: 'Prescription updated: Vitamin D' }
  ];

  openPoPopup() {
    this.displayHistory = true;
  }

  closePoPopup() {
    this.displayHistory = false;
  }


  // Method to close Patient section
  closePatient() {
    this.isPatientVisible = false;
  }

  // Method to reopen Patient section
  openPatient() {
    this.isPatientVisible = true;
  }


  openReports(date: string) {
    this.selectedDate = date;
    this.isReportDialogVisible = true;
  }

  searchPatients(event: any) {
    const query = (event?.query || '').trim();
    this.patientSearchQuery = query;
    if (query.length < 2) {
      this.patientsList = [];
      this.isSearchingPatients = false;
      return;
    }

    this.isSearchingPatients = true;
    this.http.get<any>(this.apiUrl + '/patient/search', { params: { q: query }, ...this.getAuthHeaders() })
      .subscribe(res => {
        if (!res.data || res.data.length === 0) {
          this.patientsList = [];
        } else {
          this.patientsList = res.data.map((p: any) => ({
            ...p,
            search_label: `${p.full_name} (${p.patient_number || '—'})`,
          }));
        }
        this.isSearchingPatients = false;
        this.cdr.detectChanges();
      }, error => {
        this.patientsList = [];
        this.isSearchingPatients = false;
        this.cdr.detectChanges();
      });
  }

  get patientSearchMatchCount(): number {
    if ((this.patientSearchQuery || '').trim().length < 2) {
      return 0;
    }
    return (this.patientsList || []).length;
  }

  get showPatientSearchMinCharsHint(): boolean {
    return (this.patientSearchQuery || '').trim().length < 2 && !this.isSearchingPatients;
  }
  // Quick Add Patient logic
  openQuickAddDialog() {
    this.quickPatient = {
      full_name: '',
      age: '',
      age_months: '',
      age_days: '',
      contact_number: '',
      is_free: false,
      card_id: null
    };
    this.quickIsForeignContact = false;
    this.isNewPatientCard = true;
    this.quickSelectedCard = null;
    this.quickFilteredCardList = [];
    this.quickStartConsultation = true;
    this.quickAddDialogVisible = true;
  }

  closeQuickAddDialog() {
    this.quickAddDialogVisible = false;
  }

  onQuickNewPatientToggle() {
    if (this.isNewPatientCard) {
      this.quickSelectedCard = null;
      this.quickPatient.card_id = null;
    } else {
      this.searchQuickCards({ query: '' });
    }
  }

  onQuickContactInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const digits = String(input.value ?? '').replace(/\D/g, '').slice(0, 10);
    if (input.value !== digits) {
      input.value = digits;
    }
    this.quickPatient.contact_number = digits;
  }

  onQuickForeignContactInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const raw = String(input.value ?? '');
    const digits = raw.replace(/\D/g, '').slice(0, 15);
    const formatted = digits ? `+${digits}` : '';
    if (input.value !== formatted) {
      input.value = formatted;
    }
    this.quickPatient.contact_number = formatted;
  }

  get hasValidQuickContact(): boolean {
    if (this.quickIsForeignContact) {
      const digits = (this.quickPatient.contact_number || '').replace(/\D/g, '');
      return digits.length >= 8 && digits.length <= 15;
    }
    return /^[6-9]\d{9}$/.test((this.quickPatient.contact_number || '').trim());
  }

  toggleQuickForeignContact(): void {
    this.quickIsForeignContact = !this.quickIsForeignContact;
    this.quickPatient.contact_number = '';
  }

  private getQuickContactForSave(): string {
    return (this.quickPatient.contact_number || '').trim();
  }

  onQuickAgeInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const sanitized = this.sanitizeQuickAge(input.value);
    const display = sanitized === '' ? '' : String(sanitized);
    if (input.value !== display) {
      input.value = display;
    }
    this.quickPatient.age = sanitized;
  }

  private sanitizeQuickAge(value: unknown): number | '' {
    const digits = String(value ?? '').replace(/\D/g, '');
    if (!digits) {
      return '';
    }
    const parsed = parseInt(digits, 10);
    if (!Number.isFinite(parsed)) {
      return '';
    }
    return Math.min(this.maxPatientAge, Math.max(0, parsed));
  }

  searchQuickCards(event: any) {
    const query = (event?.query || '').trim();
    if (query.length < 1) {
      this.quickFilteredCardList = [];
      return;
    }

    const searchGen = ++this.cardSearchGeneration;
    this.patientRegistrationService.searchCards(query).subscribe({
      next: (res: any) => {
        if (searchGen !== this.cardSearchGeneration) {
          return;
        }
        this.quickFilteredCardList = Array.isArray(res?.data)
          ? res.data.map((card: any) => this.mapCardOption(card))
          : [];
        this.cdr.detectChanges();
      },
      error: (err) => {
        if (searchGen !== this.cardSearchGeneration) {
          return;
        }
        console.error('Card search error:', err);
        this.quickFilteredCardList = [];
      },
    });
  }

  private mapCardOption(card: any): any {
    const patients = Array.isArray(card.patients) ? card.patients : [];
    const patientNames = patients.map((patient: any) => patient.full_name).filter(Boolean);

    return {
      label: card.patient_names ? `${card.number} - ${card.patient_names}` : card.number,
      value: card.id,
      number: card.number,
      patientCount: card.patient_count ?? patients.length,
      patients,
      searchText: [card.number, ...patientNames, card.patient_names]
        .filter(Boolean)
        .join(' ')
        .toLowerCase(),
    };
  }

  onQuickCardSelect(event: any) {
    const selected = event?.value ?? null;
    if (!selected) {
      this.quickSelectedCard = null;
      this.quickPatient.card_id = null;
      return;
    }
    this.quickSelectedCard = selected;
    this.quickPatient.card_id = selected.value;
  }

  get quickSelectedCardPatients(): any[] {
    return this.quickSelectedCard?.patients || [];
  }

  getPatientInitials(name: string | null | undefined): string {
    const parts = (name || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) {
      return '?';
    }
    if (parts.length === 1) {
      return parts[0].charAt(0).toUpperCase();
    }
    return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
  }

  displayPatientAge(
    years?: number | string | null,
    months?: number | string | null,
    days?: number | string | null,
  ): string {
    return formatPatientAge(years, months, days);
  }

  get canSubmitQuickPatient(): boolean {
    const hasValidAge = hasValidPatientAge(
      {
        years: this.quickPatient.age,
        months: this.quickPatient.age_months,
        days: this.quickPatient.age_days,
      },
      this.maxPatientAge,
    );
    return !!(
      (this.quickPatient.full_name || '').trim() &&
      hasValidAge &&
      this.hasValidQuickContact
    );
  }

  get quickAddWorkflowHint(): string {
    const name = (this.quickPatient.full_name || '').trim();

    if (!name) {
      return 'Step 1: Enter patient details. Step 2: Choose how to assign their card.';
    }

    if (this.isNewPatientCard) {
      return `Registering ${name} on a new card.`;
    }

    if (this.quickSelectedCard?.number) {
      return `Adding ${name} to card ${this.quickSelectedCard.number}.`;
    }

    return `${name} is ready — search and select a card on the right.`;
  }

  get quickAddVisitFeeHint(): string {
    if (this.quickPatient?.is_free) {
      return 'Consultation is free of charge.';
    }

    const isNewCard = this.isNewPatientCard || !this.quickSelectedCard?.value;
    return isNewCard ? 'New patient fee: ₹1,100' : 'Regular patient fee: ₹1,000';
  }

  saveQuickPatient() {
    const clinicId = Number(sessionStorage.getItem('clinic_id')) || 0;
    const doctorId = Number(sessionStorage.getItem('doctor_id')) || 0;

    let defaultDoctorName = '';
    if (doctorId && this.doctorsList && this.doctorsList.length > 0) {
      const doc: any = this.doctorsList.find((d: any) => Number(d.value) === doctorId);
      if (doc) {
        defaultDoctorName = doc.label;
      }
    }

    const payload: any = {
      ...this.quickPatient,
      contact_number: this.getQuickContactForSave(),
      ...patientAgeToPayload({
        years: this.quickPatient.age,
        months: this.quickPatient.age_months,
        days: this.quickPatient.age_days,
      }),
      clinic_id: clinicId,
      under_dr: defaultDoctorName,
    };

    if (this.quickSelectedCard && typeof this.quickSelectedCard.value !== 'undefined') {
      payload.card_id = this.quickSelectedCard.value;
    } else {
      delete payload.card_id;
    }

    const shouldStartConsultation = this.quickStartConsultation;

    this.patientRegistrationService.addPatient(payload).subscribe({
      next: (res: any) => {
        if (res.data) {
          this.toaster.success('Patient added successfully');
          this.closeQuickAddDialog();

          const patientData = res.data;
          const newPatientId = patientData.id || patientData.patient_id;
          if (!newPatientId) {
            return;
          }

          // Do not set patient.patient_id here — requestPatientSwitch treats that as
          // "already on this patient" and would skip opening the consultation form.
          this.patientSelectedFromSearch = true;
          this.isPatientVisible = false;

          if (shouldStartConsultation) {
            this.startConsultationForNewPatient(patientData);
          } else {
            this.onPatientSelect({ value: patientData });
          }
        } else {
          this.toaster.error(res.message || 'Failed to add patient');
        }
      },
      error: (err) => {
        console.error('Error adding patient:', err);
        this.toaster.error('Failed to communicate with server');
      }
    });
  }


  onPatientSelect(event: any) {
    const selected = event?.value ?? {};
    const patientId = Number(selected.id || selected.patient_id || 0);
    if (!patientId) {
      return;
    }

    // PrimeNG writes the selected item into ngModel after onSelect; clear on the next tick.
    this.clearPatientSearchInput();

    this.requestPatientSwitch(selected, (loadGen) => {
      this.isPatientVisible = false;

      this.resolveTodayAppointmentForPatient(patientId, ({ open, prescribed }) => {
        if (!this.isPatientLoadCurrent(loadGen)) {
          return;
        }

        if (open) {
          this.applySelectPatient(
            this.buildQueueSelectionFromAppointment(open, selected),
            loadGen,
          );
          return;
        }

        if (prescribed) {
          this.toaster.add({
            severity: 'info',
            summary: 'New visit',
            detail: 'This patient already consulted today. Starting a new appointment.',
          });
          this.applyLoadPatientFromSearch(patientId, loadGen);
          return;
        }

        this.applyLoadPatientFromSearch(patientId, loadGen);
      });
    });
  }

  private clearPatientSearchInput(): void {
    setTimeout(() => {
      this.selectedPatient = null;
      this.patientsList = [];
      this.patientSearchQuery = '';
      this.cdr.detectChanges();
    }, 0);
  }

  private buildQueueSelectionFromAppointment(appointment: any, selected?: any): any {
    const appointmentId = appointment.id ?? appointment.appointment_id;
    return {
      appointment_id: appointmentId,
      patient_id: appointment.patient_id ?? selected?.id ?? selected?.patient_id,
      clinic_id: appointment.clinic_id,
      doctor_id: appointment.doctor_id,
      medicine_collection: appointment.medicine_collection,
      delivery_type: appointment.delivery_type ?? (appointment.is_courier ? 'home_delivery' : null),
      is_courier: appointment.is_courier,
      name: selected?.full_name ?? appointment.patient?.full_name,
      appointment_notes: appointment.notes ?? appointment.appointment_notes ?? '',
      appointment_note: appointment.appointment_note ?? '',
      medicine_intent: appointment.medicine_intent ?? null,
    };
  }

  private readonly prescribedAppointmentStatuses = ['medicine', 'completed'];

  private resolveTodayAppointmentForPatient(
    patientId: number,
    callback: (result: { open: any | null; prescribed: any | null }) => void,
  ): void {
    const queueItems = (this.queue || []).filter(
      (item: any) => Number(item.patient_id) === patientId && Number(item.appointment_id) > 0,
    );
    if (queueItems.length) {
      const openStatuses = ['scheduled', 'checked in', 'in progress', 'paused'];
      const openItem = this.pickPreferredTodayAppointment(
        queueItems.filter((item: any) => openStatuses.includes(item.status)),
        {
          'in progress': 4,
          paused: 3,
          'checked in': 2,
          scheduled: 1,
        },
      );
      if (openItem) {
        callback({
          open: this.buildQueueSelectionFromAppointment(openItem),
          prescribed: null,
        });
        return;
      }

      const prescribedItem = queueItems.find((item: any) =>
        this.prescribedAppointmentStatuses.includes(item.status),
      );
      if (prescribedItem) {
        callback({
          open: null,
          prescribed: this.buildQueueSelectionFromAppointment(prescribedItem),
        });
        return;
      }
    }

    const date = this.selectedDate || todayDateString();
    const clinicId = Number(this.workContext.getClinicId() ?? sessionStorage.getItem('clinic_id')) || 0;
    const doctorId = Number(this.workContext.getDoctorId() ?? sessionStorage.getItem('doctor_id')) || 0;

    if (!clinicId) {
      callback({ open: null, prescribed: null });
      return;
    }

    this.appointmentService.getAppointment(date, date).subscribe({
      next: (res: any) => {
        if (!res?.success || !Array.isArray(res.data)) {
          callback({ open: null, prescribed: null });
          return;
        }

        const scoped = res.data.filter(
          (appt: any) =>
            Number(appt.patient_id) === patientId &&
            Number(appt.clinic_id) === clinicId &&
            (!doctorId || Number(appt.doctor_id) === doctorId),
        );

        const openStatuses = ['scheduled', 'checked in', 'in progress', 'paused'];
        const openMatches = scoped.filter((appt: any) => openStatuses.includes(appt.status));
        const prescribedMatches = scoped.filter((appt: any) =>
          this.prescribedAppointmentStatuses.includes(appt.status),
        );

        const open = openMatches.length
          ? this.pickPreferredTodayAppointment(openMatches, {
              'in progress': 3,
              'checked in': 2,
              scheduled: 1,
            })
          : null;
        const prescribed = prescribedMatches.length
          ? this.pickPreferredTodayAppointment(prescribedMatches, {
              medicine: 2,
              completed: 1,
            })
          : null;

        callback({ open, prescribed });
      },
      error: () => callback({ open: null, prescribed: null }),
    });
  }

  private pickPreferredTodayAppointment(
    matches: any[],
    priority: Record<string, number>,
  ): any {
    return [...matches].sort(
      (a: any, b: any) =>
        (priority[b.status] || 0) - (priority[a.status] || 0) ||
        String(b.start_time || '').localeCompare(String(a.start_time || '')),
    )[0];
  }

  private findTodayPrescribedAppointmentForPatient(
    patientId: number,
    callback: (appointment: any | null) => void,
  ): void {
    this.resolveTodayAppointmentForPatient(patientId, ({ prescribed }) => {
      callback(prescribed);
    });
  }

  private handleAlreadyPrescribedPatient(
    patientId: number,
    options: { removeFromDock?: boolean } = {},
  ): void {
    if (options.removeFromDock) {
      this.clearTodayDraftForPatient(patientId);
      this.removePatientFromOpenConsultationDock(patientId);
    }

    this.toaster.add({
      severity: 'info',
      summary: 'Already Prescribed Today',
      detail: 'This patient is already prescribed today. Use Recall Rx from Medicine Queue to edit.',
    });
  }

  private isDoubleBookingError(message: string): boolean {
    const normalized = (message || '').toLowerCase();
    return normalized.includes('already booked') || normalized.includes('time slot');
  }

  private applyLoadPatientFromSearch(patientId: number, existingLoadGen?: number): void {
    if (existingLoadGen && !this.isPatientLoadCurrent(existingLoadGen)) {
      return;
    }

    this.clearForm();
    this.patient.patient_id = patientId;
    this.onPatientContextChanged();
    this.patientSelectedFromSearch = true;
    this.prescription.appointment_id = 0;
    this.prescription.id = 0;

    const loadGen = existingLoadGen ?? this.beginPatientLoad();
    this.loadPatientPayments(patientId);

    // 1. Fetch patient info
    this.patientRegistrationService.getSinglePatient(patientId).subscribe((res: any) => {
      if (!this.isPatientLoadCurrent(loadGen)) {
        return;
      }

      if (res.success) {
        const patient = res.data;
        this.applyPatientDemographics(patient);
        this.patient.card_number = patient.patient_number?.split('-')[0] || '';
        this.patient.patient_number = patient.patient_number || '';
        this.patient.occupation = patient.occupation || '';
        this.patient.referred_by = patient.referred_by || '';
        this.patient.referred_by_dr = patient.referred_by_dr || '';
        this.patient.is_free = patient.is_free || false;
        this.patient.card_id = patient.card_id;
        this.patient.visit_fees = patient.visit_fees != null ? Number(patient.visit_fees) : null;
        this.prescription.discount_percent = 0;
        this.lastAppliedDiscountPercent = 0;
        this.prescription.visit_fees = this.resolveVisitFees(patient);
        this.setVisitFeeBase(Number(this.prescription.visit_fees) || 0);
        this.loadCardMembers(patient.card_id);
        this.syncDeskChatPatient();
      }
    });

    // Fetch latest prescription for this patient
    // this.prescriptionsService.getLatestPrescription(this.patient.patient_id).subscribe((res: any) => {
    //   if (res.success && res.data) {
    //     const prescription = res.data;

    //     // Prefill prescription form
    //     this.prescription = {
    //       ...this.prescription,   // keep any default values
    //       summary: prescription.summary || '',
    //       chief_complaints: prescription.chief_complaints || '',
    //       medicines: prescription.medicines || '',
    //       diagnosis: prescription.diagnosis || '',
    //       menstrual_history: prescription.menstrual_history || '',
    //       obstetric_history: prescription.obstetric_history || '',
    //       central_nervous_system: prescription.central_nervous_system || '',
    //       cardiovascular_system: prescription.cardiovascular_system || '',
    //       respiratory_system: prescription.respiratory_system || '',
    //       per_abdomen: prescription.per_abdomen || '',
    //       family_history: prescription.family_history || { father: '', mother: '', other: '' },
    //       past_history: prescription.past_history || '',
    //       others: prescription.others || {
    //         nail: '',
    //         mentals: '',
    //         stool: '',
    //         urine: '',
    //         sleep: '',
    //         parsp: '',
    //         corn: '',
    //         mole: '',
    //         hair: '',
    //         spine: '',
    //         pallor: '',
    //         cyanosis: '',
    //         clubbing: '',
    //         icterus: '',
    //         thirst: '',
    //         craving: '',
    //         aversion: '',
    //         dreams: '',
    //         thermals: '',
    //         warts: '',
    //         lm: '',
    //         tongue: '',
    //       },
    //       personal_dues: prescription.personal_dues || 0,
    //       // visit_fees: prescription.visit_fees || 0,
    //       // received_cash: prescription.received_cash || 0,
    //       // received_online: prescription.received_online || 0
    //     };
    //   } else {
    //     // No previous prescription → clear form
    //     this.prescription = {
    //       summary: '',
    //       chief_complaints: '',
    //       medicines: '',
    //       diagnosis: '',
    //       menstrual_history: '',
    //       obstetric_history: '',
    //       central_nervous_system: '',
    //       cardiovascular_system: '',
    //       respiratory_system: '',
    //       per_abdomen: '',
    //       family_history: '',
    //       others: '',
    //       personal_dues: 0,
    //       visit_fees: 0,
    //       received_cash: 0,
    //       received_online: 0    
    //     };
    //   }
    // });

    // 2. Fetch ALL prescriptions for history
    this.prescriptionsService.getPrescriptionsByPatientId(patientId).subscribe((res: any) => {
      if (!this.isPatientLoadCurrent(loadGen)) {
        return;
      }

      if (res.success && res.data) {
        this.filteredRecords = res.data; // history tab
        this.resetHistorySheetPage();
        this.selectedIndex = 'today';
        // console.log('Prescription history:', this.filteredRecords);

        this.syncVisitFeesAfterHistoryLoad();

        // ✅ Calculate personal dues
        this.prescription.personal_dues = this.calculatePersonalDues(
          this.filteredRecords,
          this.prescription
        );

        // Calculate card dues dynamically
        this.prescription.card_dues = this.filteredRecords.length
          ? this.filteredRecords[0].card_dues || 0
          : 0; // use card_dues from API
        this.rememberRecordedPayment();
        this.useVisitPaymentsIfNeeded();

        if (this.filteredRecords.length) {
          const latestPrescription = this.filteredRecords[0];

          this.prescription.past_history = latestPrescription.past_history || '';
          this.prescription.menstrual_history = latestPrescription.menstrual_history || '';
          this.prescription.family_history = latestPrescription.family_history || {
            father: '',
            mother: '',
            other: ''
          };
          this.prescription.respiratory_system = latestPrescription.respiratory_system || '';
          this.prescription.cardiovascular_system = latestPrescription.cardiovascular_system || '';
          this.prescription.central_nervous_system = latestPrescription.central_nervous_system || '';
          this.prescription.per_abdomen = latestPrescription.per_abdomen || '';
          this.prescription.others = latestPrescription.others || {
            others: {
              nail: '',
              mentals: '',
              stool: '',
              urine: '',
              sleep: '',
              parsp: '',
              corn: '',
              mole: '',
              hair: '',
              spine: '',
              pallor: '',
              cyanosis: '',
              clubbing: '',
              icterus: '',
              thirst: '',
              craving: '',
              aversion: '',
              dreams: '',
              thermals: '',
              warts: '',
              lm: '',
              tongue: '',
            }
          };
        }

        this.finalizePatientDraftRestore(patientId, loadGen);
      } else {
        this.filteredRecords = [];
        this.resetHistorySheetPage();
        this.selectedIndex = 'today';
        this.prescription.card_dues = 0;
        this.syncVisitFeesAfterHistoryLoad();
        this.finalizePatientDraftRestore(patientId, loadGen);
      }
    });

    // ✅ Fetch reports
    this.prescriptionsService.getReportsByPatientId(patientId).subscribe((rRes: any) => {
      if (!this.isPatientLoadCurrent(loadGen)) {
        return;
      }

      this.applyPatientReports(rRes.success ? rRes.data : []);
    });

    // 3. (Optional) Clear prescription form since no active appointment
    // this.prescription = {
    //   summary: '',
    //   chief_complaints: '',
    //   medicines: '',
    //   diagnosis: '',
    //   menstrual_history: '',
    //   obstetric_history: '',
    //   central_nervous_system: '',
    //   cardiovascular_system: '',
    //   respiratory_system: '',
    //   per_abdomen: '',
    //   family_history: { father: '', mother: '', other: '' },
    //   past_history: '',
    //   others: {
    //     nail: '',
    //     mentals: '',
    //     stool: '',
    //     urine: '',
    //     sleep: '',
    //     parsp: '',
    //     corn: '',
    //     mole: '',
    //     hair: '',
    //     spine: '',
    //     pallor: '',
    //     cyanosis: '',
    //     clubbing: '',
    //     icterus: '',
    //     thirst: '',
    //     craving: '',
    //     aversion: '',
    //     dreams: '',
    //     thermals: '',
    //     warts: '',
    //     lm: '',
    //     tongue: '',
    //   },
    //   personal_dues: 0,
    //   card_dues: 0,
    // };
  }

  loadQueue() {
    const clinicId = sessionStorage.getItem('clinic_id') || '1';
    const doctorId = sessionStorage.getItem('doctor_id') || '1';

    // ✅ Check if clinic or doctor not selected
    if (!clinicId || !doctorId) {
      this.toaster.warn('Select the clinic and doctor', 'Missing Selection');
      // return; // stop execution
    }

    const date = this.selectedDate || todayDateString();

    this.appointmentService.getQueue({
      clinic_id: clinicId,
      doctor_id: doctorId,
      date: date,
      // date: "2025-09-12",
      slot: this.getQueueSlotMinutes()
    }).subscribe((res: any) => {
      if (res.success) {
        const appointments = res.data.slots.flatMap((slot: any) =>
          slot.appointments.map((appt: any) => ({
            appointment_id: appt.id,
            patient_id: appt.patient_id,
            clinic_id: appt.clinic_id,
            doctor_id: appt.doctor_id,
            time: appt.start_time,
            status: appt.status,
            checked_in_at: appt.checked_in_at,
            medicine_collection: appt.medicine_collection,
            delivery_type: appt.delivery_type ?? (appt.is_courier ? 'home_delivery' : null),
            is_courier: appt.is_courier,
            appointment_notes: appt.notes || '',
            appointment_note: appt.appointment_note || '',
            medicine_intent: appt.medicine_intent ?? null,
          }))
        );

        // Collect all patient IDs
        const patientIds = appointments.map((a: any) => a.patient_id);

        // Fetch all patient data in one request
        this.patientRegistrationService.getPatientsBatch(patientIds)
          .subscribe((patientRes: any) => {
            if (patientRes.success) {
              const patientsMap = new Map();
              patientRes.data.forEach((p: any) => patientsMap.set(p.id, p));

              // Map appointments to patients
              this.queue = appointments.map((appt: any) => {
                const patient = patientsMap.get(appt.patient_id);
                return {
                  name: `${patient.salutation && patient.salutation !== 'null' ? patient.salutation + ' ' : ''}${patient.full_name}`.trim(),
                  full_name: patient.full_name,
                  patient_id: appt.patient_id,
                  time: appt.time,
                  status: appt.status,
                  checked_in_at: appt.checked_in_at,
                  medicine_collection: appt.medicine_collection,
                  delivery_type: appt.delivery_type ?? (appt.is_courier ? 'home_delivery' : null),
            is_courier: appt.is_courier,
                  contact_number: patient.contact_number,
                  salutation: patient.salutation,
                  is_free: patient.is_free,
                  card_id: patient.card_id,
                  age: patient.age,
                  age_months: patient.age_months,
                  age_days: patient.age_days,
                  appointment_id: appt.appointment_id,
                  clinic_id: appt.clinic_id,
                  doctor_id: appt.doctor_id,
                  appointment_notes: appt.appointment_notes || '',
                  appointment_note: appt.appointment_note || '',
                  medicine_intent: appt.medicine_intent ?? null,
                  referred_by: patient.referred_by,
                  referred_by_dr: patient.referred_by_dr,
                  occupation: patient.occupation,
                  personal_dues: Number(patient.personal_dues ?? 0) || 0,
                };
              });

              // Sort by time once
              this.queue.sort((a, b) => a.time.localeCompare(b.time));
              // console.log('Loaded queue:', this.queue);
            }
          });
      }
    });
  }

  /**
   * Poll a per-clinic summary of this doctor's active patients. Fires a toast
   * when new patients appear (so the doctor is alerted even when reception
   * queues someone at a different clinic) and keeps `queueAlerts` populated for
   * the persistent visual clue + one-click clinic switch.
   */
  loadQueueSummary() {
    const doctorId =
      this.workContext.getDoctorIdString() || sessionStorage.getItem('doctor_id') || '';

    if (!doctorId) {
      return;
    }

    const date = this.selectedDate || todayDateString();

    this.appointmentService
      .getDoctorQueueSummary({ doctor_id: doctorId, date })
      .subscribe((res: any) => {
        if (!res?.success) {
          return;
        }

        const clinics: any[] = res.data?.clinics || [];
        const currentClinicId = Number(
          this.workContext.getClinicId() ?? sessionStorage.getItem('clinic_id')
        );

        const currentCounts = new Map<number, number>();
        clinics.forEach((c) => currentCounts.set(Number(c.clinic_id), Number(c.total_active)));

        // Skip the very first run so we don't alert for patients already there
        // when the screen was opened.
        if (this.queueSummaryBaseline) {
          clinics.forEach((c) => {
            const cid = Number(c.clinic_id);
            const prev = this.queueSummaryBaseline!.get(cid) ?? 0;
            const added = Number(c.total_active) - prev;

            if (added <= 0) {
              return;
            }

            if (cid === currentClinicId) {
              this.toaster.add({
                severity: 'info',
                summary: 'New patient in queue',
                detail: `${added} patient(s) just added to your queue.`,
                life: 6000,
              });
            } else {
              this.toaster.add({
                severity: 'warn',
                summary: 'Patient waiting at another clinic',
                detail: `${c.waiting || added} patient(s) waiting at ${c.clinic_name}. Tap to switch.`,
                life: 9000,
              });
            }
          });
        }

        this.queueSummaryBaseline = currentCounts;

        // Persistent clue: clinics other than the one currently open that have
        // patients waiting (checked in) for this doctor.
        this.queueAlerts = clinics
          .filter((c) => Number(c.clinic_id) !== currentClinicId && Number(c.waiting) > 0)
          .map((c) => ({
            clinic_id: Number(c.clinic_id),
            clinic_name: c.clinic_name,
            waiting: Number(c.waiting),
            total_active: Number(c.total_active),
          }));

        this.cdr.markForCheck();
      });
  }

  /** Switch the working context to another clinic that has patients waiting. */
  switchToAlertClinic(alert: { clinic_id: number; clinic_name: string }) {
    const doctorId = Number(
      this.workContext.getDoctorId() ?? sessionStorage.getItem('doctor_id')
    );

    this.workContext.ensureOptionsLoaded().subscribe(() => {
      // Remember the doctor's original clinic so we can restore after the
      // prescription is completed (same pattern as calendar consultations).
      this.workContext.setContextForConsultation(alert.clinic_id, doctorId);
      this.clinicId = alert.clinic_id;
      // Reset baseline so switching doesn't immediately re-alert.
      this.queueSummaryBaseline = null;
      this.loadQueue();
      this.loadQueueSummary();

      this.toaster.add({
        severity: 'success',
        summary: 'Clinic switched',
        detail: `Now showing the queue for ${alert.clinic_name}. Your original clinic will be restored after you save.`,
        life: 5000,
      });
    });
  }

  /** Restore clinic/doctor context after a temporary switch (queue alert, calendar). */
  private restoreWorkContextAfterConsultation(): void {
    const previousClinicName = sessionStorage.getItem('previous_clinic_name') || '';
    const restored = this.workContext.restorePreviousContext();

    if (!restored) {
      return;
    }

    const ctx = this.workContext.getContext();
    this.clinicId = ctx.clinicId ?? 0;
    this.queueSummaryBaseline = null;
    this.loadQueue();
    this.loadQueueSummary();

    if (previousClinicName) {
      this.toaster.add({
        severity: 'info',
        summary: 'Clinic restored',
        detail: `Working context switched back to ${previousClinicName}.`,
        life: 4000,
      });
    }
  }

  // loadQueue() {
  //   const date = this.selectedDate || new Date().toISOString().slice(0, 10);

  //   this.appointmentService.getQueue({clinic_id: 1, doctor_id: 1, date: "2025-09-12", slot: 60}).subscribe((res:any) => {
  //     if(res.success) {
  //       // this.queue = res.data.slots.flatMap((slot: any) => 
  //       //   slot.appointments.map((appt: any) => {
  //       //     const prescription = appt.patient.prescriptions[0]; // might be undefined
  //       //     return {
  //       //       name: appt.patient.salutation + ' ' + appt.patient.full_name,
  //       //       full_name: appt.patient.full_name,
  //       //       time: appt.start_time,
  //       //       status: appt.status,
  //       //       contact_number: appt.patient.contact_number,
  //       //       salutation: appt.patient.salutation,
  //       //       is_free: appt.patient.is_free,
  //       //       card_id: appt.patient.card_id,
  //       //       age: appt.patient.age,
  //       //       appointment_id: appt.id,
  //       //       clinic_id: appt.clinic_id,
  //       //       doctor_id: appt.doctor_id,
  //       //       summary: prescription?.summary || '',
  //       //       chief_complaints: prescription?.chief_complaints || '',
  //       //       medicines: prescription?.medicines || '',
  //       //       diagnosis: prescription?.diagnosis || '',

  //       //       referred_by: appt.patient.referred_by,
  //       //       referred_by_dr: appt.patient.referred_by_dr,
  //       //       occupation: appt.patient.occupation
  //       //     };
  //       //   })
  //       // );

  //       const appointments = res.data.slots.flatMap((slot: any) =>
  //         slot.appointments.map((appt: any) => ({
  //           appointment_id: appt.id,
  //           patient_id: appt.patient_id,
  //           clinic_id: appt.clinic_id,
  //           doctor_id: appt.doctor_id,
  //           time: appt.start_time,
  //           status: appt.status
  //         }))
  //       );

  //       // Clear queue befoer filling.
  //       this.queue = [];

  //       // Fetch patient data for each appointment
  //       appointments.forEach((appt: any) => {
  //         this.patientRegistrationService.getSinglePatient(appt.patient_id).subscribe((patientRes: any) => {
  //           if (patientRes.success) {
  //             const patient = patientRes.data;

  //             this.queue.push({
  //               name: `${patient.salutation} ${patient.full_name}`,
  //               full_name: patient.full_name,
  //               time: appt.time,
  //               status: appt.status,
  //               contact_number: patient.contact_number,
  //               salutation: patient.salutation,
  //               is_free: patient.is_free,
  //               card_id: patient.card_id,
  //               age: patient.age,
  //               appointment_id: appt.appointment_id,
  //               clinic_id: appt.clinic_id,
  //               doctor_id: appt.doctor_id,
  //               referred_by: patient.referred_by,
  //               referred_by_dr: patient.referred_by_dr,
  //               occupation: patient.occupation
  //             });

  //             this.queue.sort((a: any, b: any) => a.time.localeCompare(b.time));
  //           }
  //         });
  //       });

  //       }
  //     });
  //     console.log('Loaded queue:', this.queue);
  // }

  // selectPatient(item: any) {
  //   this.appointmentService.changeStatus(item.appointment_id, 'in progress').subscribe({
  //     next: (res:any) => {
  //       if(res.success) {
  //         this.loadQueue(); // Refresh the queue to reflect status change
  //       };
  //     },
  //     error: (err) => {
  //       console.error('Error changing status:', err);
  //     }
  //   });

  //   this.patientRegistrationService.getCards().subscribe({
  //     next: (res: any) => {
  //       console.log('Card API response:', res);
  //       this.cardList = Array.isArray(res.data)
  //         ? res.data.map((card:any) => ({
  //             label: card.number,
  //             value: card.id
  //           }))
  //         : [];
  //     }
  //   });

  //   this.isPatientVisible = false;

  //   // populate the patient form fields
  //   // this.patient.card_no      = item.card_no || '';
  //   this.patient.full_name = item.full_name || '';
  //   this.patient.card_id = item.card_id || '';
  //   this.patient.salutation = item.salutation || '';
  //   this.patient.contact_number       = item.contact_number || '';
  //   this.patient.age     = item.age || '';
  //   this.patient.status1      = item.status || 'Checkup';
  //   this.patient.is_free      = item.is_free || false;
  //   this.patient.occupation = item.occupation || '';
  //   this.patient.referred_by = item.referred_by || '';
  //   this.patient.referred_by_dr = item.referred_by_dr || '';

  //   this.clinicId = item.clinic_id || 0;
  //   this.doctorId = item.doctor_id || 0;

  //   this.prescription.appointment_id     = item.appointment_id || '';
  //   this.prescription.summary = item.summary || '',
  //   this.prescription.chief_complaints = item.chief_complaints || '',
  //   this.prescription.medicines = item.medicines || '',
  //   this.prescription.diagnosis = item.diagnosis || ''
  // }
  recallFromMedicineQueue(item: any, event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.isMedicineVisible = false;
    this.selectPatient(item);
    this.loadAllMedicineQueue();
  }

  selectPatient(item: any) {
    this.requestPatientSwitch(item, (loadGen) => this.applySelectPatient(item, loadGen));
  }

  private applySelectPatient(
    item: any,
    existingLoadGen?: number,
    options?: { rejectIfPrescribed?: boolean },
  ) {
    if (existingLoadGen && !this.isPatientLoadCurrent(existingLoadGen)) {
      return;
    }

    const loadGen = existingLoadGen ?? this.beginPatientLoad();
    const queuedStatus = (this.queue || []).find(
      (row: any) => Number(row.appointment_id) === Number(item?.appointment_id),
    )?.status;
    const knownStatus = String(item?.status || queuedStatus || '');
    const patientId = Number(item?.patient_id) || 0;

    if (
      options?.rejectIfPrescribed &&
      knownStatus &&
      this.prescribedAppointmentStatuses.includes(knownStatus)
    ) {
      this.switchingPatientId = 0;
      this.handleAlreadyPrescribedPatient(patientId, { removeFromDock: true });
      return;
    }

    this.detailsReadyForGen = 0;
    this.historyAppliedForGen = 0;
    this.historyReadyForGen = null;
    this.parkedDraftBuffer = null;
    this.switchFlowSource = null;
    this.sideLoadsGen = 0;
    this.loadedCardMembersCardId = 0;
    this.switchPatientId = patientId;

    // Status is already known from the queue, so open immediately.
    // Otherwise wait for this one appointment before changing status or clearing the chart.
    const mustConfirm = !!options?.rejectIfPrescribed;
    if (!mustConfirm) {
      this.commitOpenPatient(item, loadGen);
    }

    this.appointmentService.getAppointmentDetails(item.appointment_id).subscribe({
      next: (res: any) => {
        if (!this.isPatientLoadCurrent(loadGen)) {
          return;
        }

        if (!res?.success || !res.data?.patient) {
          this.switchingPatientId = 0;
          if (!mustConfirm) {
            this.draftRestorePending = false;
          }
          return;
        }

        const appt = res.data;
        const patient = appt.patient;
        const resolvedPatientId = Number(patient.id || item.patient_id || 0);

        if (
          options?.rejectIfPrescribed &&
          this.prescribedAppointmentStatuses.includes(appt.status)
        ) {
          this.switchingPatientId = 0;
          this.pendingInProgressAppointmentId = 0;
          this.handleAlreadyPrescribedPatient(resolvedPatientId, { removeFromDock: true });
          return;
        }

        if (mustConfirm) {
          this.commitOpenPatient(
            {
              ...item,
              patient_id: resolvedPatientId,
              status: appt.status,
              appointment_notes: appt.notes ?? item?.appointment_notes,
              medicine_intent: appt.medicine_intent ?? item?.medicine_intent,
            },
            loadGen,
          );
        }
        
        let prescription: any = {};
        if (patient.prescriptions && Array.isArray(patient.prescriptions) && patient.prescriptions.length > 0) {
          // Only use a prescription that belongs to THIS appointment.
          // Falling back to prescriptions[0] reused the first visit (incl. 1100 fees + wrong id).
          prescription =
            patient.prescriptions.find((p: any) => Number(p.appointment_id) === Number(appt.id)) || {};
        } else if (patient.prescriptions && !Array.isArray(patient.prescriptions)) {
          const single = patient.prescriptions;
          prescription =
            Number(single?.appointment_id) === Number(appt.id) ? single : {};
        }

        const fullPatientNumber = patient.patient_number || '';
        const trimmedPatientNumber = fullPatientNumber.split('-')[0];

        const demographics = this.normalizePatientName(patient.full_name || '', patient.salutation);

        // Patient form
        this.patient = {
          patient_id: patient.id,
          full_name: demographics.full_name,
          salutation: demographics.salutation,
          card_id: patient.card_id || '',
          contact_number: patient.contact_number || '',
          card_number: trimmedPatientNumber,
          patient_number: fullPatientNumber,
          age: patient.age ?? 0,
          age_months: patient.age_months ?? 0,
          age_days: patient.age_days ?? 0,
          status1: appt.status || 'Checkup',
          medicine_collection: appt.medicine_collection,
          is_free: patient.is_free || false,
          visit_fees: patient.visit_fees != null ? Number(patient.visit_fees) : null,
          occupation: patient.occupation || '',
          referred_by: patient.referred_by || '',
          referred_by_dr: patient.referred_by_dr || '',
          under_dr: patient.under_dr || '',
          important_notes: patient.important_notes || '',
        };
        this.onPatientContextChanged();
        const nextCardId = Number(patient.card_id) || 0;
        if (nextCardId !== this.loadedCardMembersCardId || !nextCardId) {
          this.loadedCardMembersCardId = nextCardId;
          this.loadCardMembers(patient.card_id);
        }
        this.syncDeskChatPatient();

        this.appointmentIntakeNote = String(appt.notes || item.appointment_notes || '').trim();
        this.appointmentMedicineIntent = appt.medicine_intent ?? item.medicine_intent ?? null;
        const appointmentNote = String(appt.appointment_note ?? item.appointment_note ?? '').trim();
        this.pendingReceptionAppointmentNote = appointmentNote;

        const flowSource = {
          ...appt,
          delivery_type: appt.delivery_type ?? item.delivery_type,
          medicine_collection: appt.medicine_collection ?? item.medicine_collection,
          is_courier: appt.is_courier ?? item.is_courier,
        };
        const appointmentFlow = resolveAppointmentFlow(flowSource);

        // Clinic/doctor ids
        this.clinicId = appt.clinic_id || 0;
        this.doctorId = appt.doctor_id || 0;

        // Active prescription form
        this.prescription = {
          id: prescription.id,
          appointment_id: appt.id,
          summary: prescription.summary || '',
          chief_complaints: prescription.chief_complaints || '',
          medicines: prescription.medicines || '',
          diagnosis: prescription.diagnosis || '',
          menstrual_history: prescription.menstrual_history || '',
          central_nervous_system: prescription.central_nervous_system || '',
          cardiovascular_system: prescription.cardiovascular_system || '',
          respiratory_system: prescription.respiratory_system || '',
          per_abdomen: prescription.per_abdomen || '',
          past_history: prescription.past_history || '',
          family_history: prescription.family_history || { father: '', mother: '', other: '' },
          others: prescription.others || {
            nail: '', mentals: '', stool: '', urine: '', sleep: '',
            parsp: '', corn: '', mole: '', hair: '', spine: '',
            pallor: '', cyanosis: '', clubbing: '', icterus: '',
            thirst: '', craving: '', aversion: '', dreams: '',
            thermals: '', warts: '', lm: '', tongue: ''
          },
          personal_dues: prescription.personal_dues || 0,
          visit_fees: this.resolveVisitFees(patient, prescription),
          discount_percent: normalizeDiscountPercent(prescription.discount_percent),
          received_cash: prescription.received_cash || 0,
          received_online: prescription.received_online || 0,
          card_dues: prescription.card_dues || 0,
          payment_status: prescription.payment_status || null,
          notes: this.resolveInitialPrescriptionNotes(prescription.notes, appointmentNote),
          delivery_type: appointmentFlow.deliveryType ?? resolveDeliveryType(prescription),
          is_courier: !!(appointmentFlow.deliveryType ?? resolveDeliveryType(prescription)),
        };
        this.lastAppliedDiscountPercent = normalizeDiscountPercent(
          this.prescription.discount_percent
        );
        this.settledOnlineAmount = Math.round(Number(prescription.received_online) || 0);
        this.recordedCashAmount = Math.max(0, Math.round(Number(prescription.received_cash) || 0));
        this.setVisitFeeBase(Number(this.prescription.visit_fees) || 0);
        this.applyAppointmentFlowFromSource(flowSource);

        this.switchPatientId = resolvedPatientId;
        this.switchFlowSource = flowSource;
        this.detailsReadyForGen = loadGen;
        this.startPatientSideLoads(resolvedPatientId, loadGen);
        this.mergeHistoryIfReady(loadGen);
      },
      error: () => {
        if (this.isPatientLoadCurrent(loadGen)) {
          this.switchingPatientId = 0;
          if (!mustConfirm) {
            this.draftRestorePending = false;
          }
        }
      },
    });
  }

  /** Show the selected name immediately, then fill the chart when the visit returns. */
  private commitOpenPatient(item: any, loadGen: number): void {
    this.clearForm();
    this.draftRestorePending = true;
    this.queueKeyboardIndex = -1;
    this.appointmentIntakeNote = String(item?.appointment_notes || '').trim();
    this.appointmentMedicineIntent = item?.medicine_intent ?? null;

    const patientId = Number(item?.patient_id) || 0;
    this.switchPatientId = patientId;
    if (patientId) {
      this.patient.patient_id = patientId;
    }
    const rawName = String(item?.full_name || item?.name || '').trim();
    if (rawName) {
      const demographics = this.normalizePatientName(rawName, item?.salutation);
      this.patient.full_name = demographics.full_name;
      this.patient.salutation = demographics.salutation;
    }
    if (item?.patient_number) {
      this.patient.patient_number = item.patient_number;
    }
    this.switchingPatientId = 0;

    this.patientSelectedFromSearch = false;
    this.isPatientVisible = false;
    this.markAppointmentInProgress(item?.appointment_id, loadGen);
    const cardId = Number(item?.card_id) || 0;
    if (cardId) {
      this.loadedCardMembersCardId = cardId;
      this.loadCardMembers(cardId);
    }
    if (patientId) {
      this.startPatientSideLoads(patientId, loadGen);
    }
  }

  private markAppointmentInProgress(appointmentId: number, loadGen: number): void {
    const id = Number(appointmentId) || 0;
    if (!id) {
      return;
    }

    this.pendingInProgressAppointmentId = id;
    const queued = (this.queue || []).find(
      (row: any) => Number(row.appointment_id) === id,
    );
    if (queued?.status === 'in progress') {
      return;
    }

    this.appointmentService.changeStatus(id, 'in progress').subscribe({
      next: (res: any) => {
        if (!res?.success) {
          return;
        }
        if (!this.isPatientLoadCurrent(loadGen) && this.pendingInProgressAppointmentId !== id) {
          this.appointmentService.changeStatus(id, 'paused').subscribe({
            next: (pauseRes: any) => {
              if (pauseRes?.success) {
                this.scheduleQueueRefresh();
              }
            },
            error: (err) => console.error('Error pausing appointment:', err),
          });
          return;
        }
        this.scheduleQueueRefresh();
      },
      error: (err) => console.error('Error changing status:', err),
    });
  }

  private scheduleQueueRefresh(): void {
    if (this.queueRefreshTimer) {
      clearTimeout(this.queueRefreshTimer);
    }
    this.queueRefreshTimer = setTimeout(() => {
      this.queueRefreshTimer = null;
      this.loadQueue();
    }, 200);
  }

  /** History, reports, and the parked draft start with the visit fetch instead of after it. */
  private startPatientSideLoads(patientId: number, loadGen: number): void {
    if (!patientId || this.sideLoadsGen === loadGen) {
      return;
    }
    this.sideLoadsGen = loadGen;
    this.loadPatientPayments(patientId);

    this.prescriptionsService.getPrescriptionsByPatientId(patientId).subscribe({
      next: (res: any) => {
        if (!this.isPatientLoadCurrent(loadGen)) {
          return;
        }
        const records = res?.success && Array.isArray(res.data) ? res.data : [];
        this.historyReadyForGen = { gen: loadGen, records };
        this.mergeHistoryIfReady(loadGen);
      },
      error: () => {
        if (!this.isPatientLoadCurrent(loadGen)) {
          return;
        }
        this.historyReadyForGen = { gen: loadGen, records: [] };
        this.mergeHistoryIfReady(loadGen);
      },
    });

    this.prescriptionsService.getReportsByPatientId(patientId).subscribe({
      next: (rRes: any) => {
        if (!this.isPatientLoadCurrent(loadGen)) {
          return;
        }
        this.applyPatientReports(rRes?.success ? rRes.data : []);
      },
      error: () => {
        if (this.isPatientLoadCurrent(loadGen)) {
          this.applyPatientReports([]);
        }
      },
    });

    this.parkedDraftBuffer = { gen: loadGen, serverDraft: null, settled: false };
    this.prescriptionsService.getParkedWork(this.getDraftParkParams(patientId)).subscribe({
      next: (res: any) => {
        if (!this.isPatientLoadCurrent(loadGen)) {
          return;
        }
        this.parkedDraftBuffer = {
          gen: loadGen,
          serverDraft: res?.success ? res.data : null,
          settled: true,
        };
        this.applyBufferedDraft(loadGen);
      },
      error: () => {
        if (!this.isPatientLoadCurrent(loadGen)) {
          return;
        }
        this.parkedDraftBuffer = { gen: loadGen, serverDraft: null, settled: true };
        this.applyBufferedDraft(loadGen);
      },
    });
  }

  private mergeHistoryIfReady(loadGen: number): void {
    const history = this.historyReadyForGen;
    if (!history || history.gen !== loadGen || this.detailsReadyForGen !== loadGen) {
      return;
    }
    if (!this.isPatientLoadCurrent(loadGen) || this.historyAppliedForGen === loadGen) {
      this.applyBufferedDraft(loadGen);
      return;
    }

    this.historyAppliedForGen = loadGen;
    this.filteredRecords = history.records;
    this.resetHistorySheetPage();
    this.selectedIndex = 'today';
    this.syncVisitFeesAfterHistoryLoad();
    this.prescription.personal_dues = this.calculatePersonalDues(
      this.filteredRecords,
      this.prescription,
    );
    this.prescription.card_dues = this.filteredRecords.length
      ? this.filteredRecords[0].card_dues || 0
      : 0;
    this.rememberRecordedPayment();
    this.useVisitPaymentsIfNeeded();

    if (this.filteredRecords.length) {
      const latestPrescription = this.filteredRecords[0];
      this.prescription.past_history = latestPrescription.past_history || '';
      this.prescription.menstrual_history = latestPrescription.menstrual_history || '';
      this.prescription.family_history = latestPrescription.family_history || {
        father: '',
        mother: '',
        other: '',
      };
      this.prescription.respiratory_system = latestPrescription.respiratory_system || '';
      this.prescription.cardiovascular_system = latestPrescription.cardiovascular_system || '';
      this.prescription.central_nervous_system = latestPrescription.central_nervous_system || '';
      this.prescription.per_abdomen = latestPrescription.per_abdomen || '';
      this.prescription.others = latestPrescription.others || {
        others: {
          nail: '',
          mentals: '',
          stool: '',
          urine: '',
          sleep: '',
          parsp: '',
          corn: '',
          mole: '',
          hair: '',
          spine: '',
          pallor: '',
          cyanosis: '',
          clubbing: '',
          icterus: '',
          thirst: '',
          craving: '',
          aversion: '',
          dreams: '',
          thermals: '',
          warts: '',
          lm: '',
          tongue: '',
        },
      };
    }

    if (this.switchFlowSource) {
      this.applyAppointmentFlowFromSource(this.switchFlowSource);
    }
    this.applyBufferedDraft(loadGen);
  }

  private applyBufferedDraft(loadGen: number): void {
    const parked = this.parkedDraftBuffer;
    if (
      !parked ||
      parked.gen !== loadGen ||
      !parked.settled ||
      this.historyAppliedForGen !== loadGen ||
      this.detailsReadyForGen !== loadGen ||
      !this.isPatientLoadCurrent(loadGen)
    ) {
      return;
    }

    const patientId = this.switchPatientId || this.getCurrentPatientId();
    if (!patientId) {
      this.parkedDraftBuffer = null;
      this.draftRestorePending = false;
      return;
    }

    const localDraft = this.getTodayDraftForPatient(patientId);
    const serverDraft = parked.serverDraft;
    const draft = this.pickNewerDraft(localDraft, serverDraft);
    this.parkedDraftBuffer = null;

    if (
      serverDraft &&
      this.getDraftSavedAtMs(serverDraft) >= this.getDraftSavedAtMs(localDraft)
    ) {
      this.syncLocalDraftFromServer(patientId, serverDraft);
    }

    this.applyResolvedDraftRestore(draft);
  }

  // getColorClass(status: string): string {
  //   switch (status) {
  //     case 'in progress': return 'bg-light-yellow';
  //     case 'completed': return 'bg-light-green';
  //     case 'scheduled': return 'bg-light-blue';
  //     case 'cancelled': return 'bg-light-red';
  //     default: return 'bg-light-yellow';
  //   }
  // }

  getColorClass(status: string): string {
    switch (status) {
      case 'scheduled': return 'status-scheduled';
      case 'checked in': return 'status-checked-in';
      case 'in progress': return 'status-in-progress';
      case 'paused': return 'status-paused';
      case 'completed': return 'status-completed';
      case 'cancelled': return 'status-cancelled';
      case 'medicine': return 'status-medicine';
      default: return '';
    }
  }

  getQueueStatusLabel(status: string): string {
    switch ((status || '').toLowerCase()) {
      case 'checked in':
      case 'scheduled':
        return 'Waiting';
      case 'in progress':
        return 'With doctor';
      case 'paused':
        return 'Paused';
      case 'completed':
      case 'medicine':
        return 'Done';
      case 'cancelled':
        return 'Cancelled';
      default:
        return status || 'Waiting';
    }
  }

  hasKeptBalance(item: any): boolean {
    return (Number(item?.personal_dues ?? 0) || 0) > 0;
  }

  formatKeptBalance(item: any): string {
    const amount = Number(item?.personal_dues ?? 0) || 0;
    return amount.toLocaleString('en-IN');
  }

  // getColorClass(status: string): string {
  //   switch(status) {
  //     case 'in progress': return '#ffc107';
  //     case 'scheduled': return '#0d6efd';
  //     case 'completed': return '#198754';
  //     case 'cancelled': return '#dc3545';
  //     default: return 'transparent';
  //   }
  // }

  getClinic() {
    this.clinicService.getClinic().subscribe({
      next: (res: any) => {
        this.clinicsList = Array.isArray(res.data)
          ? res.data.map((clinic: any) => ({
            label: clinic.name,
            value: clinic.id
          }))
          : [];
      },
      error: (err) => {
        console.error('Clinic API error:', err);
        this.clinicsList = [];
      }
    });
  }

  getDoctors() {
    this.userService.getDoctors().subscribe({
      next: (res: any) => {
        this.doctorsList = Array.isArray(res.data)
          ? res.data.map((doctor: any) => ({
            label: doctor.name,
            value: doctor.id
          }))
          : [];
      },
      error: (err) => {
        console.error('Doctor API error:', err);
        this.doctorsList = [];
      }
    });
  }

  // onFileUpload(event: any) {
  //   const files = event.target.files;
  //   const today = new Date();

  //   let group = this.uploadsByDate.find(
  //     g => g.date.toDateString() === today.toDateString()
  //   );

  //   if (!group) {
  //     group = { date: today, files: [] };
  //     this.uploadsByDate.unshift(group); // latest date always at top
  //   }

  //   for (let file of files) {
  //     const fileObj = {
  //       name: file.name,
  //       type: file.type,
  //       url: URL.createObjectURL(file)
  //     };
  //     group.files.push(fileObj);
  //   }
  // }

  // onFileUpload(event: any) {
  //   this.pendingFiles = Array.from(event.target.files);
  // }

  imagePreviews: any[] = [];
  onFileUpload(event: any) {
    this.pendingFiles = Array.from(event.target.files);

    // Clear previous previews
    this.imagePreviews = [];

    // Generate previews for the selected files
    this.pendingFiles.forEach((file: File) => {
      // Check if it's an image
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();

        reader.onload = (e: any) => {
          this.imagePreviews.push({
            type: 'image',
            url: e.target.result,
            name: file.name
          });
        };

        reader.readAsDataURL(file);
      } else {
        // For non-image files, just store the name
        this.imagePreviews.push({
          type: 'document',
          url: null,
          name: file.name
        });
      }
    });
  }

  // Merge new reports into gallery
  private mergeReports(newReports: any[]) {
    newReports.forEach(r => {
      const date = r.uploaded_at.split(' ')[0];
      let group = this.uploadsByDate.find(g => g.date === date);
      if (!group) {
        group = { date, files: [] };
        this.uploadsByDate.push(group);
      }
      group.files.push(r);
    });
    this.rebuildReportRows();
  }

  // openFile(file: any) {
  //   window.open(file.url, "_blank"); // opens in new tab
  // }

  /** Create a walk-in appointment and load the full consultation form for a new patient. */
  startConsultationForNewPatient(patient: any) {
    const now = new Date();
    const clinicId = Number(this.workContext.getClinicId() ?? sessionStorage.getItem('clinic_id')) || 0;
    const doctorId = Number(this.workContext.getDoctorId() ?? sessionStorage.getItem('doctor_id')) || 0;
    const patientId = patient.id || patient.patient_id;

    if (!clinicId || !doctorId || !patientId) {
      this.toaster.warn('Select clinic and doctor in the work context bar first.', 'Cannot start consultation');
      this.onPatientSelect({ value: patient });
      return;
    }

    const { start_time, end_time } = buildHourlyAppointmentWindow(now);
    const appointmentPayload = {
      clinic_id: clinicId,
      doctor_id: doctorId,
      patient_id: patientId,
      appointment_date: todayDateString(),
      start_time,
      end_time,
      status: 'in progress',
      delivery_type: this.appointmentDeliveryType,
      is_courier: !!this.appointmentDeliveryType,
      type: 'on_flow',
    };

    this.appointmentService.addAppointment(appointmentPayload).subscribe({
      next: (res: any) => {
        const appt = res?.data;
        if (!appt?.id) {
          this.toaster.error('Patient saved but appointment could not be created.');
          this.onPatientSelect({ value: patient });
          return;
        }

        this.toaster.success('Patient is ready for consultation.', 'Consultation started');

        // Must include patient_id — requestPatientSwitch ignores selections without it.
        this.selectPatient(this.buildQueueSelectionFromAppointment(appt, patient));
      },
      error: () => {
        this.toaster.error('Patient saved but consultation could not be started.');
        this.onPatientSelect({ value: patient });
      },
    });
  }

  createOnFlowAppointment(event: any) {
    this.startConsultationForNewPatient(event.value);
  }

  saveAppointmentAndPrescription() {
    if (this.rejectExcessPayment()) {
      return;
    }
    const patientValidationError = this.getPatientSaveValidationError();
    if (patientValidationError) {
      this.draftSaveSuppressed = false;
      this.toaster.error(patientValidationError);
      return;
    }

    const savedPatientId = this.getCurrentPatientId();
    this.draftSaveSuppressed = true;
    this.updatePatientDetailsBeforeSave({
      onSuccess: () => {
        this.createAppointmentAndPrescription(savedPatientId);
      },
      onError: () => { this.draftSaveSuppressed = false; },
    });
  }

  private createAppointmentAndPrescription(savedPatientId: number) {
    const now = new Date();
    const appointmentDate = todayDateString();
    const { start_time: startTime, end_time: endTime } = buildHourlyAppointmentWindow(now);

    const clinicId = sessionStorage.getItem('clinic_id');
    const doctorId = sessionStorage.getItem('doctor_id');

    // Appointment payload
    const appointmentPayload = {
      clinic_id: Number(clinicId) || 1,
      doctor_id: Number(doctorId) || 1,
      // clinic_id: this.clinicId,
      // doctor_id: this.doctorId,
      patient_id: this.patient.patient_id,
      appointment_date: appointmentDate,
      start_time: startTime,
      end_time: endTime,
      status: 'medicine',
      medicine_collection: this.isMedicineCollection,
      delivery_type: this.appointmentDeliveryType,
      is_courier: !!this.appointmentDeliveryType,
      type: 'on_flow',
    };

    this.appointmentService.addAppointment(appointmentPayload).subscribe({
      next: (res: any) => {
        if (res.success) {
          const appt = res.data;

          // Now create prescription linked to this appointment
          this.syncDeliveryFlags();
          const prescriptionPayload = {
            appointment_id: appt.id,
            summary: this.prescription.summary,
            chief_complaints: this.prescription.chief_complaints,
            medicines: this.prescription.medicines,
            diagnosis: this.prescription.diagnosis,
            menstrual_history: this.prescription.menstrual_history,
            central_nervous_system: this.prescription.central_nervous_system,
            cardiovascular_system: this.prescription.cardiovascular_system,
            respiratory_system: this.prescription.respiratory_system,
            per_abdomen: this.prescription.per_abdomen,
            past_history: this.prescription.past_history,
            family_history: this.prescription.family_history,
            others: this.prescription.others,
            personal_dues: this.prescription.personal_dues,
            visit_fees: this.prescription.visit_fees,
            discount_percent: normalizeDiscountPercent(this.prescription.discount_percent),
            received_cash: this.prescription.received_cash,
            received_online: this.prescription.received_online,
            notes: this.prescription.notes,
            delivery_type: this.appointmentDeliveryType,
      is_courier: !!this.appointmentDeliveryType,
          };

          this.prescriptionsService.addPrescriptions(prescriptionPayload).subscribe((presRes: any) => {
            if (presRes.success) {
              const prescription = presRes.data;

              this.completeSavedConsultation(savedPatientId);

              // ✅ Upload reports if there are any files waiting
              if (this.pendingFiles && this.pendingFiles.length > 0) {
                const formData = new FormData();
                formData.append('patient_id', this.patient.patient_id.toString());
                formData.append('prescription_id', prescription.id.toString());
                this.pendingFiles.forEach((file: File) => {
                  formData.append('files[]', file, file.name);
                });

                this.prescriptionsService.uploadReports(formData).subscribe({
                  next: (uploadRes: any) => {
                    if (uploadRes.success) {
                      // Keep gallery cleared after submit; uploaded files remain on backend.
                      this.resetSelectedFiles();
                    }
                  },
                  error: (err) => console.error('Report upload failed:', err)
                });
              }

              this.toaster.success('Appointment & Prescription saved successfully');

              this.restoreWorkContextAfterConsultation();
              this.invalidatePatientLoad();
              this.clearForm();
              this.tryResumePendingConsultationAfterSave();
            } else {
              this.draftSaveSuppressed = false;
            }
          });

          // this.clearForm();
        }
      },
      error: (err) => {
        this.draftSaveSuppressed = false;
        console.error('Save error:', err);
        const message =
          err?.error?.message
          || err?.error?.errors?.start_time?.[0]
          || '';
        if (this.isDoubleBookingError(message)) {
          this.toaster.error(
            message || 'This patient already has an open appointment in this time slot.',
          );
          return;
        }
        this.toaster.error('Failed to save appointment and prescription');
      }
    });
  }

  private normalizePatientName(
    fullName: string,
    salutation?: string | null
  ): { salutation: string; full_name: string } {
    const knownSalutation = (salutation || '').trim();
    let name = (fullName || '').trim();

    if (knownSalutation) {
      const prefix = `${knownSalutation} `;
      if (name.startsWith(prefix)) {
        name = name.slice(prefix.length).trim();
      }
      return { salutation: knownSalutation, full_name: name };
    }

    for (const prefixSalutation of this.patientSalutations) {
      const prefix = `${prefixSalutation} `;
      if (name.startsWith(prefix)) {
        return {
          salutation: prefixSalutation,
          full_name: name.slice(prefix.length).trim(),
        };
      }
    }

    return { salutation: '', full_name: name };
  }

  private applyPatientDemographics(source: any): void {
    const demographics = this.normalizePatientName(source?.full_name || '', source?.salutation);
    this.patient.salutation = demographics.salutation;
    this.patient.full_name = demographics.full_name;
    this.patient.contact_number = source?.contact_number || '';
    const ageParts = readPatientAge(source);
    this.patient.age = ageParts.years ?? 0;
    this.patient.age_months = ageParts.months ?? 0;
    this.patient.age_days = ageParts.days ?? 0;
    this.patient.visit_fees = source?.visit_fees != null ? Number(source.visit_fees) : null;
    this.patient.important_notes = source?.important_notes || '';
  }

  private resolveVisitFees(patientData?: any, prescriptionData?: any): number {
    const currentAppointmentId = Number(
      prescriptionData?.appointment_id ?? this.prescription?.appointment_id ?? 0,
    );
    const prescriptionId = Number(prescriptionData?.id || 0);
    const prescriptionAppointmentId = Number(prescriptionData?.appointment_id || 0);

    const belongsToCurrentVisit =
      prescriptionId > 0 &&
      (currentAppointmentId <= 0 ||
        prescriptionAppointmentId <= 0 ||
        prescriptionAppointmentId === currentAppointmentId);

    if (
      belongsToCurrentVisit &&
      prescriptionData?.visit_fees != null &&
      prescriptionData.visit_fees !== ''
    ) {
      const rxFees = Number(prescriptionData.visit_fees);
      if (Number.isFinite(rxFees)) {
        return rxFees;
      }
    }

    const isNewPatient = !this.hasPriorVisitPrescriptions(currentAppointmentId, prescriptionId);

    return resolveDefaultVisitFees({
      isFree: patientData?.is_free ?? this.patient?.is_free,
      isNewPatient,
      // Only first visits may use the registration fee (usually 1100).
      storedVisitFees: isNewPatient
        ? (patientData?.visit_fees ?? this.patient?.visit_fees)
        : null,
    });
  }

  /** True when the patient already has a saved prescription from an earlier visit. */
  private hasPriorVisitPrescriptions(
    currentAppointmentId = 0,
    currentPrescriptionId = 0,
  ): boolean {
    return (this.filteredRecords || []).some((record: any) => {
      const id = Number(record?.id || 0);
      if (id <= 0) {
        return false;
      }
      if (currentPrescriptionId > 0 && id === currentPrescriptionId) {
        return false;
      }
      const appointmentId = Number(record?.appointment_id || 0);
      if (currentAppointmentId > 0 && appointmentId === currentAppointmentId) {
        return false;
      }
      return true;
    });
  }

  /**
   * After history loads, set 1000 for return visits (and keep saved fees for the current Rx).
   */
  private syncVisitFeesAfterHistoryLoad(): void {
    const appointmentId = Number(this.prescription?.appointment_id || 0);
    const prescriptionId = Number(this.prescription?.id || 0);

    const savedForThisVisit = (this.filteredRecords || []).find((record: any) => {
      const id = Number(record?.id || 0);
      if (id <= 0) {
        return false;
      }
      if (prescriptionId > 0 && id === prescriptionId) {
        return true;
      }
      return appointmentId > 0 && Number(record?.appointment_id) === appointmentId;
    });

    if (savedForThisVisit && Number(savedForThisVisit.id) > 0) {
      this.prescription.id = Number(savedForThisVisit.id);
      const discount = normalizeDiscountPercent(savedForThisVisit.discount_percent);
      this.prescription.discount_percent = discount;

      if (savedForThisVisit.visit_fees != null && savedForThisVisit.visit_fees !== '') {
        const savedFee = Number(savedForThisVisit.visit_fees);
        this.prescription.visit_fees = savedFee;
        // Recover the pre-discount base so later % edits stay consistent.
        if (discount > 0 && discount < 100 && savedFee > 0) {
          this.setVisitFeeBase(Math.round((savedFee * 100) / (100 - discount)));
        } else if (discount >= 100) {
          this.setVisitFeeBase(this.resolveStandardVisitFeeBase());
        } else {
          this.setVisitFeeBase(savedFee);
        }
      } else {
        this.setVisitFeeBase(this.resolveStandardVisitFeeBase());
        this.applyDiscountToVisitFees({ recalculateDues: false });
      }
      this.lastAppliedDiscountPercent = discount;
      return;
    }

    // Brand-new consultation for this appointment → resolve 1100 vs 1000 from history.
    this.prescription.discount_percent = normalizeDiscountPercent(
      this.prescription.discount_percent
    );
    this.setVisitFeeBase(this.resolveStandardVisitFeeBase());
    this.applyDiscountToVisitFees({ recalculateDues: false });
    this.lastAppliedDiscountPercent = normalizeDiscountPercent(
      this.prescription.discount_percent
    );
  }

  /** Standard 1100/1000 fee from visit history (ignores on-screen discount). */
  private resolveStandardVisitFeeBase(): number {
    if (this.patient?.is_free) {
      return 0;
    }

    const appointmentId = Number(this.prescription?.appointment_id || 0);
    const prescriptionId = Number(this.prescription?.id || 0);
    const isNewPatient = !this.hasPriorVisitPrescriptions(appointmentId, prescriptionId);

    return resolveDefaultVisitFees({
      isFree: false,
      isNewPatient,
      // Never reuse a leftover registration 1100 for return visits.
      storedVisitFees: isNewPatient ? (this.patient?.visit_fees ?? null) : null,
    });
  }

  private setVisitFeeBase(amount: number): void {
    const value = Number(amount);
    this.visitFeeBaseAmount = Number.isFinite(value) ? Math.max(0, Math.round(value)) : 0;
  }

  /** Pre-discount fee locked for this form; discount is always applied on top of this. */
  getVisitFeeBase(): number {
    if (this.patient?.is_free) {
      return 0;
    }
    return this.visitFeeBaseAmount;
  }

  /** Recompute visit_fees from base × discount%; 100% discount → free this visit. */
  applyDiscountToVisitFees(options?: { recalculateDues?: boolean }): void {
    const discount = normalizeDiscountPercent(this.prescription.discount_percent);
    this.prescription.discount_percent = discount;

    if (this.patient?.is_free) {
      this.prescription.visit_fees = 0;
      this.prescription.discount_percent = 0;
      this.lastAppliedDiscountPercent = 0;
    } else {
      this.prescription.visit_fees = applyVisitDiscount(this.getVisitFeeBase(), discount);
      this.lastAppliedDiscountPercent = discount;
    }

    if (options?.recalculateDues !== false) {
      this.prescription.personal_dues = this.calculatePersonalDues(
        this.filteredRecords,
        this.prescription
      );
    }
  }

  onBannerDiscountChange(): void {
    const newDiscount = normalizeDiscountPercent(this.prescription.discount_percent);

    // When discount starts from 0, lock base to the fee currently shown (e.g. 1000),
    // not patient.visit_fees (often leftover registration 1100).
    if (this.lastAppliedDiscountPercent === 0 && newDiscount > 0) {
      const shownFee = Number(this.prescription.visit_fees);
      if (Number.isFinite(shownFee) && shownFee >= 0) {
        this.setVisitFeeBase(shownFee);
      } else {
        this.setVisitFeeBase(this.resolveStandardVisitFeeBase());
      }
    }

    this.prescription.discount_percent = newDiscount;
    this.applyDiscountToVisitFees();
  }

  /** Drop stale first-visit 1100 drafts once the patient already has prior visits. */
  private normalizeDraftVisitFees(drafted: number): number {
    if (!Number.isFinite(drafted)) {
      return this.resolveVisitFees(this.patient);
    }

    const resolved = this.resolveVisitFees(this.patient);
    if (drafted === NEW_PATIENT_VISIT_FEES && resolved === REGULAR_PATIENT_VISIT_FEES) {
      return resolved;
    }

    return drafted;
  }

  onBannerVisitFeesChange(): void {
    // Manual fee override clears discount so we don't fight the typed amount.
    this.prescription.discount_percent = 0;
    this.lastAppliedDiscountPercent = 0;
    const fees = this.patient?.is_free ? 0 : Number(this.prescription.visit_fees) || 0;
    this.prescription.visit_fees = fees;
    this.setVisitFeeBase(fees);
    this.patient.visit_fees = fees;
    this.prescription.personal_dues = this.calculatePersonalDues(
      this.filteredRecords,
      this.prescription
    );
  }

  private getPatientSaveValidationError(): string | null {
    if (!(this.patient.full_name || '').trim()) {
      return 'Patient name is required.';
    }

    if (!hasValidPatientAge(
      {
        years: this.patient.age,
        months: this.patient.age_months,
        days: this.patient.age_days,
      },
      this.maxPatientAge,
    )) {
      return 'Please enter a valid age.';
    }

    if (!this.patient.patient_number) {
      return 'Patient number is missing. Reload the patient and try again.';
    }

    return null;
  }

  private buildPatientUpdatePayload(): any {
    const clinicId = Number(this.workContext.getClinicId() ?? sessionStorage.getItem('clinic_id')) || this.clinicId;
    const payload: any = {
      id: this.getCurrentPatientId(),
      clinic_id: clinicId,
      full_name: (this.patient.full_name || '').trim(),
      ...patientAgeToPayload({
        years: this.patient.age,
        months: this.patient.age_months,
        days: this.patient.age_days,
      }),
      patient_number: this.patient.patient_number,
      contact_number: this.patient.contact_number || null,
      referred_by: this.patient.referred_by || null,
      referred_by_dr: this.patient.referred_by_dr || null,
      under_dr: this.patient.under_dr || null,
      occupation: this.patient.occupation || null,
      important_notes: (this.patient.important_notes || '').trim() || null,
      is_free: !!this.patient.is_free,
      // Persist the standard/base fee on the patient — not a discounted visit fee.
      visit_fees: this.patient.is_free
        ? 0
        : (normalizeDiscountPercent(this.prescription.discount_percent) > 0
          ? this.getVisitFeeBase()
          : Number(this.prescription.visit_fees) || 0),
    };

    if (this.patient.salutation) {
      payload.salutation = this.patient.salutation;
    }

    if (this.patient.card_id) {
      payload.card_id = this.patient.card_id;
    }

    return payload;
  }

  private updatePatientDetailsBeforeSave(handlers: { onSuccess: () => void; onError: () => void }): void {
    this.patientRegistrationService.updatePatient(this.buildPatientUpdatePayload()).subscribe({
      next: (res: any) => {
        if (!res?.success) {
          handlers.onError();
          this.toaster.error(res?.message || 'Failed to update patient.');
          return;
        }
        handlers.onSuccess();
      },
      error: (err) => {
        handlers.onError();
        const message = err?.error?.message || 'Failed to update patient.';
        this.toaster.error(message);
      },
    });
  }

  calculatePersonalDues(records: any[], current: any): number {
    const visitFees = Number(current?.visit_fees) || 0;
    const receivedCash = Number(current?.received_cash) || 0;
    const receivedOnline = Number(current?.received_online) || 0;
    const currentVisitDue = visitFees - (receivedCash + receivedOnline);

    const previousDue = this.getPreviousPersonalDues(records, current);
    return previousDue + currentVisitDue;
  }

  private syncDeskChatPatient(): void {
    const patientId = this.getCurrentPatientId();
    if (!patientId) {
      this.deskChat.setAttachablePatient(null);
      return;
    }

    const name = [this.patient?.salutation, this.patient?.full_name].filter(Boolean).join(' ').trim();
    this.deskChat.setAttachablePatient({
      id: patientId,
      full_name: name || 'Patient',
      patient_number: this.patient?.patient_number || '',
      card_number: this.patient?.card_number || '',
    });
  }

  loadCardMembers(cardId: number | string | null | undefined): void {
    const id = Number(cardId || 0);
    const requestId = ++this.cardMembersRequest;
    if (!id) {
      this.cardMembers = [];
      this.cardMembersLoading = false;
      return;
    }

    this.cardMembersLoading = true;
    this.cardsService.getCard(id).subscribe({
      next: (res: any) => {
        if (requestId !== this.cardMembersRequest) {
          return;
        }
        const patients = res?.success && Array.isArray(res?.data?.patients) ? res.data.patients : [];
        this.cardMembers = patients;
        this.cardMembersLoading = false;
        this.cdr.markForCheck();
      },
      error: () => {
        if (requestId !== this.cardMembersRequest) {
          return;
        }
        this.cardMembers = [];
        this.cardMembersLoading = false;
        this.cdr.markForCheck();
      },
    });
  }

  isCurrentCardMember(member: any): boolean {
    return Number(member?.id) === this.getCurrentPatientId();
  }

  get otherCardMembers(): any[] {
    return this.cardMembers.filter((member) => !this.isCurrentCardMember(member));
  }

  cardMemberLabel(member: any): string {
    const salutation = String(member?.salutation || '').trim();
    const name = String(member?.full_name || '').trim();
    return [salutation, name].filter(Boolean).join(' ') || 'Patient';
  }

  cardMemberAge(member: any): string {
    const years = Number(member?.age);
    if (!Number.isFinite(years) || years <= 0) {
      return '';
    }
    return `${years}y`;
  }

  startCardMemberConsultation(member: any): void {
    const patientId = Number(member?.id || 0);
    if (!patientId || patientId === this.getCurrentPatientId()) {
      return;
    }

    this.onPatientSelect({
      value: {
        id: patientId,
        patient_id: patientId,
        full_name: member?.full_name || '',
        salutation: member?.salutation || '',
      },
    });
  }

  private getPreviousPersonalDues(records: any[], current: any): number {
    if (!records?.length) {
      return 0;
    }

    const currentId = Number(current?.id || 0);
    const currentAppointmentId = Number(current?.appointment_id || 0);

    const previous = records.find((record: any) => {
      if (currentId > 0 && Number(record?.id) === currentId) {
        return false;
      }
      if (currentAppointmentId > 0 && Number(record?.appointment_id) === currentAppointmentId) {
        return false;
      }
      return true;
    });

    return previous ? Number(previous.personal_dues) || 0 : 0;
  }

  /** Amount still to collect on CC Avenue for this visit. */
  getOnlineChargeAmount(): number {
    const typed = Math.round(Number(this.prescription?.received_online) || 0);
    const settled = Math.round(this.settledOnlineAmount || 0);
    const balance = Math.max(0, Math.round(Number(this.prescription?.personal_dues) || 0));
    const cash = Math.max(0, Math.round(Number(this.prescription?.received_cash) || 0));
    const room = Math.max(0, this.maximumCollectable() - cash - settled);

    let charge = 0;
    if (typed > settled) {
      charge = typed - settled;
    } else if (typed === 0 || typed === settled) {
      charge = balance;
    }

    return Math.min(Math.max(0, charge), room);
  }

  onReceivedAmountChange(field: 'received_cash' | 'received_online'): void {
    const maximum = this.maximumCollectable();
    const cash = Math.max(0, Math.round(Number(this.prescription?.received_cash) || 0));
    const online = Math.max(0, Math.round(Number(this.prescription?.received_online) || 0));
    if (cash + online > maximum) {
      const other = field === 'received_cash' ? online : cash;
      this.prescription[field] = Math.max(0, maximum - other);
      this.toaster.warn(
        `Payment cannot exceed ₹${maximum.toLocaleString('en-IN')} (visit fees and outstanding dues).`,
        'Amount too high'
      );
    }
    this.prescription.personal_dues = this.calculatePersonalDues(this.filteredRecords, this.prescription);
  }

  private rememberRecordedPayment(): void {
    this.recordedCashAmount = Math.max(0, Math.round(Number(this.prescription?.received_cash) || 0));
    this.settledOnlineAmount = Math.max(0, Math.round(Number(this.prescription?.received_online) || 0));
  }

  private maximumCollectable(): number {
    const visitFees = Math.max(0, Math.round(Number(this.prescription?.visit_fees) || 0));
    const previous = Math.max(0, Math.round(this.getPreviousPersonalDues(this.filteredRecords, this.prescription)));
    const patientCap = previous + visitFees;
    const cardDues = Math.max(0, Math.round(Number(this.prescription?.card_dues) || 0));
    if (cardDues <= 0) {
      return patientCap;
    }

    const savedReceived = Math.max(0, Math.round(this.recordedCashAmount + (this.settledOnlineAmount || 0)));
    const currentId = Number(this.prescription?.id || 0);
    const latestId = Number(this.filteredRecords?.[0]?.id || 0);
    const visitAlreadyOnCard = currentId > 0 && latestId > 0 && currentId === latestId;
    const cardCap = visitAlreadyOnCard ? cardDues + savedReceived : cardDues + visitFees;
    return Math.max(0, Math.min(patientCap, cardCap));
  }

  private rejectExcessPayment(): boolean {
    const cash = Math.max(0, Math.round(Number(this.prescription?.received_cash) || 0));
    const online = Math.max(0, Math.round(Number(this.prescription?.received_online) || 0));
    const maximum = this.maximumCollectable();
    const already = Math.max(0, Math.round(this.recordedCashAmount + (this.settledOnlineAmount || 0)));
    if (cash + online <= maximum || cash + online <= already) {
      return false;
    }
    this.draftSaveSuppressed = false;
    this.toaster.warn(
      `Payment cannot exceed ₹${maximum.toLocaleString('en-IN')} (visit fees and outstanding dues).`,
      'Amount too high'
    );
    return true;
  }

  canStartOnlinePayment(): boolean {
    if (this.patient?.is_free || !this.getCurrentPatientId()) {
      return false;
    }
    return this.getOnlineChargeAmount() > 0;
  }

  isOnlineAmountSettled(): boolean {
    const typed = Math.round(Number(this.prescription?.received_online) || 0);
    const settled = Math.round(this.settledOnlineAmount || 0);
    const balance = Math.max(0, Math.round(Number(this.prescription?.personal_dues) || 0));
    return settled > 0 && typed === settled && balance === 0;
  }

  onlinePaymentTitle(): string {
    if (this.onlinePaymentInProgress) {
      return 'Waiting for CC Avenue';
    }
    if (this.patient?.is_free) {
      return 'No payment for a free visit';
    }
    if (!this.getCurrentPatientId()) {
      return 'Select a patient first';
    }
    const charge = this.getOnlineChargeAmount();
    if (charge > 0) {
      return `Collect ₹${charge} via CC Avenue`;
    }
    const settled = Math.round(this.settledOnlineAmount || 0);
    const typed = Math.round(Number(this.prescription?.received_online) || 0);
    if (settled > 0 && typed < settled) {
      return `₹${settled} is already collected. Set Online back to ${settled} to collect the balance, or higher to collect more.`;
    }
    if (settled > 0) {
      return `₹${settled} is already collected online.`;
    }
    return 'Enter the online amount to collect, or leave it blank to collect the balance';
  }

  initiateOnlinePayment(): void {
    if (this.onlinePaymentInProgress) {
      return;
    }
    if (!this.canStartOnlinePayment()) {
      this.toaster.warn(this.onlinePaymentTitle(), 'Online payment');
      return;
    }

    const charge = this.getOnlineChargeAmount();
    const doctorId = Number(this.doctorId || this.workContext.getDoctorId() || 0);
    if (!doctorId) {
      this.toaster.error('Doctor is not selected for this visit.', 'Online payment');
      return;
    }

    this.onlinePaymentInProgress = true;
    this.ensureAppointmentForPayment(doctorId, () => {
      const resolvedDoctorId = Number(this.doctorId || doctorId);
      this.ensurePrescriptionForPayment((prescriptionId) => {
        this.openCcAvenueCheckout(prescriptionId, charge, resolvedDoctorId);
      });
    });
  }

  /** Search selections have no queue visit yet. Open one so CC Avenue can attach to it. */
  private ensureAppointmentForPayment(doctorId: number, onReady: () => void): void {
    if (Number(this.prescription?.appointment_id) > 0) {
      onReady();
      return;
    }

    const clinicId = Number(
      this.clinicId || this.workContext.getClinicId() || sessionStorage.getItem('clinic_id')
    ) || 0;
    const patientId = this.getCurrentPatientId();
    if (!clinicId || !doctorId || !patientId) {
      this.onlinePaymentInProgress = false;
      this.toaster.error('Select clinic and doctor before collecting payment.', 'Online payment');
      return;
    }

    const { start_time, end_time } = buildHourlyAppointmentWindow(new Date());
    this.appointmentService.addAppointment({
      clinic_id: clinicId,
      doctor_id: doctorId,
      patient_id: patientId,
      appointment_date: todayDateString(),
      start_time,
      end_time,
      status: 'in progress',
      delivery_type: this.appointmentDeliveryType,
      is_courier: !!this.appointmentDeliveryType,
      type: 'on_flow',
    }).subscribe({
      next: (res: any) => {
        const appt = res?.data;
        const appointmentId = Number(appt?.id || appt?.appointment_id || 0);
        if (!appointmentId) {
          this.onlinePaymentInProgress = false;
          this.toaster.error(res?.message || 'Could not open a visit for this patient.', 'Online payment');
          return;
        }
        this.bindAppointmentForPayment(appt, doctorId, clinicId);
        this.loadQueue();
        onReady();
      },
      error: (err) => {
        const message =
          err?.error?.message
          || err?.error?.errors?.start_time?.[0]
          || '';
        if (this.isDoubleBookingError(message)) {
          this.attachExistingTodayAppointment(patientId, doctorId, onReady);
          return;
        }
        this.onlinePaymentInProgress = false;
        this.toaster.error('Could not open a visit for this patient.', 'Online payment');
      },
    });
  }

  private bindAppointmentForPayment(appt: any, doctorId: number, clinicId: number): void {
    this.prescription.appointment_id = Number(appt?.id || appt?.appointment_id || 0);
    this.doctorId = Number(appt?.doctor_id) || doctorId;
    this.clinicId = Number(appt?.clinic_id) || clinicId;
    this.patientSelectedFromSearch = false;
  }

  private attachExistingTodayAppointment(patientId: number, doctorId: number, onReady: () => void): void {
    this.resolveTodayAppointmentForPatient(patientId, ({ open, prescribed }) => {
      if (open) {
        const clinicId = Number(open.clinic_id || this.workContext.getClinicId() || 0);
        this.bindAppointmentForPayment(open, Number(open.doctor_id) || doctorId, clinicId);
        onReady();
        return;
      }

      this.onlinePaymentInProgress = false;
      if (prescribed) {
        this.handleAlreadyPrescribedPatient(patientId);
        return;
      }
      this.toaster.error('This patient already has a visit today, but it could not be opened for payment.', 'Online payment');
    });
  }

  private ensurePrescriptionForPayment(onReady: (prescriptionId: number) => void): void {
    const existingId = Number(this.prescription?.id || 0);
    if (existingId > 0) {
      onReady(existingId);
      return;
    }

    const intendedOnline = this.prescription.received_online;
    const payload = this.buildUnpaidPrescriptionPayload();

    this.prescriptionsService.addPrescriptions(payload).subscribe({
      next: (res: any) => {
        const createdId = Number(res?.data?.id || 0);
        if (!res?.success || !createdId) {
          this.onlinePaymentInProgress = false;
          this.toaster.error(res?.message || 'Could not save the visit before payment.', 'Online payment');
          return;
        }

        this.prescription.id = createdId;
        this.prescription.received_online = intendedOnline;
        this.prescription.personal_dues = this.calculatePersonalDues(
          this.filteredRecords,
          this.prescription
        );
        onReady(createdId);
      },
      error: (err) => {
        this.onlinePaymentInProgress = false;
        this.toaster.error(err?.error?.message || 'Could not save the visit before payment.', 'Online payment');
      },
    });
  }

  private buildUnpaidPrescriptionPayload(): any {
    const receivedOnline = Math.round(this.settledOnlineAmount || 0);
    const snapshot: any = {
      ...this.prescription,
      received_cash: Math.round(Number(this.prescription.received_cash) || 0),
      received_online: receivedOnline,
      visit_fees: Math.round(Number(this.prescription.visit_fees) || 0),
      discount_percent: Math.round(Number(this.prescription.discount_percent) || 0),
    };
    snapshot.personal_dues = Math.round(
      this.calculatePersonalDues(this.filteredRecords, snapshot)
    );
    delete snapshot.id;
    delete snapshot.payment_status;
    return snapshot;
  }

  private openCcAvenueCheckout(prescriptionId: number, charge: number, doctorId: number): void {
    const payload = {
      patient_id: this.getCurrentPatientId(),
      appointment_id: this.prescription.appointment_id,
      prescription_id: prescriptionId,
      doctor_id: doctorId,
      name: this.patient?.full_name || '',
      contact_number: this.patient?.contact_number || '',
      amount: charge,
    };

    this.appointmentService.ccAvenuePayment(payload).subscribe({
      next: (res: any) => {
        if (!res?.ccavenueUrl || !res?.encRequest || !res?.accessCode) {
          this.onlinePaymentInProgress = false;
          this.toaster.error('Invalid payment initialization response.', 'Payment Error');
          return;
        }

        const form = document.createElement('form');
        form.method = 'POST';
        form.action = res.ccavenueUrl;
        form.target = 'paymentPopup';

        const fields: Record<string, string> = {
          encRequest: res.encRequest,
          access_code: res.accessCode,
        };
        Object.entries(fields).forEach(([key, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = value;
          form.appendChild(input);
        });

        const popup = window.open('', 'paymentPopup', 'width=800,height=600');
        if (!popup) {
          this.onlinePaymentInProgress = false;
          this.toaster.warn('Please allow popups to continue payment.', 'Popup Blocked');
          return;
        }

        this.pendingOnlinePrescriptionId = prescriptionId;
        this.pendingOnlineCharge = charge;
        this.attachOnlinePaymentListener();

        document.body.appendChild(form);
        form.submit();
        form.remove();
        this.watchOnlinePaymentPopup(popup, prescriptionId);
      },
      error: (err) => {
        this.onlinePaymentInProgress = false;
        this.toaster.error(err?.error?.error || err?.error?.message || 'Could not start CC Avenue.', 'Payment Error');
      },
    });
  }

  private attachOnlinePaymentListener(): void {
    if (this.onlinePaymentListenerAttached) {
      return;
    }
    this.onlinePaymentListenerAttached = true;
    window.addEventListener('message', this.onOnlinePaymentMessage);
  }

  private watchOnlinePaymentPopup(popup: Window, prescriptionId: number): void {
    const timer = window.setInterval(() => {
      if (!popup.closed) {
        return;
      }
      window.clearInterval(timer);
      window.setTimeout(() => {
        if (
          this.onlinePaymentInProgress &&
          this.pendingOnlinePrescriptionId === prescriptionId
        ) {
          this.onlinePaymentInProgress = false;
          this.cdr.markForCheck();
        }
      }, 1500);
    }, 500);
  }

  private handleOnlinePaymentMessage(event: MessageEvent): void {
    if (!this.isTrustedPaymentOrigin(event.origin)) {
      return;
    }

    const data = event.data;
    if (!data || typeof data !== 'object' || data.type === 'card_dues') {
      return;
    }

    const orderId = Number(data.orderId || data.order_id || 0);
    if (!orderId || orderId !== this.pendingOnlinePrescriptionId) {
      return;
    }

    const status = String(data.status || data.payment_status || '').trim().toLowerCase();
    if (!status) {
      return;
    }

    const trackingId = String(data.trackingId || data.tracking_id || '').trim();
    if (trackingId) {
      if (this.handledPaymentTrackingIds.has(trackingId)) {
        return;
      }
      this.handledPaymentTrackingIds.add(trackingId);
    }

    const prescriptionId = this.pendingOnlinePrescriptionId;
    const charge = this.pendingOnlineCharge;
    this.pendingOnlinePrescriptionId = 0;
    this.pendingOnlineCharge = 0;

    switch (status) {
      case 'success':
        this.applySuccessfulOnlinePayment(data, charge, prescriptionId);
        break;
      case 'failure':
        this.onlinePaymentInProgress = false;
        this.toaster.error('The transaction was unsuccessful. Please try again.', 'Payment Failed');
        break;
      case 'aborted':
        this.onlinePaymentInProgress = false;
        this.toaster.warn('You cancelled the payment.', 'Payment Aborted');
        break;
      case 'invalid':
        this.onlinePaymentInProgress = false;
        this.toaster.error('Payment request was invalid or corrupted.', 'Invalid Payment');
        break;
      case 'timeout':
        this.onlinePaymentInProgress = false;
        this.toaster.warn('The payment session expired or timed out. Please try again.', 'Payment Timeout');
        break;
      default:
        this.onlinePaymentInProgress = false;
        this.toaster.info('Payment status: ' + status, 'Payment Status');
        break;
    }
    this.cdr.markForCheck();
  }

  private isTrustedPaymentOrigin(origin: string): boolean {
    const allowed = new Set<string>([
      'https://clinic.drsubodhbhade.com',
      window.location.origin,
    ]);
    if (this.apiUrl) {
      try {
        allowed.add(new URL(this.apiUrl).origin);
      } catch {
        // Ignore a malformed API base URL.
      }
    }
    return allowed.has(origin);
  }

  private applySuccessfulOnlinePayment(data: any, charge: number, prescriptionId: number): void {
    const paidNow = Math.round(Number(data?.amount ?? charge) || charge);
    const receivedOnline = Math.round(this.settledOnlineAmount || 0) + (paidNow > 0 ? paidNow : charge);

    this.prescription.received_online = receivedOnline;
    this.prescription.personal_dues = this.calculatePersonalDues(
      this.filteredRecords,
      this.prescription
    );
    this.prescription.payment_status = 'Success';
    this.settledOnlineAmount = receivedOnline;

    const payload = {
      id: prescriptionId,
      appointment_id: this.prescription.appointment_id,
      received_cash: Math.round(Number(this.prescription.received_cash) || 0),
      received_online: receivedOnline,
      visit_fees: Math.round(Number(this.prescription.visit_fees) || 0),
      discount_percent: Math.round(Number(this.prescription.discount_percent) || 0),
      personal_dues: Math.round(Number(this.prescription.personal_dues) || 0),
      delivery_type: this.prescription.delivery_type ?? null,
      is_courier: !!this.prescription.delivery_type,
    };

    this.prescriptionsService.updatePrescriptions(payload).subscribe({
      next: (res: any) => {
        this.onlinePaymentInProgress = false;
        if (!res?.success) {
          this.toaster.error(res?.message || 'Payment succeeded but could not be saved on the visit.', 'Online payment');
          this.cdr.markForCheck();
          return;
        }
        this.settledOnlineAmount = receivedOnline;
        this.toaster.success(`₹${paidNow || charge} collected online.`, 'Payment Successful');
        this.loadPatientPayments(this.getCurrentPatientId());
        this.cdr.markForCheck();
      },
      error: (err) => {
        this.onlinePaymentInProgress = false;
        this.toaster.error(
          err?.error?.message || 'Payment succeeded but could not be saved on the visit.',
          'Online payment'
        );
        this.cdr.markForCheck();
      },
    });
  }

  // 🎤 Voice recognition controls
  isRecording = false;
  activeField = '';
  recognition: any = null;

  interimTranscript: string = ''; // Stores floating interim text
  showFloatingTranscript: boolean = false;

  lastFinalChunk: string = '';

  pauseTimer: any = null;
  sentenceBuffer: string = '';

  // 🎤 Start voice dictation
  startDictation(fieldId: string) {
    if (this.isRecording) {
      this.toaster.warn(
        'Please stop the current recording before starting a new one.',
        'Recording already active',
        { life: 4000 },
      );
      return;
    }

    if (!('webkitSpeechRecognition' in window)) {
      this.toaster.error(
        'Your browser does not support voice input. Try Chrome.',
        'Speech Recognition Unsupported',
        { life: 5000 },
      );
      return;
    }

    this.isRecording = true;
    this.activeField = fieldId;
    this.showFloatingTranscript = true;

    if (fieldId === 'notes') {
      this.clearReceptionNotesHighlight();
    }

    if (fieldId === 'medicines') {
      this.applyMedicinesDatePrefix();
      this.prescription.medicines_final = this.getMedicinesBody(this.prescription.medicines);
    }

    const glossary: Record<string, string> = {
      'calcarea carbonica': 'Calcarea Carbonica',
      'c30': '30C',
      'c200': '200C',
      'one dose': '1 dose',
      'two doses': '2 doses',
      'three doses': '3 doses',
      'globules': 'globules'
    };

    const applyGlossary = (text: string) => {
      for (const key in glossary) {
        const regex = new RegExp(`\\b${key}\\b`, 'gi');
        text = text.replace(regex, glossary[key]);
      }
      return text;
    };

    const recognition = new (window as any).webkitSpeechRecognition();
    this.recognition = recognition;

    recognition.continuous = true;
    recognition.interimResults = true; // Important for floating transcript
    recognition.lang = 'en-US';
    recognition.start();

    this.toaster.info('You can start speaking now.', 'Listening...', { life: 5000 });

    recognition.onresult = (event: any) => {
      let interim = '';
      let fullFinal = '';

      for (let i = event.resultIndex; i < event.results.length; i++) {
        const text = event.results[i][0].transcript.trim();
        if (!text) continue;

        if (event.results[i].isFinal) {
          fullFinal = text; // Mobile sends cumulative full transcript
        } else {
          interim += text + ' ';
        }
      }

      const replaceSymbols = (text: string) =>
        text
          .replace(/ colon/gi, ':')
          .replace(/ dash/gi, '-')
          .replace(/ slash/gi, '/')
          .replace(/ new line/gi, '\n');

      fullFinal = applyGlossary(replaceSymbols(fullFinal));
      interim = applyGlossary(replaceSymbols(interim));

      // 🔥 ALWAYS show updated fullFinal (one line)
      if (fullFinal) {
        this.sentenceBuffer = fullFinal;
        this.interimTranscript = '';        // hide interim
      } else {
        this.interimTranscript = interim;   // show floating only
      }

      // 🔥 Show live in the field (replace, not append)
      if (fieldId === 'medicines') {
        this.refreshMedicinesDisplay(this.sentenceBuffer);
      } else {
        (this.prescription as any)[fieldId] = this.sentenceBuffer;
      }

      // 🔥 Reset pause detection timer
      clearTimeout(this.pauseTimer);

      this.pauseTimer = setTimeout(() => {
        // User paused -> finalize that line
        const prev = (this.prescription as any)[fieldId] || '';

        if (prev.trim()) {
          this.saveSentence(fieldId, prev.trim());
        }

        // Reset for next sentence
        this.sentenceBuffer = '';
        this.lastFinalChunk = ''; // important for fresh cumulative
        if (fieldId === 'medicines') {
          this.refreshMedicinesDisplay();
        } else {
          (this.prescription as any)[fieldId] = '';
        }
      }, 900); // adjust pause length
    };

    //! Version 3
    // recognition.onresult = (event: any) => {
    //   let interim = '';
    //   let finalTranscript = '';

    //   for (let i = event.resultIndex; i < event.results.length; i++) {
    //     const transcript = event.results[i][0].transcript.trim();
    //     if (!transcript) continue;

    //     if (event.results[i].isFinal) {
    //       finalTranscript = transcript;
    //     } else {
    //       interim += transcript + ' ';
    //     }
    //   }

    //   const replaceSymbols = (text: string) =>
    //     text
    //       .replace(/ colon/gi, ':')
    //       .replace(/ dash/gi, '-')
    //       .replace(/ slash/gi, '/')
    //       .replace(/ new line/gi, '\n');

    //   interim = applyGlossary(replaceSymbols(interim));
    //   finalTranscript = applyGlossary(replaceSymbols(finalTranscript));

    //   // 🚨 STOP DUPLICATION
    //   if (finalTranscript && finalTranscript !== this.lastFinalChunk) {

    //     const prev = this.prescription[fieldId] || '';
    //     this.prescription[fieldId] = prev
    //       ? prev + '\n' + finalTranscript
    //       : finalTranscript;

    //     this.lastFinalChunk = finalTranscript;
    //   }

    //   this.interimTranscript = interim;
    // };

    //! Version 2
    // recognition.onresult = (event: any) => {
    //   let interim = '';
    //   let finalTranscript = '';

    //   for (let i = event.resultIndex; i < event.results.length; ++i) {
    //     const transcript = event.results[i][0].transcript;
    //     if (event.results[i].isFinal) {
    //       // finalTranscript += transcript + '\n';
    //       finalTranscript += transcript;
    //     } else {
    //       interim += transcript;
    //     }
    //   }

    //   // Replace common spoken symbols
    //   const replaceSymbols = (text: string) =>
    //     text
    //       .replace(/ colon/gi, ':')
    //       .replace(/ dash/gi, '-')
    //       .replace(/ slash/gi, '/')
    //       .replace(/ new line/gi, '\n');

    //   interim = applyGlossary(replaceSymbols(interim));
    //   finalTranscript = applyGlossary(replaceSymbols(finalTranscript));

    //   if (finalTranscript) {
    //     (this.prescription as any)[fieldId] +=
    //       (this.prescription as any)[fieldId]
    //         ? '\n' + finalTranscript
    //         : finalTranscript;
    //   }

    //   this.interimTranscript = interim; // floating text
    // };

    //! Version 1
    // recognition.onresult = (event: any) => {
    //   let interim = '';
    //   let finalTranscript = '';

    //   for (let i = event.resultIndex; i < event.results.length; ++i) {
    //     const transcript = event.results[i][0].transcript.trim();
    //     if (!transcript) continue;

    //     if (event.results[i].isFinal) {
    //       finalTranscript += transcript + ' ';
    //     } else {
    //       interim += transcript + ' ';
    //     }
    //   }

    //   const replaceSymbols = (text: string) =>
    //     text
    //       .replace(/\s*colon\s*/gi, ':')
    //       .replace(/\s*dash\s*/gi, '-')
    //       .replace(/\s*slash\s*/gi, '/')
    //       .replace(/\s*new line\s*/gi, '\n')
    //       .trim();

    //   interim = applyGlossary(replaceSymbols(interim));
    //   finalTranscript = applyGlossary(replaceSymbols(finalTranscript));

    //   // 🟢 1. Show interim live for instant feedback
    //   this.interimTranscript = interim;

    //   // 🟢 2. Commit final only when ready
    //   if (finalTranscript) {
    //     const prev = ((this.prescription as any)[fieldId] || '').trim();
    //     const merged = [prev, finalTranscript.trim()]
    //       .filter(Boolean)
    //       .join(' ')
    //       .replace(/\s{2,}/g, ' ')
    //       .replace(/\n{2,}/g, '\n');
    //     (this.prescription as any)[fieldId] = merged;
    //   }

    //   // 🟢 3. Optional — update the visible field live
    //   if (interim && !finalTranscript) {
    //     // instantly show interim in the text field
    //     (this.prescription as any)[fieldId] =
    //       ((this.prescription as any)[fieldId] || '') + ' ' + interim;
    //   }
    // };

    recognition.onerror = (event: any) => {
      this.toaster.add({
        severity: 'error',
        summary: 'Speech Error',
        detail: `An error occurred: ${event.error}`,
        life: 4000
      });
      this.stopRecording();
    };

    recognition.onend = () => {
      this.showFloatingTranscript = false;
      if (this.isRecording) {
        // console.log('Recognition ended unexpectedly, restarting...');
        recognition.start();
      } else {
        this.toaster.info('Voice recognition has been turned off.', 'Recording stopped', { life: 3000 });
      }
    };
  }

  // startDictation(fieldId: string) {
  //   if (this.isRecording) {
  //     this.toaster.add({
  //       severity: 'warn',
  //       summary: 'Recording already active',
  //       detail: 'Please stop the current recording before starting a new one.',
  //       life: 4000,
  //     });
  //     return;
  //   }

  //   if (!('webkitSpeechRecognition' in window)) {
  //     this.toaster.add({
  //       severity: 'error',
  //       summary: 'Speech Recognition Unsupported',
  //       detail: 'Your browser does not support voice input. Try Chrome.',
  //       life: 5000,
  //     });
  //     return;
  //   }

  //   this.isRecording = true;
  //   this.activeField = fieldId;
  //   this.showFloatingTranscript = true;

  //   const glossary: Record<string, string> = {
  //     'calcarea carbonica': 'Calcarea Carbonica',
  //     'c30': '30C',
  //     'c200': '200C',
  //     'one dose': '1 dose',
  //     'two doses': '2 doses',
  //     'three doses': '3 doses',
  //     'globules': 'globules',
  //   };

  //   const applyGlossary = (text: string) => {
  //     for (const key in glossary) {
  //       const regex = new RegExp(`\\b${key}\\b`, 'gi');
  //       text = text.replace(regex, glossary[key]);
  //     }
  //     return text;
  //   };

  //   const replaceSymbols = (text: string) =>
  //     text
  //       .replace(/\s*colon\s*/gi, ':')
  //       .replace(/\s*dash\s*/gi, '-')
  //       .replace(/\s*slash\s*/gi, '/')
  //       .replace(/\s*new line\s*/gi, '\n')
  //       .trim();

  //   const recognition = new (window as any).webkitSpeechRecognition();
  //   this.recognition = recognition;

  //   recognition.continuous = true;
  //   recognition.interimResults = true;
  //   recognition.lang = 'en-US';
  //   recognition.maxAlternatives = 1;

  //   recognition.start();

  //   this.toaster.add({
  //     severity: 'info',
  //     summary: 'Listening...',
  //     detail: 'You can start speaking now.',
  //     life: 4000,
  //   });

  //   let liveTextBuffer = ''; // stores last interim batch

  //   recognition.onresult = (event: any) => {
  //     let interim = '';
  //     let final = '';

  //     for (let i = event.resultIndex; i < event.results.length; ++i) {
  //       const transcript = event.results[i][0].transcript.trim();
  //       if (!transcript) continue;

  //       if (event.results[i].isFinal) final += transcript + ' ';
  //       else interim += transcript + ' ';
  //     }

  //     interim = applyGlossary(replaceSymbols(interim));
  //     final = applyGlossary(replaceSymbols(final));

  //     // ⚡ Show interim instantly
  //     this.interimTranscript = interim;

  //     // 🧠 Commit final cleanly
  //     if (final) {
  //       const prev = ((this.prescription as any)[fieldId] || '').trim();
  //       const merged = [prev, final.trim()]
  //         .filter(Boolean)
  //         .join(' ')
  //         .replace(/\s{2,}/g, ' ')
  //         .replace(/\n{2,}/g, '\n');
  //       (this.prescription as any)[fieldId] = merged;
  //       liveTextBuffer = ''; // reset buffer
  //     } else if (interim && interim !== liveTextBuffer) {
  //       // 💨 Real-time live update (feels instant)
  //       liveTextBuffer = interim;
  //       const prev = ((this.prescription as any)[fieldId] || '').trim();
  //       (this.prescription as any)[fieldId] = [prev, interim]
  //         .filter(Boolean)
  //         .join(' ')
  //         .replace(/\s{2,}/g, ' ');
  //     }
  //   };

  //   recognition.onerror = (event: any) => {
  //     if (event.error !== 'no-speech') {
  //       this.toaster.add({
  //         severity: 'error',
  //         summary: 'Speech Error',
  //         detail: `Error: ${event.error}`,
  //         life: 4000,
  //       });
  //     }
  //     this.stopRecording();
  //   };

  //   recognition.onend = () => {
  //     this.showFloatingTranscript = false;
  //     if (this.isRecording) {
  //       // 🔁 Auto-restart for continuous flow
  //       recognition.start();
  //     } else {
  //       this.toaster.add({
  //         severity: 'info',
  //         summary: 'Recording stopped',
  //         detail: 'Voice recognition turned off.',
  //         life: 3000,
  //       });
  //     }
  //   };
  // }

  //! ==================================================================

  // 🛑 Stop voice dictation
  // stopRecording() {
  //   if (this.recognition) {
  //     this.recognition.onend = null;
  //     this.recognition.stop();
  //     this.recognition = null;
  //   }
  //   this.isRecording = false;
  //   this.activeField = '';

  //   this.toaster.add({
  //     severity: 'success',
  //     summary: 'Recording stopped',
  //     detail: 'Speech recognition successfully stopped.',
  //     life: 3000
  //   });
  // }

  stopRecording() {
    // 🔥 1. Commit any pending buffered speech
    if (this.sentenceBuffer && this.activeField) {
      const finalField = this.activeField + '_final';
      const prev = (this.prescription[finalField] || '').trim();

      this.prescription[finalField] = prev
        ? prev + '\n' + this.sentenceBuffer.trim()
        : this.sentenceBuffer.trim();
    }

    // 🔥 2. Push final field back into main field
    if (this.activeField) {
      const finalField = this.activeField + '_final';
      if (this.activeField === 'medicines') {
        this.prescription.medicines = this.composeMedicines(this.prescription[finalField] || '');
      } else {
        this.prescription[this.activeField] = this.prescription[finalField] || '';
      }
    }

    // 🔥 3. Cleanup recognition properly
    if (this.recognition) {
      this.recognition.onend = null;
      this.recognition.stop();
      this.recognition = null;
    }

    // 🔥 4. Reset tracking state
    this.isRecording = false;
    this.lastFinalChunk = '';
    this.sentenceBuffer = '';
    this.interimTranscript = '';
    this.showFloatingTranscript = false;
    clearTimeout(this.pauseTimer);

    const stoppedField = this.activeField;
    this.activeField = '';

    // 🔥 5. Feedback
    this.toaster.success(
      stoppedField ? 'Dictation saved successfully.' : 'Speech recognition has been stopped.',
      'Recording stopped',
      { life: 3000 },
    );
  }

  saveSentence(fieldId: string, text: string) {
    const chunk = fieldId === 'medicines' ? this.getMedicinesBody(text) : text;
    const prev = (this.prescription[fieldId + '_final'] || '').trim();
    const merged = prev ? prev + '\n' + chunk : chunk;
    this.prescription[fieldId + '_final'] = merged;

    if (fieldId === 'medicines') {
      this.refreshMedicinesDisplay();
    }
  }

  // onFileSelect(event: any) {
  //   const files = event.target.files as FileList;
  //   if (!files || files.length === 0) {
  //     return;
  //   }

  //   const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
  //   const maxFileSize = 5 * 1024 * 1024; // 5 MB

  //   const validFiles: File[] = [];

  //   for (let i = 0; i < files.length; i++) {
  //     const file = files[i];

  //     // --- Validation Step 1: File Type ---
  //     if (!allowedTypes.includes(file.type)) {
  //       this.toaster.add({
  //         severity: 'error',
  //         summary: 'Invalid File Type',
  //         detail: `File '${file.name}' was rejected. Only PDF, JPG, and PNG are allowed.`
  //       });
  //       continue; // Skip this file
  //     }

  //     // --- Validation Step 2: File Size ---
  //     if (file.size > maxFileSize) {
  //       const fileSizeMB = (file.size / 1024 / 1024).toFixed(2);
  //       this.toaster.add({
  //         severity: 'error',
  //         summary: 'File Too Large',
  //         detail: `File '${file.name}' (${fileSizeMB} MB) exceeds the 5 MB limit.`
  //       });
  //       continue; // Skip this file
  //     }

  //     // If all checks pass, add the file to our valid list
  //     validFiles.push(file);
  //   }

  //   // Now, assign only the validated files to your main property
  //   this.selectedFiles = validFiles;

  //   // Optional: Give a summary message if some files were selected
  //   if (this.selectedFiles.length > 0) {
  //       this.toaster.add({
  //           severity: 'info',
  //           summary: 'Files Ready',
  //           detail: `${this.selectedFiles.length} file(s) are ready to be uploaded.`
  //       });
  //   }

  //   // Reset the file input to allow re-selection of the same file
  //   event.target.value = '';
  // }

  onFileSelect(event: any) {
    const files = Array.from(event.target.files as FileList);
    if (!files || files.length === 0) {
      return;
    }

    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
    const maxFileSize = this.reportMaxFileSizeBytes;

    const validFiles: File[] = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      // --- Validation Step 1: File Type ---
      if (!allowedTypes.includes(file.type)) {
        this.toaster.add({
          severity: 'error',
          summary: 'Invalid File Type',
          detail: `File '${file.name}' was rejected. Only PDF, JPG, and PNG are allowed.`
        });
        continue; // Skip this file
      }

      // --- Validation Step 2: File Size ---
      if (file.size > maxFileSize) {
        const fileSizeMB = (file.size / 1024 / 1024).toFixed(2);
        this.toaster.add({
          severity: 'error',
          summary: 'File Too Large',
          detail: `File '${file.name}' (${fileSizeMB} MB) exceeds the 20 MB limit.`
        });
        continue; // Skip this file
      }

      // If all checks pass, add the file to our valid list
      validFiles.push(file);
    }

    this.pendingFiles = [...this.pendingFiles, ...validFiles];

    if (this.pendingFiles.length > 0) {
      this.toaster.add({
        severity: 'info',
        summary: 'Files Ready',
        detail: `${this.pendingFiles.length} file(s) are ready to be uploaded.`
      });
    }

    // Reset the file input to allow re-selection of the same file
    event.target.value = '';
  }

  // onUploadSelectedFiles() {
  //   if (!this.selectedFiles.length) {
  //     this.toaster.add({
  //       severity: 'warn',
  //       summary: 'No Files',
  //       detail: 'Please select valid files before uploading.'
  //     });
  //     return;
  //   }

  //   const today = new Date();
  //   let group = this.uploadsByDate.find(
  //     g => g.date.toDateString() === today.toDateString()
  //   );

  //   if (!group) {
  //     group = { date: today, files: [] };
  //     this.uploadsByDate.unshift(group);
  //   }

  //   const filesToProcessCount = this.selectedFiles.length;

  //   this.selectedFiles.forEach(file => {
  //     const reader = new FileReader();
  //     reader.onload = (e: any) => {
  //       // The '!' non-null assertion is safe here because we created the group if it didn't exist
  //       group!.files.push({
  //         name: file.name,
  //         type: file.type,
  //         url: e.target.result,
  //       });
  //     };
  //     reader.readAsDataURL(file);
  //   });

  //   // Give a success feedback message
  //   this.toaster.add({
  //     severity: 'success',
  //     summary: 'Upload Complete',
  //     detail: `${filesToProcessCount} file(s) have been successfully added.`
  //   });

  //   // Clear the selection for the next batch
  //   this.selectedFiles = [];
  // }

  onUploadSelectedFiles() {
    if (!this.pendingFiles || this.pendingFiles.length === 0) {
      this.toaster.warn('Please select valid files before uploading.', 'No Files');
      return;
    }

    const patientId = this.getCurrentPatientId();
    if (!patientId) {
      this.toaster.warn('Please select a patient before uploading reports.', 'Patient Required');
      return;
    }

    const formData = new FormData();
    formData.append('patient_id', String(patientId));
    if (this.prescription?.id) {
      formData.append('prescription_id', String(this.prescription.id));
    }

    this.pendingFiles.forEach((file: File) => {
      formData.append('files[]', file, file.name);
    });

    this.isUploadingReports = true;
    const fileCount = this.pendingFiles.length;

    this.prescriptionsService.uploadReports(formData).subscribe({
      next: (res: any) => {
        this.isUploadingReports = false;
        if (!res?.success) {
          this.toaster.error(res?.message || 'Unable to upload documents.', 'Upload Failed');
          return;
        }

        this.toaster.add({
          severity: 'success',
          summary: 'Upload Complete',
          detail: `${fileCount} file(s) uploaded successfully.`
        });

        this.resetSelectedFiles();
        this.refreshReportsForCurrentPatient();
      },
      error: (err) => {
        this.isUploadingReports = false;
        console.error('Report upload failed:', err);
        this.toaster.error('Failed to upload reports.', 'Upload Failed');
      }
    });
  }

  reportFileUrl(file: any): string {
    return this.prescriptionsService.resolveReportFileUrl(file);
  }

  openFile(file: any, event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();

    if (!file) {
      this.toaster.warn('Document is unavailable.', 'Open Failed');
      return;
    }

    if (!file.id) {
      this.toaster.warn('This document is not saved yet.', 'Open Failed');
      return;
    }

    this.viewingReportFile = file;
    this.openingReportId = Number(file.id);
    this.openReportViaDialog(file);
  }

  trackReportRow(_index: number, row: { file: any }): number {
    return Number(row.file?.id) || _index;
  }

  onDialogRetry(): void {
    if (this.viewingReportFile) {
      this.openReportViaDialog(this.viewingReportFile);
    }
  }

  downloadReport(file: any, event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();

    if (!file) {
      this.toaster.warn('Document is unavailable.', 'Download Failed');
      return;
    }

    this.reportViewerService.fetchReportBlob(file).subscribe({
      next: (blob) => {
        downloadBlob(blob, file?.name || 'document');
      },
      error: (err) => {
        const message = extractHttpErrorMessage(err, 'Unable to download document.');
        this.toaster.error(message, 'Download Failed');
      },
    });
  }

  private openReportViaDialog(file: any): void {
    this.reportOpenSub?.unsubscribe();
    this.revokeDialogPreviewBlob();
    this.resetReportViewerState();
    this.reportViewerVisible = true;
    this.reportViewerLoading = true;
    this.reportViewerTitle = file?.name || 'Document';
    this.reportViewerIsImage = isImageReportFile(file);
    this.cdr.detectChanges();

    const reportId = Number(file.id);
    this.reportOpenSub = this.reportViewerService.loadReport(file).subscribe({
      next: (payload) => {
        if (Number(this.viewingReportFile?.id) !== reportId) {
          URL.revokeObjectURL(payload.blobUrl);
          return;
        }
        this.openingReportId = null;
        this.applyReportViewerPayload(payload);
      },
      error: (err) => {
        if (Number(this.viewingReportFile?.id) !== reportId) {
          return;
        }
        this.openingReportId = null;
        const message = extractHttpErrorMessage(err, 'Unable to open document. Please try again.');
        this.reportViewerLoading = false;
        this.reportViewerError = message;
        this.toaster.error(message, 'Open Failed');
        this.cdr.markForCheck();
      },
    });
  }

  private revokeDialogPreviewBlob(): void {
    if (this.dialogPreviewBlobUrl) {
      URL.revokeObjectURL(this.dialogPreviewBlobUrl);
      this.dialogPreviewBlobUrl = null;
    }
  }

  private resetReportViewerState(): void {
    this.reportViewerLoading = false;
    this.reportViewerError = null;
    this.reportViewerTitle = '';
    this.reportViewerIsImage = false;
    this.reportViewerImageUrl = null;
    this.reportViewerDocumentUrl = null;
    this.reportViewerRawUrl = null;
  }

  private applyReportViewerPayload(payload: ReportViewerPayload): void {
    this.revokeDialogPreviewBlob();
    this.dialogPreviewBlobUrl = payload.blobUrl;

    this.reportViewerTitle = payload.title;
    this.reportViewerIsImage = payload.isImage;
    this.reportViewerError = null;
    this.reportViewerRawUrl = payload.blobUrl;

    if (payload.isImage) {
      this.reportViewerImageUrl = payload.blobUrl;
      this.reportViewerDocumentUrl = null;
    } else {
      this.reportViewerImageUrl = null;
      this.reportViewerDocumentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(payload.blobUrl);
    }

    this.reportViewerLoading = false;
    this.cdr.markForCheck();
  }

  closeReportViewer(): void {
    this.reportOpenSub?.unsubscribe();
    this.openingReportId = null;
    this.reportViewerVisible = false;
    this.revokeDialogPreviewBlob();
    this.resetReportViewerState();
  }

  private applyPatientReports(data: any[]) {
    this.uploadsByDate = data || [];
    this.rebuildReportRows();
    this.cdr.markForCheck();
  }

  recallSavedPrescription(record?: any) {
    const todayIst = this.getIstDateKey();
    let source: any = null;

    if (record) {
      if (!this.isRecordFromTodayIst(record)) {
        this.toaster.add({
          severity: 'info',
          summary: 'Recall Restricted',
          detail: `Only prescriptions saved on ${todayIst} (IST) can be recalled.`
        });
        return;
      }
      source = record;
    } else {
      source = this.getLatestTodayIstPrescription();
    }

    if (!source) {
      this.toaster.add({
        severity: 'info',
        summary: 'No Saved Prescription',
        detail: `No prescription saved today (${todayIst} IST) was found for this patient.`
      });
      return;
    }

    // Keep current appointment/patient context, only recall saved prescription fields.
    this.prescription = {
      ...this.prescription,
      summary: source.summary || '',
      medicines: source.medicines || '',
      chief_complaints: source.chief_complaints || '',
      diagnosis: source.diagnosis || '',
      past_history: source.past_history || '',
      menstrual_history: source.menstrual_history || '',
      respiratory_system: source.respiratory_system || '',
      cardiovascular_system: source.cardiovascular_system || '',
      central_nervous_system: source.central_nervous_system || '',
      per_abdomen: source.per_abdomen || '',
      family_history: {
        father: '',
        mother: '',
        other: '',
        ...(source.family_history || {})
      },
      others: {
        nail: '',
        mentals: '',
        stool: '',
        urine: '',
        sleep: '',
        parsp: '',
        corn: '',
        mole: '',
        hair: '',
        spine: '',
        pallor: '',
        cyanosis: '',
        clubbing: '',
        icterus: '',
        thirst: '',
        craving: '',
        aversion: '',
        dreams: '',
        thermals: '',
        warts: '',
        lm: '',
        tongue: '',
        ...(source.others || {})
      },
      visit_fees: Number(source.visit_fees || 0),
      discount_percent: normalizeDiscountPercent(source.discount_percent),
      received_cash: Number(source.received_cash || 0),
      received_online: Number(source.received_online || 0),
      personal_dues: Number(source.personal_dues || 0),
      card_dues: Number(source.card_dues || 0),
      notes: source.notes || '',
      delivery_type: resolveDeliveryType(source),
      is_courier: !!resolveDeliveryType(source),
    };
    this.applyAppointmentFlowFromSource(source);
    this.applyMedicinesDatePrefix();

    this.toaster.add({
      severity: 'success',
      summary: 'Prescription Recalled',
      detail: `Today's IST prescription (${todayIst}) has been loaded into the form.`
    });
  }

  isRecordFromTodayIst(record: any): boolean {
    const today = this.getIstDateKey();
    return [record?.appointment_date, record?.visit_date, record?.created_at]
      .some((value) => this.toIstDateKey(value) === today);
  }

  get hasTodayIstPrescription(): boolean {
    return (this.filteredRecords || []).some((record: any) => this.isRecordFromTodayIst(record));
  }

  private getLatestTodayIstPrescription(): any | null {
    const todays = (this.filteredRecords || []).filter((record: any) => this.isRecordFromTodayIst(record));
    if (!todays.length) {
      return null;
    }

    return todays
      .slice()
      .sort((a: any, b: any) => this.getRecordDateValue(b) - this.getRecordDateValue(a))[0];
  }

  private getIstDateKey(value: Date = new Date()): string {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(value);

    const day = parts.find((p: any) => p.type === 'day')?.value || '01';
    const month = parts.find((p: any) => p.type === 'month')?.value || '01';
    const year = parts.find((p: any) => p.type === 'year')?.value || '1970';
    return `${year}-${month}-${day}`;
  }

  deleteReport(file: any, event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();

    const reportId = Number(file?.id || 0);
    if (!reportId) {
      this.toaster.warn('This report is not saved on server yet.', 'Not Deletable');
      return;
    }

    const reportName = file?.name || 'this report';
    this.confirmationService.confirm({
      header: 'Delete Report',
      message: `Delete "${reportName}"? This action cannot be undone.`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Delete',
      rejectLabel: 'Cancel',
      acceptIcon: 'none',
      rejectIcon: 'none',
      defaultFocus: 'reject',
      acceptButtonStyleClass: 'rx-delete-accept',
      rejectButtonStyleClass: 'rx-delete-reject',
      accept: () => this.executeReportDeletion(reportId),
    });
  }

  private executeReportDeletion(reportId: number) {
    if (this.deletingReportId === reportId) {
      return;
    }

    this.deletingReportId = reportId;
    this.prescriptionsService.deleteReports(reportId).subscribe({
      next: (res: any) => {
        this.deletingReportId = null;
        if (!res?.success) {
          this.toaster.error(res?.message || 'Unable to delete document.', 'Delete Failed');
          return;
        }

        this.removeReportFromGallery(reportId);
        this.toaster.success('Document deleted successfully.', 'Deleted');
        this.cdr.markForCheck();
      },
      error: (err) => {
        this.deletingReportId = null;
        const message = extractHttpErrorMessage(err, 'Unable to delete document. Please try again.');
        console.error('Report delete failed:', err);
        this.toaster.error(message, 'Delete Failed');
      }
    });
  }

  get totalReportsCount(): number {
    return (this.uploadsByDate || []).reduce((count: number, group: any) => {
      return count + (Array.isArray(group?.files) ? group.files.length : 0);
    }, 0);
  }

  get reportsImageCount(): number {
    return this.countReportsByType((type) => type.startsWith('image/'));
  }

  get reportsPdfCount(): number {
    return this.countReportsByType((type) => type === 'application/pdf');
  }

  get selectedReportGroup(): { date: any; files: any[] } | null {
    return this.uploadsByDate[this.selectedReportGroupIndex] ?? this.uploadsByDate[0] ?? null;
  }

  selectReportDateGroup(index: number): void {
    this.selectedReportGroupIndex = index;
  }

  triggerDocUpload(): void {
    this.docUploadInput?.nativeElement?.click();
  }

  onReportsDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.reportsDropActive = true;
  }

  onReportsDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.reportsDropActive = false;
  }

  onReportsDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.reportsDropActive = false;

    const files = Array.from(event.dataTransfer?.files || []);
    if (!files.length) {
      return;
    }

    this.onFileSelect({ target: { files, value: '' } });
  }

  removePendingFile(index: number, event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();
    this.pendingFiles = this.pendingFiles.filter((_, i) => i !== index);
    if (!this.pendingFiles.length) {
      this.resetSelectedFiles();
    }
  }

  formatFileSize(bytes: number): string {
    if (!bytes) {
      return '0 KB';
    }
    if (bytes >= 1024 * 1024) {
      return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
    }
    return `${Math.max(1, Math.round(bytes / 1024))} KB`;
  }

  getPendingFileIcon(file: File): string {
    if (file.type === 'application/pdf') {
      return 'pi-file-pdf';
    }
    if (file.type.startsWith('image/')) {
      return 'pi-image';
    }
    return 'pi-file';
  }

  getPendingFileIconClass(file: File): string {
    if (file.type === 'application/pdf') {
      return 'rd-pending-item-icon--pdf';
    }
    if (file.type.startsWith('image/')) {
      return 'rd-pending-item-icon--image';
    }
    return '';
  }

  private countReportsByType(predicate: (type: string) => boolean): number {
    return (this.uploadsByDate || []).reduce((count: number, group: any) => {
      const files = Array.isArray(group?.files) ? group.files : [];
      return count + files.filter((file: any) => predicate(String(file?.type || '').toLowerCase())).length;
    }, 0);
  }

  get selectedUploadSizeLabel(): string {
    const totalBytes = (this.pendingFiles || []).reduce((sum: number, file: File) => sum + (file.size || 0), 0);
    if (!totalBytes) {
      return '0 KB';
    }

    if (totalBytes >= 1024 * 1024) {
      return `${(totalBytes / (1024 * 1024)).toFixed(2)} MB`;
    }
    return `${Math.max(1, Math.round(totalBytes / 1024))} KB`;
  }

  getReportDateLabel(value: any): string {
    if (!value) {
      return '';
    }

    const dt = new Date(value);
    if (Number.isNaN(dt.getTime())) {
      return String(value);
    }

    return dt.toLocaleDateString('en-US', {
      weekday: 'short',
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  }

  getReportTypeLabel(file: any): string {
    const type = String(file?.type || '').toLowerCase();
    if (type.startsWith('image/')) {
      return 'Image';
    }
    if (type === 'application/pdf') {
      return 'PDF';
    }
    return (file?.name || '').split('.').pop()?.toUpperCase() || 'File';
  }

  get allReportRows(): Array<{ date: any; file: any }> {
    return this.reportRows;
  }

  private rebuildReportRows(): void {
    const rows: Array<{ date: any; file: any }> = [];
    for (const group of this.uploadsByDate || []) {
      const files = Array.isArray(group?.files) ? group.files : [];
      for (const file of files) {
        rows.push({ date: group.date, file });
      }
    }
    this.reportRows = rows;
  }

  get filteredReportRows(): Array<{ date: any; file: any }> {
    const query = (this.reportSearchQuery || '').trim().toLowerCase();
    const filter = this.reportFilterType;

    return this.allReportRows.filter(({ file }) => {
      const name = String(file?.name || '').toLowerCase();
      const type = String(file?.type || '').toLowerCase();

      const matchesQuery = !query || name.includes(query);
      let matchesFilter = true;

      if (filter === 'image') {
        matchesFilter = type.startsWith('image/');
      } else if (filter === 'pdf') {
        matchesFilter = type === 'application/pdf';
      }

      return matchesQuery && matchesFilter;
    });
  }

  setReportViewMode(mode: 'grid' | 'table'): void {
    this.reportViewMode = mode;
  }

  setReportFilterType(type: 'all' | 'image' | 'pdf'): void {
    this.reportFilterType = type;
  }

  clearReportSearch(): void {
    this.reportSearchQuery = '';
  }

  private resolveInitialPrescriptionNotes(existingNotes: string | null | undefined, appointmentNote: string): string {
    const saved = String(existingNotes || '').trim();
    if (saved) {
      this.clearReceptionNotesHighlight();
      return saved;
    }

    const seeded = String(appointmentNote || '').trim();
    if (seeded) {
      this.receptionNotesHighlightActive = true;
      this.receptionNotesSeed = seeded;
      return seeded;
    }

    this.clearReceptionNotesHighlight();
    return '';
  }

  onPrescriptionNotesChange(value: string): void {
    if (this.draftRestorePending) {
      return;
    }

    if (!this.receptionNotesHighlightActive) {
      return;
    }

    if (String(value || '').trim() !== this.receptionNotesSeed) {
      this.clearReceptionNotesHighlight();
    }
  }

  private clearReceptionNotesHighlight(): void {
    this.receptionNotesHighlightActive = false;
    this.receptionNotesSeed = '';
  }

  getReportFileIcon(file: any): string {
    const type = String(file?.type || '').toLowerCase();
    if (type === 'application/pdf') {
      return 'pi-file-pdf';
    }
    if (type.startsWith('image/')) {
      return 'pi-image';
    }
    return 'pi-file';
  }

  getReportFileIconClass(file: any): string {
    const type = String(file?.type || '').toLowerCase();
    if (type === 'application/pdf') {
      return 'rd-type-badge--pdf';
    }
    if (type.startsWith('image/')) {
      return 'rd-type-badge--image';
    }
    return 'rd-type-badge--file';
  }

  private removeReportFromGallery(reportId: number) {
    this.uploadsByDate = (this.uploadsByDate || [])
      .map((group: any) => ({
        ...group,
        files: (group?.files || []).filter((file: any) => Number(file?.id) !== reportId)
      }))
      .filter((group: any) => (group?.files || []).length > 0);

    this.rebuildReportRows();

    if (Number(this.viewingReportFile?.id) === reportId) {
      this.viewingReportFile = this.reportRows[0]?.file ?? null;
      if (this.reportViewerVisible) {
        this.closeReportViewer();
      }
    }
  }

  private refreshReportsForCurrentPatient() {
    const patientId = this.getCurrentPatientId();
    if (!patientId) {
      this.uploadsByDate = [];
      this.reportRows = [];
      this.selectedReportGroupIndex = 0;
      return;
    }

    this.prescriptionsService.getReportsByPatientId(patientId).subscribe({
      next: (rRes: any) => {
        this.applyPatientReports(rRes?.success ? (rRes.data || []) : []);
        this.selectedReportGroupIndex = 0;
      },
      error: () => {
        this.uploadsByDate = [];
        this.reportRows = [];
        this.selectedReportGroupIndex = 0;
      }
    });
  }

  //! Medicine Queue
  // loadAllMedicineQueue() {
  //   const clinicId = sessionStorage.getItem('clinic_id') || '1';
  //   const doctorId = sessionStorage.getItem('doctor_id') || '1';

  //   if (!clinicId || !doctorId) {
  //     this.toaster.add({
  //       severity: 'warn',
  //       summary: 'Missing Selection',
  //       detail: 'Select the clinic and doctor',
  //     });
  //     return;
  //   }

  //   this.appointmentService.getAllMedicineQueue({
  //     clinic_id: clinicId,
  //     doctor_id: doctorId,
  //   }).subscribe((res: any) => {
  //     if (res.success && res.data && res.data.appointments) {
  //       const appointments = res.data.appointments.map((appt: any) => ({
  //         appointment_id: appt.id,
  //         patient_id: appt.patient_id,
  //         clinic_id: appt.clinic_id,
  //         doctor_id: appt.doctor_id,
  //         date: appt.appointment_date,
  //         formatdate: this.formatDate(appt.appointment_date),
  //         time: this.formatTime(appt.start_time),
  //         status: appt.status,
  //         medicine_collection: appt.medicine_collection,
  //         prescription_id: appt.latest_prescription_id,
  //       }));

  //       const patientIds = appointments.map((a: any) => a.patient_id);

  //       // ✅ Fetch all patient details in one go
  //       // this.patientRegistrationService.getPatientsBatch(patientIds)
  //       //   .subscribe((patientRes: any) => {
  //       //     if (patientRes.success && patientRes.data) {
  //       //       const patientsMap = new Map();
  //       //       patientRes.data.forEach((p: any) => patientsMap.set(p.id, p));

  //       //       // ✅ Merge patient + appointment data
  //       //       this.allMedicineQueue = appointments.map((appt: any) => {
  //       //         const patient = patientsMap.get(appt.patient_id);
  //       //         return {
  //       //           id: patient.id,
  //       //           prescription_id: appt.prescription_id,
  //       //           name: `${patient.salutation} ${patient.full_name}`,
  //       //           full_name: patient.full_name,
  //       //           time: appt.time,
  //       //           date: appt.date,
  //       //           formatdate: appt.formatdate,
  //       //           status: appt.status,
  //       //           contact_number: patient.contact_number,
  //       //           salutation: patient.salutation,
  //       //           is_free: patient.is_free,
  //       //           card_id: patient.card_id,
  //       //           age: patient.age,
  //       //           appointment_id: appt.appointment_id,
  //       //           clinic_id: appt.clinic_id,
  //       //           doctor_id: appt.doctor_id,
  //       //           referred_by: patient.referred_by,
  //       //           referred_by_dr: patient.referred_by_dr,
  //       //           occupation: patient.occupation,
  //       //           medicines: '',
  //       //           personal_dues: 0,
  //       //           visit_fees: 0,
  //       //           received_online: 0,
  //       //           received_cash: 0,
  //       //           card_dues: 0,
  //       //           history: [],
  //       //         };
  //       //       });

  //       //       // ✅ Fetch prescriptions for each patient
  //       //       this.allMedicineQueue.forEach((queueItem) => {
  //       //         this.prescriptionsService.getPrescriptionsByPatientId(queueItem.id)
  //       //           .subscribe((res: any) => {
  //       //             if (res.success && res.data) {
  //       //               const prescriptions = res.data;
  //       //               const latest = prescriptions.length ? prescriptions[0] : {};

  //       //               queueItem.history = prescriptions;
  //       //               queueItem.medicines = latest.medicines || '';
  //       //               queueItem.personal_dues = latest.personal_dues || 0;
  //       //               queueItem.visit_fees = latest.visit_fees || 0;
  //       //               queueItem.received_online = latest.received_online || 0;
  //       //               queueItem.received_cash = latest.received_cash || 0;
  //       //               queueItem.card_dues = latest.card_dues || 0;
  //       //             } else {
  //       //               queueItem.medicines = '';
  //       //               queueItem.history = [];
  //       //               queueItem.personal_dues = 0;
  //       //               queueItem.visit_fees = 0;
  //       //               queueItem.received_online = 0;
  //       //               queueItem.received_cash = 0;
  //       //               queueItem.card_dues = 0;
  //       //             }
  //       //           });
  //       //       });

  //       //       // ✅ Sort by appointment date then time
  //       //       // ✅ Sort by date/time (latest first, correct chronological order)
  //       //       this.allMedicineQueue.sort((a, b) => {
  //       //         const dateA = new Date(a.raw_date || a.date);
  //       //         const dateB = new Date(b.raw_date || b.date);

  //       //         const dateCompare = dateB.getTime() - dateA.getTime(); // descending order
  //       //         if (dateCompare !== 0) return dateCompare;

  //       //         const timeA = a.time.padStart(5, '0');
  //       //         const timeB = b.time.padStart(5, '0');
  //       //         return timeB.localeCompare(timeA); // descending (latest first)
  //       //       });
  //       //     }
  //       //   });

  //       this.patientRegistrationService.getPatientsBatch(patientIds)
  //         .subscribe((patientRes: any) => {
  //           if (!(patientRes.success && patientRes.data)) return;

  //           // console.log(patientRes.data);
  //           const patientsMap = new Map(patientRes.data.map((p: any) => [p.id, p]));

  //           // Merge data -> Initial queue list
  //           this.allMedicineQueue = appointments.map((appt: any) => {
  //             const p: any = patientsMap.get(appt.patient_id);
  //             // console.log(p);
  //             return {
  //               id: p.id,
  //               appointment_id: appt.appointment_id,
  //               clinic_id: appt.clinic_id,
  //               doctor_id: appt.doctor_id,
  //               prescription_id: appt.prescription_id,
  //               name: `${p.salutation} ${p.full_name}`,
  //               full_name: p.full_name,
  //               time: appt.time,
  //               date: appt.date,
  //               formatdate: appt.formatdate,
  //               status: appt.status,
  //               medicine_collection: appt.medicine_collection,
  //               delivery_type: appt.delivery_type ?? (appt.is_courier ? 'home_delivery' : null),
  //               is_courier: appt.is_courier,
  //               contact_number: p.contact_number,
  //               is_free: p.is_free,
  //               card_id: p.card_id,
  //               age: p.age,
  //               referred_by: p.referred_by,
  //               referred_by_dr: p.referred_by_dr,
  //               occupation: p.occupation,
  //               medicines: '',
  //               personal_dues: 0,
  //               visit_fees: 0,
  //               received_online: 0,
  //               received_cash: 0,
  //               card_dues: 0,
  //               history: []
  //             };
  //           });

  //           // 🔥 Use SINGLE batch request instead of 50 API calls
  //           this.prescriptionsService.getLatestBatch(patientIds).subscribe((presRes: any) => {
  //             if (presRes.success && presRes.data) {
  //               const latestMap = new Map(presRes.data.map((p: any) =>
  //                 [p.appointment?.patient_id, p]
  //               ));

  //               this.allMedicineQueue = this.allMedicineQueue.map(item => {
  //                 const latest: any = latestMap.get(item.id);
  //                 // console.log(latest);
  //                 return {
  //                   ...item,
  //                   medicines: latest?.medicines || '',
  //                   personal_dues: latest?.personal_dues || 0,
  //                   visit_fees: latest?.visit_fees || 0,
  //                   received_online: latest?.received_online || 0,
  //                   received_cash: latest?.received_cash || 0,
  //                   card_dues: latest?.card_dues || 0,
  //                   is_courier: latest?.is_courier || false,
  //                   history: []  // Load only when needed separately
  //                 };
  //               });

  //               // Final sorting (if needed)
  //               this.allMedicineQueue.sort((a, b) => {
  //                 const d1 = new Date(a.date);
  //                 const d2 = new Date(b.date);
  //                 return d2.getTime() - d1.getTime() || b.time.localeCompare(a.time);
  //               });
  //             }
  //           });
  //       });

  //     } else {
  //       this.allMedicineQueue = [];
  //       this.toaster.add({
  //         severity: 'info',
  //         summary: 'No Records',
  //         detail: 'No patients in medicine queue.',
  //       });
  //     }
  //   });
  // }

  loadAllMedicineQueue() {
    const clinicId = sessionStorage.getItem('clinic_id') || '1';
    const doctorId = sessionStorage.getItem('doctor_id') || '1';

    if (!clinicId || !doctorId) {
      this.toaster.warn('Select clinic and doctor', 'Missing Selection');
      return;
    }

    this.appointmentService.getAllMedicineQueue({ clinic_id: clinicId, doctor_id: doctorId })
      .subscribe((res: any) => {
        // Support two common response shapes: { success:true, data: { appointments: [...] } }
        // and { success:true, data: [...] }
        const dataArr: any[] = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data?.appointments)
            ? res.data.appointments
            : [];

        if (!res.success || dataArr.length === 0) {
          this.allMedicineQueue = [];
          return;
        }

        // Normalize various field names from backend (id vs appointment_id, start_time vs appointment_time)
        this.allMedicineQueue = dataArr.map((a: any) => {
          const apptId = a.appointment_id ?? a.id ?? a.appointmentId ?? a.appointment?.id;
          const apptDate = a.appointment_date ?? a.date ?? a.appointment?.date;
          const apptTime = a.appointment_time ?? a.start_time ?? a.time ?? a.appointment?.time;
          const patientObj = a.patient ?? a.patient_data ?? a.patient_details ?? a.patientInfo ?? a.patient?.data;

          return {
            appointment_id: apptId,
            date: apptDate,
            time: apptTime,
            formatdate: this.formatDate(apptDate),
            status: a.status ?? a.state ?? '',
            medicine_collection: a.medicine_collection ?? a.medicineCollection ?? false,

            patient_id: patientObj?.id ?? a.patient_id ?? a.patientId ?? null,
            name: `${patientObj?.salutation && patientObj?.salutation !== 'null' ? patientObj?.salutation + ' ' : ''}${patientObj?.full_name ?? patientObj?.name ?? ''}`.trim(),
            full_name: patientObj?.full_name ?? patientObj?.name ?? '',
            patient_number: patientObj?.patient_number ?? a.patient_number ?? '',
            card_number: (patientObj?.patient_number ?? a.patient_number ?? '').split('-')[0] ?? '',
            contact_number: patientObj?.contact_number ?? patientObj?.phone ?? '',
            card_id: patientObj?.card_id ?? '',
            age: patientObj?.age ?? 0,
            age_months: patientObj?.age_months ?? 0,
            age_days: patientObj?.age_days ?? 0,
            is_free: patientObj?.is_free ?? false,

            medicines: '',
            personal_dues: 0,
            visit_fees: 0,
            received_cash: 0,
            received_online: 0,
            card_dues: 0,
            notes: '',
            delivery_type: a.delivery_type ?? (a.is_courier || a.isCourier ? 'home_delivery' : null),
            is_courier: a.is_courier ?? a.isCourier ?? false
          };
        });

        // Build appointment id list and filter out falsy ids
        const appointmentIds = this.allMedicineQueue.map(q => q.appointment_id).filter((id: any) => id != null);
        console.log('appointmentIds:', appointmentIds);

        if (appointmentIds.length === 0) return; // nothing to fetch

        // Fetch prescriptions by appointment IDs
        this.prescriptionsService.getPrescriptionsByAppointments(appointmentIds)
          .subscribe((presRes: any) => {
            if (!presRes.success || !Array.isArray(presRes.data)) return;

            const map = new Map(
              presRes.data.map((p: any) => [p.appointment_id ?? p.appointmentId ?? p.appointment?.id, p])
            );

            this.allMedicineQueue = this.allMedicineQueue.map(item => {
              const key = item.appointment_id;
              const p = map.get(key);
              return p ? { ...item, ...p } : item;
            });

            // Final sort (safely handle missing date/time)
            this.allMedicineQueue.sort((a, b) => {
              const tA = new Date((a.date ?? '') + ' ' + (a.time ?? ''))?.getTime() || 0;
              const tB = new Date((b.date ?? '') + ' ' + (b.time ?? ''))?.getTime() || 0;
              return tB - tA;
            });
          });
      });
  }

  private formatTime(time: string): string {
    if (!time) return '';
    const [hours, minutes] = time.split(':');
    return `${hours}:${minutes}`;
  }

  formatDisplayTime(value: any): string {
    if (!value) return '';

    // Handle "HH:mm" / "HH:mm:ss" strings from API.
    if (typeof value === 'string') {
      const timeMatch = value.trim().match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
      if (timeMatch) {
        const hours = Number(timeMatch[1]);
        const minutes = timeMatch[2];
        const period = hours >= 12 ? 'PM' : 'AM';
        const hour12 = hours % 12 || 12;
        return `${hour12}:${minutes} ${period}`;
      }
    }

    // Fallback for ISO date-time values or Date objects.
    const date = new Date(value);
    if (isNaN(date.getTime())) return String(value);

    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  }

  shouldShowWaitingBadge(item: any): boolean {
    const status = (item?.status || '').toLowerCase();
    return (status === 'checked in' || status === 'in progress') && !!this.getCheckInTimestamp(item);
  }

  formatWaitingTime(item: any): string {
    void this.waitingTimeTick;

    const start = this.getCheckInTimestamp(item);
    if (!start) {
      return '';
    }

    const elapsedMs = Math.max(0, Date.now() - start);
    const totalMinutes = Math.floor(elapsedMs / 60000);

    if (totalMinutes < 1) {
      return '<1 min';
    }

    if (totalMinutes < 60) {
      return `${totalMinutes} min`;
    }

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
  }

  isWaitingUrgent(item: any): boolean {
    void this.waitingTimeTick;
    const start = this.getCheckInTimestamp(item);
    if (!start) {
      return false;
    }
    return Date.now() - start >= 20 * 60 * 1000;
  }

  private getCheckInTimestamp(item: any): number | null {
    if (!item?.checked_in_at) {
      return null;
    }

    const timestamp = new Date(item.checked_in_at).getTime();
    return Number.isNaN(timestamp) ? null : timestamp;
  }

  /**
   * ✅ Format date to “8th Nov 25”
   */
  private formatDate(dateStr: string): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear().toString().slice(-2);
    const suffix = this.getOrdinalSuffix(day);
    return `${day}${suffix} ${month} ${year}`;
  }

  private getMedicinesDateHeader(): string {
    const [y, m, d] = todayDateString().split('-').map(Number);
    const dd = String(d).padStart(2, '0');
    const mm = String(m).padStart(2, '0');
    return `${dd}/${mm}/${y}`;
  }

  private getMedicinesDatePrefix(): string {
    return `${this.getMedicinesDateHeader()} == `;
  }

  private getMedicinesBody(value?: string | null): string {
    const text = String(value ?? this.prescription?.medicines ?? '');
    const header = this.getMedicinesDateHeader();
    const prefix = this.getMedicinesDatePrefix();
    const legacyPrefix = `${header} - `;

    if (text.startsWith(prefix)) {
      return text.slice(prefix.length);
    }

    if (text.startsWith(legacyPrefix)) {
      return text.slice(legacyPrefix.length);
    }

    if (
      text.trim() === header ||
      text.trim() === `${header} ==` ||
      text.trim() === `${header} -`
    ) {
      return '';
    }

    if (text.trimStart().startsWith(header)) {
      return text
        .trimStart()
        .slice(header.length)
        .replace(/^\s*(?:==|-)\s*/, '');
    }

    return text;
  }

  private composeMedicines(body?: string | null): string {
    const prefix = this.getMedicinesDatePrefix();
    const content = String(body ?? '').trimEnd();
    return content ? `${prefix}${content}` : prefix;
  }

  private ensureMedicinesDatePrefix(value?: string | null): string {
    const text = String(value ?? '').trim();
    if (!text) {
      return this.getMedicinesDatePrefix();
    }

    const header = this.getMedicinesDateHeader();
    if (text.startsWith(header)) {
      return this.composeMedicines(this.getMedicinesBody(text));
    }

    return this.composeMedicines(text);
  }

  private applyMedicinesDatePrefix(): void {
    this.prescription.medicines = this.ensureMedicinesDatePrefix(this.prescription.medicines);
    this.prescription.medicines_final = this.getMedicinesBody(this.prescription.medicines);
  }

  private refreshMedicinesDisplay(liveLine = ''): void {
    const saved = String(this.prescription.medicines_final || '').trim();
    const live = String(liveLine || '').trim();
    const body = live ? (saved ? `${saved}\n${live}` : live) : saved;
    this.prescription.medicines = this.composeMedicines(body);
  }

  onMedicinesChange(value: string): void {
    const header = this.getMedicinesDateHeader();
    const prefix = this.getMedicinesDatePrefix();

    if (!value || (!value.startsWith(prefix) && !value.trimStart().startsWith(header))) {
      this.prescription.medicines = this.composeMedicines(this.getMedicinesBody(value));
      this.prescription.medicines_final = this.getMedicinesBody(this.prescription.medicines);
      return;
    }

    if (value.startsWith(header) && !value.startsWith(prefix)) {
      const body = value.slice(header.length).replace(/^\s*(?:==|-)\s*/, '');
      this.prescription.medicines = this.composeMedicines(body);
      this.prescription.medicines_final = body;
      return;
    }

    this.prescription.medicines = value;
    this.prescription.medicines_final = this.getMedicinesBody(value);
  }

  /**
   * Helper to add correct suffix (st, nd, rd, th)
   */
  private getOrdinalSuffix(day: number): string {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  /** Append a common condition to chief complaints (comma-separated, no duplicates). */
  appendChiefComplaintBadge(term: string) {
    const label = (term || '').trim();
    if (!label) {
      return;
    }

    const current = (this.prescription.chief_complaints || '').trim();
    const alreadyPresent = current
      .split(',')
      .map((part: string) => part.trim().toLowerCase())
      .includes(label.toLowerCase());

    if (alreadyPresent) {
      return;
    }

    this.prescription.chief_complaints = current ? `${current}, ${label}` : label;
  }

  toggleChiefComplaintBadge(term: string) {
    if (this.isChiefComplaintBadgeActive(term)) {
      this.removeChiefComplaintPart(term);
    } else {
      this.appendChiefComplaintBadge(term);
    }
  }

  getChiefComplaintParts(): string[] {
    return (this.prescription.chief_complaints || '')
      .split(',')
      .map((part: string) => part.trim())
      .filter(Boolean);
  }

  removeChiefComplaintPart(part: string) {
    const target = (part || '').trim().toLowerCase();
    if (!target) {
      return;
    }

    const remaining = this.getChiefComplaintParts().filter(
      (item) => item.toLowerCase() !== target
    );
    this.prescription.chief_complaints = remaining.join(', ');
  }

  isFieldRecording(fieldId: string): boolean {
    return this.isRecording && this.activeField === fieldId;
  }

  isFieldDictationBlocked(fieldId: string): boolean {
    return this.isRecording && this.activeField !== fieldId;
  }

  isChiefComplaintBadgeActive(term: string): boolean {
    const label = (term || '').trim().toLowerCase();
    if (!label) {
      return false;
    }

    return (this.prescription.chief_complaints || '')
      .split(',')
      .map((part: string) => part.trim().toLowerCase())
      .includes(label);
  }

  // 🧹 Clear a specific prescription field and reset dictation buffers
  clearField(fieldId: string) {
    if (fieldId === 'notes') {
      this.clearReceptionNotesHighlight();
    }

    // Reset visible text
    if (fieldId === 'medicines') {
      this.prescription.medicines = this.getMedicinesDatePrefix();
      this.prescription.medicines_final = '';
    } else {
      this.prescription[fieldId] = '';
      this.prescription[fieldId + '_final'] = '';
    }

    // Reset dictation buffers
    this.sentenceBuffer = '';
    this.lastFinalChunk = '';
    this.interimTranscript = '';

    // Optional: stop any current pause timers
    clearTimeout(this.pauseTimer);

    this.toaster.info('The field has been reset.', 'Cleared', { life: 2000 });
  }

  // old code
  // isFormValid(): boolean {
  //   // ✅ Check if medicines field has content
  //   const hasMedicines = this.prescription.medicines && this.prescription.medicines.trim().length > 0;

  //   // ✅ Check if at least one field is filled (chief_complaints, diagnosis, or summary)
  //   const hasComplaintOrDiagnosis = 
  //     (this.prescription.chief_complaints && this.prescription.chief_complaints.trim().length > 0) ||
  //     (this.prescription.diagnosis && this.prescription.diagnosis.trim().length > 0) ||
  //     (this.prescription.summary && this.prescription.summary.trim().length > 0);

  //   // ✅ Check if visit_fees is a positive number
  //   const hasFees = this.prescription.visit_fees !== null && 
  //                   this.prescription.visit_fees !== undefined && 
  //                   this.prescription.visit_fees > 0;

  //   // ✅ Check if patient is selected
  //   const hasPatient = this.patient.patient_id && this.patient.patient_id > 0;

  //   return hasMedicines && hasComplaintOrDiagnosis && hasFees && hasPatient;
  // }

  //! new code handles is free / 100% discount scenario
  isFormValid(): boolean {
    const hasPatient =
      (!!this.patient?.patient_id && this.patient.patient_id > 0) ||
      (!!this.patient?.id && this.patient.id > 0);

    const isFree = !!this.patient?.is_free;
    const visitFees = Number(this.prescription?.visit_fees ?? 0);
    const fullDiscount =
      normalizeDiscountPercent(this.prescription?.discount_percent) >= 100;
    // Zero fee is allowed for free patients or a full (100%) visit discount.
    const hasFees = isFree || fullDiscount || visitFees > 0;
    const hasPatientDetails = !this.getPatientSaveValidationError();

    return hasFees && hasPatient && hasPatientDetails;
  }

  openQueueSidebar() {
    if (this.isPatientVisible) {
      this.isPatientVisible = false;
      this.queueKeyboardIndex = -1;
      return;
    }
    this.consultationQueueSearchTerm = '';
    this.loadQueue();
    this.isPatientVisible = true;
    if (this.filteredConsultationQueue.length > 0 && this.queueKeyboardIndex < 0) {
      this.queueKeyboardIndex = 0;
    }
    setTimeout(() => this.focusConsultationQueueSearch(), 80);
  }

  openPatientSearch() {
    this.isPatientVisible = false;
    this.queueKeyboardIndex = -1;
    setTimeout(() => this.focusPatientSearchInput(), 80);
  }

  private focusPatientSearchInput(): void {
    const inputEl = this.headerPatientSearchAuto?.inputEL?.nativeElement as HTMLInputElement | undefined
      ?? this.patientSearchAuto?.inputEL?.nativeElement as HTMLInputElement | undefined;
    inputEl?.focus();
    inputEl?.select();
  }

  openCommandPalette(): void {
    this.commandPaletteVisible = true;
    this.commandPaletteQuery = '';
    this.commandPaletteIndex = 0;
    this.commandPalettePatients = [];
    this.commandPaletteSearching = false;
    this.rebuildCommandPaletteItems();
    setTimeout(() => {
      const input = this.commandPaletteInput?.nativeElement;
      input?.focus();
      input?.select();
    }, 60);
  }

  closeCommandPalette(): void {
    this.commandPaletteVisible = false;
    this.commandPaletteQuery = '';
    this.commandPalettePatients = [];
    this.commandPaletteSearching = false;
  }

  onCommandPaletteQueryChange(): void {
    this.commandPaletteIndex = 0;
    const query = (this.commandPaletteQuery || '').trim();
    if (query.length < 2) {
      this.commandPalettePatients = [];
      this.commandPaletteSearching = false;
      this.rebuildCommandPaletteItems();
      return;
    }

    this.searchCommandPalettePatients(query);
  }

  onCommandPaletteKeydown(event: KeyboardEvent): void {
    const key = event.key;
    if (key === 'ArrowDown') {
      event.preventDefault();
      if (this.commandPaletteItems.length) {
        this.commandPaletteIndex = Math.min(
          this.commandPaletteItems.length - 1,
          this.commandPaletteIndex + 1,
        );
      }
      return;
    }
    if (key === 'ArrowUp') {
      event.preventDefault();
      this.commandPaletteIndex = Math.max(0, this.commandPaletteIndex - 1);
      return;
    }
    if (key === 'Enter') {
      event.preventDefault();
      const item = this.commandPaletteItems[this.commandPaletteIndex];
      if (item) {
        this.executeCommandPaletteItem(item);
      }
      return;
    }
    if (key === 'Escape') {
      event.preventDefault();
      this.closeCommandPalette();
    }
  }

  executeCommandPaletteItem(item: CommandPaletteItem): void {
    this.closeCommandPalette();

    switch (item.kind) {
      case 'action':
        this.runCommandPaletteAction(item.id);
        break;
      case 'patient':
        this.onPatientSelect({ value: item.payload });
        break;
      case 'open':
        this.switchToOpenConsultation(item.payload as OpenConsultationEntry);
        break;
    }
  }

  private runCommandPaletteAction(actionId: string): void {
    switch (actionId) {
      case 'save':
        this.savePrescriptionViaHotkey();
        break;
      case 'queue':
        this.openQueueSidebar();
        break;
      case 'find':
        this.openPatientSearch();
        break;
      case 'add':
        this.openQuickAddDialog();
        break;
      case 'medicine':
        this.openMedicineQueueSidebar();
        break;
      case 'notes':
        this.openNotesDialog();
        break;
      case 'shortcuts':
        this.hotkeysHelpVisible = true;
        break;
      case 'queue-board':
        this.router.navigate(['/admin/queue-board']);
        break;
    }
  }

  private searchCommandPalettePatients(query: string): void {
    const token = ++this.commandPaletteSearchToken;
    this.commandPaletteSearching = true;
    this.rebuildCommandPaletteItems();

    this.http.get<any>(this.apiUrl + '/patient/search', {
      params: { q: query },
      ...this.getAuthHeaders(),
    }).subscribe({
      next: (res) => {
        if (token !== this.commandPaletteSearchToken) {
          return;
        }

        this.commandPalettePatients = (res?.data || []).map((p: any) => ({
          ...p,
          search_label: `${p.full_name} (${p.patient_number || '—'})`,
        }));
        this.commandPaletteSearching = false;
        this.rebuildCommandPaletteItems();
        this.cdr.detectChanges();
      },
      error: () => {
        if (token !== this.commandPaletteSearchToken) {
          return;
        }
        this.commandPalettePatients = [];
        this.commandPaletteSearching = false;
        this.rebuildCommandPaletteItems();
        this.cdr.detectChanges();
      },
    });
  }

  private rebuildCommandPaletteItems(): void {
    const query = (this.commandPaletteQuery || '').trim().toLowerCase();
    const items: CommandPaletteItem[] = [];

    const matchesQuery = (label: string, sublabel?: string) => {
      if (!query) {
        return true;
      }
      const haystack = `${label} ${sublabel || ''}`.toLowerCase();
      return haystack.includes(query);
    };

    this.commandPaletteActions
      .filter((action) => matchesQuery(action.label))
      .forEach((action) => items.push({ ...action }));

    (this.openConsultations || [])
      .filter((entry) => matchesQuery(entry.display_name, entry.patient_number))
      .forEach((entry) => {
        items.push({
          id: `open-${entry.patient_id}`,
          kind: 'open',
          label: entry.display_name,
          sublabel: entry.patient_number ? `#${entry.patient_number}` : 'Open consultation',
          icon: 'pi-bookmark',
          payload: entry,
        });
      });

    (this.commandPalettePatients || [])
      .filter((patient) => matchesQuery(patient.full_name || '', patient.patient_number))
      .forEach((patient) => {
        items.push({
          id: `patient-${patient.id}`,
          kind: 'patient',
          label: patient.full_name || 'Patient',
          sublabel: patient.patient_number ? `#${patient.patient_number}` : undefined,
          icon: 'pi-user',
          payload: patient,
        });
      });

    this.commandPaletteItems = items;
    if (this.commandPaletteIndex >= items.length) {
      this.commandPaletteIndex = Math.max(0, items.length - 1);
    }
  }

  get consultationQueueCount(): number {
    return this.filteredConsultationQueue.length;
  }

  private get consultationQueueBase(): any[] {
    const base = this.queue || [];
    switch (this.consultationStatusFilter) {
      case 'waiting':
        return base.filter((item: any) => ['checked in', 'scheduled'].includes(item.status));
      case 'with_doctor':
        return base.filter((item: any) => item.status === 'in progress');
      case 'paused':
        return base.filter((item: any) => item.status === 'paused');
      case 'done':
        return base.filter((item: any) => ['completed', 'medicine'].includes(item.status));
      default:
        return base.filter((item: any) =>
          ['checked in', 'in progress', 'paused'].includes(item.status),
        );
    }
  }

  get consultationStatusCounts(): Record<ConsultationQueueStatusFilter, number> {
    const base = this.queue || [];
    return {
      all: base.filter((item: any) =>
        ['checked in', 'in progress', 'paused'].includes(item.status),
      ).length,
      waiting: base.filter((item: any) => ['checked in', 'scheduled'].includes(item.status)).length,
      with_doctor: base.filter((item: any) => item.status === 'in progress').length,
      paused: base.filter((item: any) => item.status === 'paused').length,
      done: base.filter((item: any) => ['completed', 'medicine'].includes(item.status)).length,
    };
  }

  get openConsultationDock(): OpenConsultationEntry[] {
    const activeId = this.getCurrentPatientId();
    return [...this.openConsultations].sort((a, b) => {
      if (a.patient_id === activeId) {
        return -1;
      }
      if (b.patient_id === activeId) {
        return 1;
      }
      return new Date(b.last_opened_at).getTime() - new Date(a.last_opened_at).getTime();
    });
  }

  isActiveOpenConsultation(entry: OpenConsultationEntry): boolean {
    return this.getCurrentPatientId() === Number(entry.patient_id);
  }

  getOpenChipTone(entry: OpenConsultationEntry): string {
    return this.openChipTones[Number(entry.patient_id) % this.openChipTones.length];
  }

  private stripSalutation(raw: string): string {
    const name = (raw || '').trim();
    for (const s of this.patientSalutations) {
      if (name.startsWith(s + ' ')) {
        return name.slice(s.length + 1).trim();
      }
    }
    return name;
  }

  getOpenChipInitials(entry: OpenConsultationEntry): string {
    const name = this.stripSalutation(entry.display_name || '');
    const parts = name.split(/\s+/).filter(Boolean);
    if (!parts.length) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  getOpenChipName(entry: OpenConsultationEntry): string {
    const name = this.stripSalutation(entry.display_name || '');
    const parts = name.split(/\s+/).filter(Boolean);
    if (!parts.length) return 'Patient';
    if (parts.length === 1) {
      return parts[0].length > 12 ? parts[0].slice(0, 11) + '…' : parts[0];
    }
    const firstName = parts[0];
    const lastInit = parts[parts.length - 1][0].toUpperCase() + '.';
    const compact = `${firstName} ${lastInit}`;
    return compact.length > 14 ? firstName : compact;
  }

  getOpenChipNumber(entry: OpenConsultationEntry): string {
    const raw = (entry.patient_number || '').trim();
    if (!raw) return '';
    const short = raw.split('-')[0] || raw;
    return short.length > 10 ? short.slice(0, 9) + '…' : short;
  }

  getOpenChipTooltip(entry: OpenConsultationEntry): string {
    const fullName = (entry.display_name || 'Patient').trim();
    const number = (entry.patient_number || '').trim();
    const active = this.isActiveOpenConsultation(entry);
    const lines: string[] = [fullName];
    if (number) lines.push(`Patient #${number}`);
    if (active) lines.push('Currently open');
    return lines.join('\n');
  }

  switchToOpenConsultation(entry: OpenConsultationEntry): void {
    if (this.isActiveOpenConsultation(entry)) {
      this.isPatientVisible = false;
      return;
    }

    const patientId = Number(entry.patient_id);
    if (this.switchingPatientId === patientId) {
      return;
    }

    const queueItem = (this.queue || []).find(
      (item: any) =>
        Number(item.patient_id) === patientId ||
        (Number(entry.appointment_id) > 0 &&
          Number(item.appointment_id) === Number(entry.appointment_id)),
    );

    const target = queueItem || {
      patient_id: patientId,
      appointment_id: entry.appointment_id,
      name: entry.display_name,
      full_name: entry.display_name,
      patient_number: entry.patient_number,
    };

    this.requestPatientSwitch(target, (loadGen) => {
      if (queueItem && this.prescribedAppointmentStatuses.includes(queueItem.status)) {
        this.switchingPatientId = 0;
        this.handleAlreadyPrescribedPatient(patientId, { removeFromDock: true });
        return;
      }

      if (Number(queueItem?.appointment_id) > 0) {
        this.applySelectPatient(queueItem, loadGen);
        return;
      }

      if (Number(entry.appointment_id) > 0) {
        this.applySelectPatient(target, loadGen, { rejectIfPrescribed: true });
        return;
      }

      this.resolveTodayAppointmentForPatient(patientId, ({ open, prescribed }) => {
        if (!this.isPatientLoadCurrent(loadGen)) {
          return;
        }

        if (prescribed) {
          this.switchingPatientId = 0;
          this.handleAlreadyPrescribedPatient(patientId, { removeFromDock: true });
          return;
        }

        if (open) {
          this.applySelectPatient(this.buildQueueSelectionFromAppointment(open), loadGen);
          return;
        }

        this.switchingPatientId = 0;
        this.applyLoadPatientFromSearch(patientId, loadGen);
      });
    });
  }

  trackOpenConsultation(_index: number, entry: OpenConsultationEntry): number {
    return Number(entry.patient_id);
  }

  isSwitchingToOpenConsultation(entry: OpenConsultationEntry): boolean {
    return (
      this.switchingPatientId > 0 &&
      Number(entry.patient_id) === this.switchingPatientId &&
      !this.isActiveOpenConsultation(entry)
    );
  }

  dismissOpenConsultation(entry: OpenConsultationEntry, event: Event): void {
    event.stopPropagation();
    event.preventDefault();

    const patientId = Number(entry.patient_id);
    if (!patientId) {
      return;
    }

    if (this.isActiveOpenConsultation(entry)) {
      this.invalidatePatientLoad();
      this.patientSelectedFromSearch = false;
      this.clearForm();
    }

    this.clearTodayDraftForPatient(patientId);
    this.removePatientFromOpenConsultationDock(patientId);
  }

  get consultationFlowCounts(): FlowCounts {
    const list = this.consultationQueueBase;
    return {
      all: list.length,
      medicine: list.filter((item: any) => !!item?.medicine_collection).length,
      normal: list.filter((item: any) => matchesFlowFilter(item, 'normal')).length,
      home_delivery: list.filter((item: any) => resolveDeliveryType(item) === 'home_delivery').length,
      domestic: list.filter((item: any) => resolveDeliveryType(item) === 'domestic').length,
      international: list.filter((item: any) => resolveDeliveryType(item) === 'international').length,
    };
  }

  get filteredConsultationQueue(): any[] {
    const term = (this.consultationQueueSearchTerm || '').trim().toLowerCase();
    return this.consultationQueueBase.filter((item: any) =>
      matchesFlowFilter(item, this.consultationFlowFilter) &&
      this.matchesQueueSearch(item, term),
    );
  }

  clearConsultationQueueSearch(): void {
    this.consultationQueueSearchTerm = '';
  }

  private focusConsultationQueueSearch(): void {
    this.consultationQueueSearchInput?.nativeElement?.focus();
  }

  get medicineQueueFlowCounts(): FlowCounts {
    const list = this.allMedicineQueue || [];
    return {
      all: list.length,
      medicine: list.filter((item: any) => !!item?.medicine_collection).length,
      normal: list.filter((item: any) => matchesFlowFilter(item, 'normal')).length,
      home_delivery: list.filter((item: any) => resolveDeliveryType(item) === 'home_delivery').length,
      domestic: list.filter((item: any) => resolveDeliveryType(item) === 'domestic').length,
      international: list.filter((item: any) => resolveDeliveryType(item) === 'international').length,
    };
  }

  get filteredMedicineCollectionQueue(): any[] {
    const term = (this.medicineQueueSearchTerm || '').trim().toLowerCase();
    return (this.allMedicineQueue || []).filter((item: any) =>
      matchesFlowFilter(item, this.medicineQueueFlowFilter) &&
      this.matchesQueueSearch(item, term),
    );
  }

  clearMedicineQueueSearch(): void {
    this.medicineQueueSearchTerm = '';
  }

  private matchesQueueSearch(item: any, term: string): boolean {
    if (!term) {
      return true;
    }

    const haystack = [
      item?.name,
      item?.full_name,
      item?.patient_number,
      item?.card_number,
      item?.card_id,
      item?.contact_number,
    ]
      .map((value) => String(value ?? '').toLowerCase())
      .join(' ');

    return haystack.includes(term);
  }

  isDeliveryTypeActive(type: DeliveryType): boolean {
    return this.appointmentDeliveryType === type;
  }

  get activeDeliverySummary(): string {
    if (this.isMedicineCollection) {
      return 'Medicine Pickup';
    }
    return deliveryTypeLabel(this.appointmentDeliveryType) || 'Not selected';
  }

  getDeliveryOptionTooltip(option: {
    value: DeliveryType;
    label: string;
    shortLabel: string;
  }): string {
    const descriptions: Record<DeliveryType, string> = {
      home_delivery: 'Deliver medicines to the patient\'s home',
      domestic: 'Ship medicines within India',
      international: 'Ship medicines outside India',
    };
    return `${option.label}\n${descriptions[option.value]}\nShortcut: Alt + C`;
  }

  getDeliveryType(item: any): DeliveryType | null {
    return resolveDeliveryType(item);
  }

  getDeliveryBadgeLabel(item: any): string {
    return deliveryTypeLabel(resolveDeliveryType(item));
  }

  getDeliveryBadgeShort(item: any): string {
    return deliveryTypeShortLabel(resolveDeliveryType(item));
  }

  getDeliveryBadgeIcon(item: any): string {
    return deliveryBadgeIcon(resolveDeliveryType(item));
  }

  openMedicineQueueSidebar() {
    if (this.isMedicineVisible) {
      this.isMedicineVisible = false;
      return;
    }
    this.medicineQueueSearchTerm = '';
    this.loadAllMedicineQueue();
    this.isMedicineVisible = true;
    setTimeout(() => this.focusMedicineQueueSearch(), 80);
  }

  private focusMedicineQueueSearch(): void {
    this.medicineQueueSearchInput?.nativeElement?.focus();
  }

  private loadPatientPayments(patientId: number): void {
    if (!patientId) {
      this.patientPayments = null;
      this.patientPaymentsLoading = false;
      this.patientPaymentsError = false;
      return;
    }

    const requestId = ++this.patientPaymentsRequest;
    this.patientPaymentsLoading = true;
    this.patientPaymentsError = false;
    this.analytics.getPatientPaymentLedger(patientId).subscribe({
      next: (res: any) => {
        if (requestId !== this.patientPaymentsRequest) {
          return;
        }
        const patient = res?.success ? res.patient : null;
        if (patient?.lines) {
          patient.lines = [...patient.lines].reverse();
        }
        this.patientPayments = patient;
        this.patientPaymentsFromLedger = !!res?.success;
        this.patientPaymentsLoading = false;
        this.patientPaymentsError = !res?.success;
        if (!res?.success) {
          this.useVisitPaymentsIfNeeded();
        }
        this.cdr.markForCheck();
      },
      error: () => {
        if (requestId !== this.patientPaymentsRequest) {
          return;
        }
        this.patientPaymentsLoading = false;
        this.patientPaymentsFromLedger = false;
        this.useVisitPaymentsIfNeeded(true);
        this.cdr.markForCheck();
      },
    });
  }

  private useVisitPaymentsIfNeeded(force = false): void {
    if (this.patientPaymentsFromLedger && !force) {
      return;
    }
    const built = this.paymentsFromVisitHistory();
    if (built.lines.length) {
      this.patientPayments = built;
      this.patientPaymentsError = false;
      return;
    }
    if (force || !this.patientPaymentsLoading) {
      this.patientPayments = built;
      this.patientPaymentsError = force;
    }
  }

  private paymentsFromVisitHistory(): any {
    const lines = (this.filteredRecords || []).map((record: any) => {
      const fees = Math.round(Number(record?.visit_fees) || 0);
      const cash = Math.round(Number(record?.received_cash) || 0);
      const online = Math.round(Number(record?.received_online) || 0);
      return {
        kind: 'visit',
        date: String(record?.appointment_date || record?.visit_date || '').slice(0, 10),
        fees,
        cash,
        online,
        collected: cash + online,
        pending: fees - (cash + online),
        discount_percent: Math.round(Number(record?.discount_percent) || 0),
      };
    });
    const total = (key: 'fees' | 'collected') => lines.reduce((sum, line) => sum + line[key], 0);
    return {
      visits: lines.length,
      fees: total('fees'),
      collected: total('collected'),
      outstanding: Math.round(Number(this.filteredRecords?.[0]?.personal_dues) || 0),
      lines,
    };
  }

  paymentAmount(value: unknown): string {
    const amount = Number(value ?? 0);
    if (!Number.isFinite(amount)) {
      return '0';
    }
    return amount.toLocaleString('en-IN');
  }

  paymentLineTone(line: any): string {
    if (line?.kind === 'dues') {
      return 'is-dues';
    }
    if (line?.pending > 0) {
      return 'is-short';
    }
    if (line?.pending < 0) {
      return 'is-extra';
    }
    return 'is-settled';
  }

  paymentLineNote(line: any): string {
    if (line?.kind === 'dues') {
      const mode = line.mode || 'Payment';
      return `${mode} of ₹${this.paymentAmount(line.collected)} settled older dues.`;
    }
    if (line?.pending > 0) {
      return `₹${this.paymentAmount(line.pending)} of this visit fee is still unpaid.`;
    }
    if (line?.pending < 0) {
      return `₹${this.paymentAmount(Math.abs(line.pending))} above the visit fee went toward earlier dues.`;
    }
    return 'The visit fee was collected in full.';
  }

  paymentLineResult(line: any): string {
    if (line?.kind === 'dues') {
      return line.mode ? `${line.mode} dues` : 'Older dues';
    }
    if (line?.pending > 0) {
      return `Unpaid ₹${this.paymentAmount(line.pending)}`;
    }
    if (line?.pending < 0) {
      return `Extra ₹${this.paymentAmount(Math.abs(line.pending))}`;
    }
    return 'Paid';
  }

  paymentLineDate(value: string): string {
    if (!value) {
      return '—';
    }
    const parsed = new Date(value.includes('T') ? value : `${value}T00:00:00`);
    if (Number.isNaN(parsed.getTime())) {
      return value;
    }
    return parsed.toLocaleDateString('en-IN', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  }

  get hasSelectedPatient(): boolean {
    return !!(
      (this.patient && this.patient.patient_id && Number(this.patient.patient_id) > 0) ||
      (this.patient && this.patient.id && Number(this.patient.id) > 0)
    );
  }

  get currentPatientDisplayName(): string {
    const salutation = (this.patient?.salutation || '').trim();
    const fullName = (this.patient?.full_name || '').trim();
    return [salutation, fullName].filter(Boolean).join(' ') || 'Patient';
  }

  get hasUnsavedWork(): boolean {
    if (!this.hasSelectedPatient || !this.hasDraftableContent()) {
      return false;
    }
    return this.getDraftFingerprint() !== this.lastDraftFingerprint;
  }

  private resolvePatientIdFromSelection(source: any): number {
    return Number(source?.patient_id || source?.id || 0);
  }

  private resolvePatientDisplayName(source: any): string {
    const salutation = (source?.salutation || '').trim();
    const fullName = (source?.full_name || source?.name || '').trim();
    return [salutation, fullName].filter(Boolean).join(' ') || 'this patient';
  }

  private getOpenConsultationsStorageKey(): string {
    const clinicId = this.workContext.getClinicId() || this.clinicId || 0;
    const doctorId = this.workContext.getDoctorId() || this.doctorId || 0;
    return `${this.openConsultationsStoragePrefix}_${clinicId}_${doctorId}_${this.getTodayDateKey()}`;
  }

  private loadOpenConsultationsFromStorage(): void {
    try {
      const raw = localStorage.getItem(this.getOpenConsultationsStorageKey());
      const parsed = raw ? JSON.parse(raw) : [];
      this.openConsultations = Array.isArray(parsed)
        ? parsed
            .map((entry: any) => ({
              patient_id: Number(entry?.patient_id || 0),
              appointment_id: Number(entry?.appointment_id || 0),
              display_name: String(entry?.display_name || '').trim(),
              patient_number: entry?.patient_number ? String(entry.patient_number) : '',
              last_opened_at: entry?.last_opened_at || new Date().toISOString(),
            }))
            .filter((entry: OpenConsultationEntry) => entry.patient_id > 0)
            .slice(0, this.maxOpenConsultations)
        : [];
    } catch {
      this.openConsultations = [];
    }
  }

  private saveOpenConsultationsToStorage(): void {
    try {
      localStorage.setItem(
        this.getOpenConsultationsStorageKey(),
        JSON.stringify(this.openConsultations.slice(0, this.maxOpenConsultations)),
      );
    } catch (err) {
      console.error('Unable to persist open consultations:', err);
    }
  }

  private syncOpenConsultationDock(): void {
    const patientId = this.getCurrentPatientId();
    if (!patientId) {
      return;
    }

    const displayName = this.currentPatientDisplayName;
    const appointmentId = Number(this.prescription?.appointment_id || 0);
    const now = new Date().toISOString();
    const existingIndex = this.openConsultations.findIndex(
      (entry) => Number(entry.patient_id) === patientId,
    );

    const nextEntry: OpenConsultationEntry = {
      patient_id: patientId,
      appointment_id: appointmentId,
      display_name: displayName,
      patient_number: this.patient?.patient_number || '',
      last_opened_at: now,
    };

    if (existingIndex >= 0) {
      this.openConsultations[existingIndex] = {
        ...this.openConsultations[existingIndex],
        ...nextEntry,
        appointment_id: appointmentId || this.openConsultations[existingIndex].appointment_id,
      };
    } else {
      this.openConsultations.unshift(nextEntry);
    }

    if (this.openConsultations.length > this.maxOpenConsultations) {
      const activeId = patientId;
      const removable = [...this.openConsultations]
        .filter((entry) => Number(entry.patient_id) !== activeId)
        .sort(
          (a, b) =>
            new Date(a.last_opened_at).getTime() - new Date(b.last_opened_at).getTime(),
        );
      const overflow = this.openConsultations.length - this.maxOpenConsultations;
      const removeIds = new Set(removable.slice(0, overflow).map((entry) => entry.patient_id));
      this.openConsultations = this.openConsultations.filter(
        (entry) => !removeIds.has(entry.patient_id),
      );
    }

    this.saveOpenConsultationsToStorage();
  }

  private pauseCurrentAppointment(): void {
    // Look up the queue item by patient_id first — this is reliable even
    // when this.prescription.appointment_id hasn't been populated yet.
    const currentPatientId = this.getCurrentPatientId();
    const queueItem = currentPatientId
      ? (this.queue || []).find(
          (item: any) => Number(item.patient_id) === currentPatientId,
        )
      : null;

    const appointmentId = Number(
      queueItem?.appointment_id ||
        this.prescription?.appointment_id ||
        this.pendingInProgressAppointmentId ||
        0,
    );
    if (!appointmentId) {
      return;
    }

    const currentStatus = queueItem?.status || this.patient?.status1 || '';
    const leavingInFlight = appointmentId === this.pendingInProgressAppointmentId;
    if (!leavingInFlight && !['in progress', 'checked in'].includes(currentStatus)) {
      return;
    }

    this.pendingInProgressAppointmentId = 0;
    this.appointmentService.changeStatus(appointmentId, 'paused').subscribe({
      next: (res: any) => {
        if (res?.success) {
          this.scheduleQueueRefresh();
        }
      },
      error: (err) => console.error('Error pausing appointment:', err),
    });
  }

  private requestPatientSwitch(target: any, proceed: (loadGen: number) => void): void {
    const nextPatientId = this.resolvePatientIdFromSelection(target);
    if (!nextPatientId) {
      return;
    }

    const currentPatientId = this.getCurrentPatientId();
    if (currentPatientId > 0 && currentPatientId === nextPatientId) {
      this.isPatientVisible = false;
      this.switchingPatientId = 0;
      return;
    }

    if (currentPatientId > 0) {
      this.pendingReturnConsultation = this.captureReturnConsultation(currentPatientId);
      this.flushDraftForCurrentPatient();
      this.pauseCurrentAppointment();
    }

    this.switchingPatientId = nextPatientId;
    proceed(this.beginPatientLoad());
  }

  private flushDraftForCurrentPatient(): void {
    const patientId = this.getCurrentPatientId();
    if (!patientId || !this.hasDraftableContent()) {
      return;
    }

    const wasSuppressed = this.draftSaveSuppressed;
    this.draftSaveSuppressed = false;
    this.persistDraftSnapshot(patientId);
    if (wasSuppressed) {
      this.draftSaveSuppressed = true;
    }
  }

  openNotesDialog() {
    if (!this.hasSelectedPatient) {
      return;
    }
    this.notesDialogVisible = true;
  }

  get hasAppointmentIntakeNote(): boolean {
    return !!(this.appointmentIntakeNote || '').trim();
  }

  getMedicineIntentShort(value: MedicineIntent | null | undefined): string {
    return medicineIntentShortLabel(value);
  }

  getMedicineIntentTitle(value: MedicineIntent | null | undefined): string {
    return medicineIntentTitle(value);
  }

  getReceptionNoteTooltip(
    note: string | null | undefined,
    intent: MedicineIntent | null | undefined,
  ): string {
    return receptionNoteTooltip(note, intent);
  }

  copyAppointmentIntakeNote(): void {
    const text = (this.appointmentIntakeNote || '').trim();
    if (!text) {
      return;
    }

    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(text).then(
        () => this.toaster.success('Reception note copied'),
        () => this.toaster.error('Could not copy to clipboard'),
      );
      return;
    }

    this.toaster.error('Clipboard is not available in this browser');
  }

  copyContactNumber(): void {
    const text = String(this.patient?.contact_number || '').trim();
    if (!text) {
      return;
    }

    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(text).then(
        () => this.toaster.success('Contact number copied'),
        () => this.toaster.error('Could not copy to clipboard'),
      );
      return;
    }

    this.toaster.error('Clipboard is not available in this browser');
  }

  closeNotesDialog() {
    this.notesDialogVisible = false;
  }

  private getRecordDateValue(record: any): number {
    const dateCandidate = record?.visit_date || record?.created_at || record?.updated_at || null;
    const t = dateCandidate ? new Date(dateCandidate).getTime() : NaN;
    return Number.isFinite(t) ? t : 0;
  }

  getRecordDisplayDate(record: any): any {
    return record?.visit_date || record?.created_at || record?.updated_at || null;
  }

  getHistoryPaymentItems(record: any): Array<{ key: string; label: string; amount: number }> {
    const items: Array<{ key: string; label: string; amount: number }> = [];
    const push = (key: string, label: string, value: unknown) => {
      const amount = Number(value);
      if (!Number.isNaN(amount) && amount > 0) {
        items.push({ key, label, amount });
      }
    };
    push('fee', 'Fee', record?.visit_fees);
    const discount = normalizeDiscountPercent(record?.discount_percent);
    if (discount > 0) {
      items.push({ key: 'discount', label: 'Disc', amount: discount });
    }
    push('cash', 'Cash', record?.received_cash);
    push('online', 'Online', record?.received_online);
    push('dues', 'Dues', record?.personal_dues);
    return items;
  }

  isHistoryEmpty(value: string | null | undefined): boolean {
    return !(value || '').trim();
  }

  formatHistoryPaymentSummary(record: any): string {
    const items = this.getHistoryPaymentItems(record);
    if (!items.length) {
      return '—';
    }
    return items
      .map((item) =>
        item.key === 'discount'
          ? `${item.label} ${item.amount}%`
          : `${item.label} ₹${item.amount}`
      )
      .join(' · ');
  }

  /** Ultra-short payment labels for the Excel sheet column. */
  formatHistoryPaymentCompact(record: any): string {
    const items = this.getHistoryPaymentItems(record);
    if (!items.length) {
      return '—';
    }
    return items
      .map((item) =>
        item.key === 'discount'
          ? `${this.getHistoryPaymentShortCode(item.key)}${item.amount}%`
          : `${this.getHistoryPaymentShortCode(item.key)}${item.amount}`
      )
      .join(' ');
  }

  getHistoryPaymentShortCode(key: string): string {
    const codes: Record<string, string> = {
      fee: 'F',
      discount: '%',
      cash: 'C',
      online: 'O',
      dues: 'D',
    };
    return codes[key] || key.charAt(0).toUpperCase();
  }

  formatHistoryText(value: string | null | undefined): string {
    const text = (value || '').trim();
    return text || '—';
  }

  canReviseRecord(record: any): boolean {
    return Number(this.historyRecordId(record)) > 0;
  }

  revisionCount(record: any): number {
    const count = Array.isArray(record?.revisions) ? record.revisions.length : 0;
    return count;
  }

  /** Keep history rows in the DOM between change-detection passes so clicks land. */
  trackHistoryRow(_index: number, row: { record: any; index: number }): number {
    return Number(row.record?.id || row.record?.prescription_id) || row.index;
  }

  onHistorySheetClick(event: Event): void {
    const target = event.target as HTMLElement | null;
    if (!target) {
      return;
    }

    const row = target.closest('tr[data-history-index]') as HTMLElement | null;
    if (!row || row.classList.contains('is-pad')) {
      return;
    }

    const index = Number(row.getAttribute('data-history-index'));
    if (!Number.isFinite(index) || index < 0) {
      return;
    }

    this.openVisitRevision(this.filteredRecords?.[index], event);
  }

  openVisitRevision(record: any, event?: Event): void {
    event?.stopPropagation();
    if (!record) {
      return;
    }

    this.canCorrectTodayVisit = this.readIsDoctor();
    this.visitRevisionRecord = record;
    this.visitRevisionPreview = null;
    this.visitRevisionSaving = false;
    this.visitReviseIgnoreBackdrop = true;
    this.visitRevisionForm = {
      chief_complaints: record?.chief_complaints || '',
      medicines: record?.medicines || '',
      notes: record?.notes || '',
    };
    // Insert the overlay after this click finishes so the same click
    // cannot land on the backdrop and close it immediately.
    window.setTimeout(() => {
      this.visitRevisionVisible = true;
      this.cdr.detectChanges();
      window.setTimeout(() => {
        this.visitReviseIgnoreBackdrop = false;
      }, 250);
    }, 0);
  }

  private historyRecordId(record: any): number {
    return Number(record?.id || record?.prescription_id || 0);
  }

  closeVisitRevision(): void {
    if (this.visitRevisionSaving) {
      return;
    }
    this.visitRevisionVisible = false;
    this.visitRevisionRecord = null;
    this.visitRevisionPreview = null;
    this.visitReviseIgnoreBackdrop = false;
    this.cdr.detectChanges();
  }

  onVisitReviseBackdrop(event: Event): void {
    if (this.visitReviseIgnoreBackdrop || event.target !== event.currentTarget) {
      return;
    }
    this.closeVisitRevision();
  }

  previewVisitRevision(version: any): void {
    this.visitRevisionPreview = version;
  }

  useVisitRevision(version: any): void {
    this.visitRevisionForm = {
      chief_complaints: version?.chief_complaints || '',
      medicines: version?.medicines || '',
      notes: version?.notes || '',
    };
    this.visitRevisionPreview = null;
  }

  saveVisitRevision(): void {
    const record = this.visitRevisionRecord;
    const id = this.historyRecordId(record);
    if (!id || this.visitRevisionSaving) {
      return;
    }

    this.visitRevisionSaving = true;
    this.prescriptionsService.revisePrescription(id, {
      chief_complaints: this.visitRevisionForm.chief_complaints || '',
      medicines: this.visitRevisionForm.medicines || '',
      notes: this.visitRevisionForm.notes || '',
    }).subscribe({
      next: (res: any) => {
        this.visitRevisionSaving = false;
        if (!res?.success) {
          this.toaster.error(res?.message || 'Could not save this version.');
          return;
        }

        if (res.unchanged) {
          this.toaster.add({
            severity: 'info',
            summary: 'No change',
            detail: res.message || 'Those fields already match the latest version.',
          });
          return;
        }

        this.applyVisitRevision(record, res.data || {});
        this.closeVisitRevision();
        this.toaster.success(res.message || 'Saved as a new version.');
        this.cdr.markForCheck();
      },
      error: (err) => {
        this.visitRevisionSaving = false;
        this.toaster.error(extractHttpErrorMessage(err, 'Could not save this correction.'));
      },
    });
  }

  private readIsDoctor(): boolean {
    try {
      const user = JSON.parse(sessionStorage.getItem('loggedInUser') || '{}');
      const type = String(user?.type || user?.role || '').toLowerCase();
      const roles = Array.isArray(user?.roles)
        ? user.roles.map((role: unknown) => String(role).toLowerCase())
        : [];
      return type === 'doctor'
        || type === 'assistant_doctor'
        || roles.includes('doctor')
        || roles.includes('assistant_doctor');
    } catch {
      return false;
    }
  }

  private toIstDateKey(value: any): string | null {
    if (value == null || value === '') {
      return null;
    }

    const text = String(value).trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(text)) {
      return text;
    }

    const normalized = text.includes('T') ? text : text.replace(' ', 'T');
    const parsed = new Date(normalized);
    if (!Number.isNaN(parsed.getTime())) {
      return this.getIstDateKey(parsed);
    }

    const day = text.match(/^(\d{4}-\d{2}-\d{2})/);
    return day ? day[1] : null;
  }

  private applyVisitRevision(record: any, data: any): void {
    record.chief_complaints = data?.chief_complaints ?? '';
    record.medicines = data?.medicines ?? '';
    record.notes = data?.notes ?? '';
    record.revisions = Array.isArray(data?.revisions) ? data.revisions : [];

    if (Number(this.prescription?.id) !== Number(record?.id)) {
      return;
    }

    this.prescription.chief_complaints = record.chief_complaints;
    this.prescription.medicines = record.medicines;
    this.prescription.notes = record.notes;
    this.prescription.medicines_final = this.getMedicinesBody(this.prescription.medicines);
  }

  get historySheetPageSize(): number {
    return this.historyRowsPerColumn * 2;
  }

  get historySheetPageCount(): number {
    const total = this.filteredRecords?.length || 0;
    return Math.max(1, Math.ceil(total / this.historySheetPageSize));
  }

  get historySheetPageRecords(): any[] {
    const start = this.historySheetPage * this.historySheetPageSize;
    return (this.filteredRecords || []).slice(start, start + this.historySheetPageSize);
  }

  get historyLeftColumn(): Array<{ record: any; index: number }> {
    return this.historySheetPageRecords
      .slice(0, this.historyRowsPerColumn)
      .map((record, i) => ({
        record,
        index: this.historySheetPage * this.historySheetPageSize + i,
      }));
  }

  get historyRightColumn(): Array<{ record: any; index: number }> {
    return this.historySheetPageRecords
      .slice(this.historyRowsPerColumn, this.historySheetPageSize)
      .map((record, i) => ({
        record,
        index: this.historySheetPage * this.historySheetPageSize + this.historyRowsPerColumn + i,
      }));
  }

  get historySheetRangeLabel(): string {
    const total = this.filteredRecords?.length || 0;
    if (!total) {
      return '0 visits';
    }
    const start = this.historySheetPage * this.historySheetPageSize + 1;
    const end = Math.min(total, start + this.historySheetPageSize - 1);
    return `${start}–${end} of ${total}`;
  }

  prevHistorySheetPage(): void {
    if (this.historySheetPage > 0) {
      this.historySheetPage -= 1;
    }
  }

  nextHistorySheetPage(): void {
    if (this.historySheetPage < this.historySheetPageCount - 1) {
      this.historySheetPage += 1;
    }
  }

  resetHistorySheetPage(): void {
    this.historySheetPage = 0;
  }

  historyPadRows(filledCount: number): number[] {
    const missing = Math.max(0, this.historyRowsPerColumn - filledCount);
    return Array.from({ length: missing }, (_, i) => i);
  }

  selectHistoryRecord(index: number) {
    if (index < 0 || index >= (this.filteredRecords?.length || 0)) {
      return;
    }
    this.selectedIndex = index;
  }

  get selectedHistoryRecord(): any | null {
    const records = this.selectedHistoryRecords;
    return records.length ? records[0] : null;
  }

  get selectedHistoryRecords(): any[] {
    const records = this.filteredRecords || [];
    if (!records.length) {
      return [];
    }

    if (this.selectedIndex === 'today') {
      return [records[0]];
    }

    if (
      typeof this.selectedIndex === 'number' &&
      this.selectedIndex >= 0 &&
      this.selectedIndex < records.length
    ) {
      return [records[this.selectedIndex]];
    }

    return [records[0]];
  }

  isLatestHistoryRecord(record: any): boolean {
    const records = this.filteredRecords || [];
    return !!records.length && records[0] === record;
  }

  hasHistoryPaymentInfo(record: any): boolean {
    return this.getHistoryPaymentItems(record).length > 0;
  }

  get notesHistory(): any[] {
    return (this.filteredRecords || [])
      .filter((record: any) => (record?.notes || '').trim().length > 0)
      .slice()
      .sort((a: any, b: any) => this.getRecordDateValue(b) - this.getRecordDateValue(a));
  }

  get draftLastSavedAtLabel(): string {
    return this.formatDraftTimestamp(this.draftLastSavedAt);
  }

  @HostListener('document:keydown', ['$event'])
  onDocumentKeydown(event: KeyboardEvent): void {
    if (!this.handleRxHotkey(event)) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
  }

  private handleRxHotkey(event: KeyboardEvent): boolean {
    const key = event.key;
    const lowerKey = key.toLowerCase();
    const ctrl = event.ctrlKey || event.metaKey;
    const alt = event.altKey;
    const shift = event.shiftKey;

    if (this.commandPaletteVisible) {
      return false;
    }

    if (key === 'Escape') {
      return this.handleEscapeHotkey();
    }

    if (ctrl && !alt && !shift && lowerKey === 'k') {
      this.openCommandPalette();
      return true;
    }

    if (ctrl && !alt && !shift && lowerKey === 's') {
      this.savePrescriptionViaHotkey();
      return true;
    }

    if (alt && !ctrl && !shift) {
      if (lowerKey === 'q') {
        this.openQueueSidebar();
        return true;
      }
      if (lowerKey === 'f') {
        this.openPatientSearch();
        return true;
      }
      if (lowerKey === 'a' && !this.quickAddDialogVisible) {
        this.openQuickAddDialog();
        return true;
      }
      if (lowerKey === 'm') {
        this.openMedicineQueueSidebar();
        return true;
      }
      if (lowerKey === 'h') {
        this.openNotesDialog();
        return true;
      }
      if (lowerKey === 'p') {
        this.setMedicineCollection(!this.isMedicineCollection);
        return true;
      }
      if (lowerKey === 'c') {
        this.cycleAppointmentDeliveryType();
        return true;
      }
      if (lowerKey === 'u') {
        this.triggerReportUpload();
        return true;
      }
      if (key === '/' || event.code === 'Slash') {
        this.hotkeysHelpVisible = !this.hotkeysHelpVisible;
        return true;
      }
      if (key === 'ArrowDown') {
        this.moveQueueKeyboardFocus(1);
        return true;
      }
      if (key === 'ArrowUp') {
        this.moveQueueKeyboardFocus(-1);
        return true;
      }
      if (key === 'Enter') {
        this.selectQueueKeyboardPatient();
        return true;
      }
      const tabIndex = this.getTabIndexFromDigitKey(key);
      if (tabIndex !== null) {
        this.activeIndex = tabIndex;
        return true;
      }
    }

    if (!ctrl && !alt && !shift && /^F[2-4]$/i.test(key)) {
      const fieldByKey: Record<string, string> = {
        F2: 'chief_complaints',
        F3: 'medicines',
        F4: 'notes',
      };
      this.startDictation(fieldByKey[key.toUpperCase()]);
      return true;
    }

    return false;
  }

  private handleEscapeHotkey(): boolean {
    if (this.visitRevisionVisible) {
      this.closeVisitRevision();
      return true;
    }
    if (this.commandPaletteVisible) {
      this.closeCommandPalette();
      return true;
    }
    if (this.hotkeysHelpVisible) {
      this.hotkeysHelpVisible = false;
      return true;
    }
    if (this.isRecording) {
      this.stopRecording();
      return true;
    }
    if (this.quickAddDialogVisible) {
      this.closeQuickAddDialog();
      return true;
    }
    if (this.notesDialogVisible) {
      this.closeNotesDialog();
      return true;
    }
    if (this.isMedicineVisible) {
      this.isMedicineVisible = false;
      return true;
    }
    if (this.isPatientVisible) {
      this.isPatientVisible = false;
      this.queueKeyboardIndex = -1;
      return true;
    }
    return false;
  }

  private getTabIndexFromDigitKey(key: string): number | null {
    const digit = Number(key);
    if (!Number.isInteger(digit) || digit < 1 || digit > 4) {
      return null;
    }
    return digit - 1;
  }

  private savePrescriptionViaHotkey(): void {
    if (!this.isFormValid()) {
      this.toaster.warn(
        'Select a patient and complete required details before saving.',
        'Cannot save',
        { life: 3500 },
      );
      return;
    }
    this.addPrescriptions();
  }

  private moveQueueKeyboardFocus(step: 1 | -1): void {
    const list = this.filteredConsultationQueue;
    if (!list.length) {
      return;
    }
    if (!this.isPatientVisible) {
      this.openQueueSidebar();
    }
    if (this.queueKeyboardIndex < 0) {
      this.queueKeyboardIndex = step > 0 ? 0 : list.length - 1;
      return;
    }
    this.queueKeyboardIndex = Math.max(0, Math.min(list.length - 1, this.queueKeyboardIndex + step));
  }

  private selectQueueKeyboardPatient(): void {
    const list = this.filteredConsultationQueue;
    if (!list.length) {
      return;
    }
    if (!this.isPatientVisible) {
      this.openQueueSidebar();
    }
    if (this.queueKeyboardIndex < 0) {
      this.queueKeyboardIndex = 0;
    }
    this.selectPatient(list[this.queueKeyboardIndex]);
  }

  triggerReportUpload(): void {
    if (this.activeIndex !== 2) {
      this.activeIndex = 2;
    }
    this.docUploadInput?.nativeElement?.click();
  }

  private startDraftAutosave() {
    if (this.draftAutosaveInterval) {
      clearInterval(this.draftAutosaveInterval);
    }

    this.draftAutosaveInterval = setInterval(() => {
      this.autoSaveDraft();
    }, 3000);
  }

  private autoSaveDraft() {
    const patientId = this.getCurrentPatientId();
    if (!patientId || this.draftRestorePending || this.draftSaveSuppressed) {
      return;
    }

    if (!this.hasDraftableContent()) {
      return;
    }

    const fingerprint = this.getDraftFingerprint();
    if (fingerprint === this.lastDraftFingerprint) {
      return;
    }

    this.persistDraftSnapshot(patientId);
  }

  private getDraftParkParams(patientId: number) {
    const clinicId = Number(
      this.workContext.getClinicId()
      ?? this.clinicId
      ?? sessionStorage.getItem('clinic_id'),
    ) || 0;
    const doctorId = Number(
      this.workContext.getDoctorId()
      ?? this.doctorId
      ?? sessionStorage.getItem('doctor_id'),
    ) || 0;
    return {
      patient_id: patientId,
      clinic_id: clinicId > 0 ? clinicId : undefined,
      doctor_id: doctorId > 0 ? doctorId : undefined,
      date_key: this.getTodayDateKey(),
    };
  }

  private completeSavedConsultation(patientId: number): void {
    if (!patientId) {
      return;
    }
    this.clearTodayDraftForPatient(patientId);
    this.removePatientFromOpenConsultationDock(patientId);
  }

  private captureReturnConsultation(patientId: number): OpenConsultationEntry {
    const existing = this.openConsultations.find(
      (entry) => Number(entry.patient_id) === Number(patientId),
    );
    if (existing) {
      return { ...existing };
    }

    return {
      patient_id: patientId,
      appointment_id: Number(this.prescription?.appointment_id || 0),
      display_name: this.currentPatientDisplayName,
      patient_number: this.patient?.patient_number || '',
      last_opened_at: new Date().toISOString(),
    };
  }

  private tryResumePendingConsultationAfterSave(): void {
    const target = this.pendingReturnConsultation;
    this.pendingReturnConsultation = null;
    if (!target?.patient_id) {
      return;
    }

    const dockEntry = this.openConsultations.find(
      (entry) => Number(entry.patient_id) === Number(target.patient_id),
    );
    if (!dockEntry) {
      return;
    }

    setTimeout(() => this.switchToOpenConsultation(dockEntry), 0);
  }

  private removePatientFromOpenConsultationDock(patientId: number): void {
    const normalizedId = Number(patientId);
    const before = this.openConsultations.length;
    this.openConsultations = this.openConsultations.filter(
      (entry) => Number(entry.patient_id) !== normalizedId,
    );
    if (this.openConsultations.length !== before) {
      this.saveOpenConsultationsToStorage();
    }
  }

  private buildDraftPayload(patientId: number) {
    return {
      patient_id: patientId,
      date_key: this.getTodayDateKey(),
      saved_at: new Date().toISOString(),
      is_medicine_collection: !!this.isMedicineCollection,
      prescription: this.prescription,
    };
  }

  private getDraftSavedAtMs(draft: any | null): number {
    const savedAt = new Date(draft?.saved_at || 0).getTime();
    return Number.isFinite(savedAt) ? savedAt : 0;
  }

  private pickNewerDraft(localDraft: any | null, serverDraft: any | null): any | null {
    if (!localDraft && !serverDraft) {
      return null;
    }
    if (!localDraft) {
      return serverDraft;
    }
    if (!serverDraft) {
      return localDraft;
    }
    return this.getDraftSavedAtMs(serverDraft) >= this.getDraftSavedAtMs(localDraft)
      ? serverDraft
      : localDraft;
  }

  private persistDraftSnapshot(patientId: number): void {
    const draftPayload = this.buildDraftPayload(patientId);

    try {
      localStorage.setItem(this.getDraftStorageKey(patientId), JSON.stringify(draftPayload));
      this.lastDraftFingerprint = this.getDraftFingerprint();
      this.draftStatus = 'saved';
      this.draftLastSavedAt = draftPayload.saved_at;
      this.hasTodayDraft = true;
      this.todayDraftSavedAt = draftPayload.saved_at;
    } catch (err) {
      this.draftStatus = 'error';
      console.error('Draft autosave failed:', err);
      return;
    }

    this.prescriptionsService.upsertParkedWork({
      ...this.getDraftParkParams(patientId),
      appointment_id: this.prescription?.appointment_id || null,
      ...draftPayload,
    }).subscribe({
      error: (err) => console.error('Server park failed:', err),
    });
  }

  private syncLocalDraftFromServer(patientId: number, serverDraft: any): void {
    if (!serverDraft) {
      return;
    }

    try {
      localStorage.setItem(this.getDraftStorageKey(patientId), JSON.stringify(serverDraft));
    } catch (err) {
      console.error('Unable to cache server draft locally:', err);
    }
  }

  private applyResolvedDraftRestore(draft: any | null): void {
    this.refreshTodayDraftState();

    if (draft) {
      this.mergeTodayDraftIntoForm(draft);
      this.draftStatus = 'saved';
      this.draftLastSavedAt = draft.saved_at || null;
    }

    this.reapplyReceptionNotesAfterDraftRestore();

    this.lastDraftFingerprint = this.getDraftFingerprint();
    this.draftRestorePending = false;

    if (this.getCurrentPatientId()) {
      this.applyMedicinesDatePrefix();
    }

    this.syncOpenConsultationDock();
  }

  private mergeTodayDraftIntoForm(draft: any) {
    const draftPrescription = draft?.prescription || {};
    const currentId = this.prescription.id;
    const currentAppointmentId = this.prescription.appointment_id;
    const draftNotes = String(draftPrescription.notes ?? '').trim();
    const currentNotes = String(this.prescription.notes ?? '').trim();
    const mergedNotes = draftNotes || currentNotes;

    this.prescription = {
      ...this.prescription,
      ...draftPrescription,
      id: currentId,
      appointment_id: currentAppointmentId,
      notes: mergedNotes,
      visit_fees:
        draftPrescription.visit_fees != null
          ? this.normalizeDraftVisitFees(Number(draftPrescription.visit_fees))
          : this.resolveVisitFees(this.patient),
      discount_percent: normalizeDiscountPercent(draftPrescription.discount_percent),
      personal_dues:
        draftPrescription.personal_dues != null ? Number(draftPrescription.personal_dues) : 0,
      received_cash:
        draftPrescription.received_cash != null ? Number(draftPrescription.received_cash) : 0,
      received_online: Math.max(
        draftPrescription.received_online != null ? Number(draftPrescription.received_online) : 0,
        Math.round(this.settledOnlineAmount || 0),
      ),
      family_history: {
        father: '',
        mother: '',
        other: '',
        ...(draftPrescription.family_history || {})
      },
      others: {
        nail: '',
        mentals: '',
        stool: '',
        urine: '',
        sleep: '',
        parsp: '',
        corn: '',
        mole: '',
        hair: '',
        spine: '',
        pallor: '',
        cyanosis: '',
        clubbing: '',
        icterus: '',
        thirst: '',
        craving: '',
        aversion: '',
        dreams: '',
        thermals: '',
        warts: '',
        lm: '',
        tongue: '',
        ...(draftPrescription.others || {})
      }
    };

    const restoredDiscount = normalizeDiscountPercent(this.prescription.discount_percent);
    const restoredFee = Number(this.prescription.visit_fees) || 0;
    this.lastAppliedDiscountPercent = restoredDiscount;
    if (restoredDiscount > 0 && restoredDiscount < 100 && restoredFee > 0) {
      this.setVisitFeeBase(Math.round((restoredFee * 100) / (100 - restoredDiscount)));
    } else {
      this.setVisitFeeBase(restoredFee || this.resolveStandardVisitFeeBase());
    }

    this.applyAppointmentFlowFromSource({
      delivery_type: draftPrescription.delivery_type,
      medicine_collection: draft?.is_medicine_collection,
      is_courier: draftPrescription.is_courier,
    });
    this.applyMedicinesDatePrefix();

    if (
      mergedNotes &&
      (!draftNotes || mergedNotes === this.receptionNotesSeed || mergedNotes === this.pendingReceptionAppointmentNote)
    ) {
      if (this.receptionNotesSeed && mergedNotes === this.receptionNotesSeed) {
        this.receptionNotesHighlightActive = true;
      } else if (this.pendingReceptionAppointmentNote && mergedNotes === this.pendingReceptionAppointmentNote) {
        this.receptionNotesHighlightActive = true;
        this.receptionNotesSeed = this.pendingReceptionAppointmentNote;
      }
    } else if (draftNotes && draftNotes !== this.receptionNotesSeed) {
      this.clearReceptionNotesHighlight();
    }
  }

  /** Re-seed reception notes if an empty autosaved draft wiped them during restore. */
  private reapplyReceptionNotesAfterDraftRestore(): void {
    const pending = String(this.pendingReceptionAppointmentNote || '').trim();
    if (!pending) {
      return;
    }

    const current = String(this.prescription?.notes || '').trim();
    if (current) {
      return;
    }

    this.prescription.notes = this.resolveInitialPrescriptionNotes('', pending);
  }

  /** Apply today's draft after patient/history load; avoids autosave clobbering stored drafts. */
  private finalizePatientDraftRestore(
    patientIdOverride?: number,
    loadGen?: number,
  ) {
    const patientId = Number(patientIdOverride || this.getCurrentPatientId()) || 0;
    if (!patientId) {
      this.draftRestorePending = false;
      return;
    }

    if (loadGen != null && !this.isPatientLoadCurrent(loadGen)) {
      this.draftRestorePending = false;
      return;
    }

    const localDraft = this.getTodayDraftForPatient(patientId);

    this.prescriptionsService.getParkedWork(this.getDraftParkParams(patientId)).subscribe({
      next: (res: any) => {
        if (loadGen != null && !this.isPatientLoadCurrent(loadGen)) {
          return;
        }

        const serverDraft = res?.success ? res.data : null;
        const draft = this.pickNewerDraft(localDraft, serverDraft);

        if (
          serverDraft &&
          this.getDraftSavedAtMs(serverDraft) >= this.getDraftSavedAtMs(localDraft)
        ) {
          this.syncLocalDraftFromServer(patientId, serverDraft);
        }

        this.applyResolvedDraftRestore(draft);
      },
      error: () => {
        if (loadGen != null && !this.isPatientLoadCurrent(loadGen)) {
          return;
        }

        this.applyResolvedDraftRestore(localDraft);
      },
    });
  }

  private hasDraftableContent(): boolean {
    const p = this.prescription || {};
    const hasText =
      (p.summary || '').trim().length > 0 ||
      (p.chief_complaints || '').trim().length > 0 ||
      this.getMedicinesBody(p.medicines).trim().length > 0 ||
      (p.diagnosis || '').trim().length > 0 ||
      (p.notes || '').trim().length > 0;

    const defaultFees = this.resolveVisitFees(this.patient);
    const visitFees = Number(p.visit_fees || 0);
    const hasFinancials =
      Number(p.received_cash || 0) > 0 ||
      Number(p.received_online || 0) > 0 ||
      Number(p.personal_dues || 0) > 0 ||
      normalizeDiscountPercent(p.discount_percent) > 0 ||
      (visitFees > 0 && visitFees !== defaultFees);

    return hasText || hasFinancials || !!this.isMedicineCollection || !!resolveDeliveryType(p);
  }

  private getDraftFingerprint(): string {
    const snapshot = {
      is_medicine_collection: !!this.isMedicineCollection,
      prescription: this.prescription
    };
    return JSON.stringify(snapshot);
  }

  private beginPatientLoad(): number {
    this.patientLoadGeneration += 1;
    return this.patientLoadGeneration;
  }

  private invalidatePatientLoad(): void {
    this.patientLoadGeneration += 1;
  }

  private isPatientLoadCurrent(generation: number): boolean {
    return generation === this.patientLoadGeneration;
  }

  private getCurrentPatientId(): number {
    const patientId = this.patient?.patient_id || this.patient?.id || 0;
    return Number(patientId) || 0;
  }

  private getTodayDateKey(): string {
    return todayDateString();
  }

  private getDraftStorageKey(patientId: number): string {
    return `${this.draftStoragePrefix}_${patientId}_${this.getTodayDateKey()}`;
  }

  private getTodayDraftForPatient(patientId: number): any | null {
    if (!patientId) {
      return null;
    }

    const raw = localStorage.getItem(this.getDraftStorageKey(patientId));
    if (!raw) {
      return null;
    }

    try {
      const parsed = JSON.parse(raw);
      if (parsed?.date_key && parsed.date_key !== this.getTodayDateKey()) {
        return null;
      }
      return parsed;
    } catch {
      return null;
    }
  }

  private getTodayDraft(): any | null {
    return this.getTodayDraftForPatient(this.getCurrentPatientId());
  }

  private onPatientContextChanged() {
    this.appointmentDeliveryType = null;
    this.syncDeliveryFlags();
    this.draftRestorePending = true;
    this.lastDraftFingerprint = '';
    this.draftStatus = 'idle';
    this.draftLastSavedAt = null;
    this.refreshTodayDraftState();
  }

  setDeliveryType(type: DeliveryType) {
    const next: DeliveryType | null = this.appointmentDeliveryType === type ? null : type;
    this.applyDeliveryType(next);
  }

  cycleAppointmentDeliveryType() {
    this.applyDeliveryType(nextDeliveryType(this.appointmentDeliveryType));
  }

  private applyDeliveryType(type: DeliveryType | null) {
    this.appointmentDeliveryType = type;
    if (type) {
      this.isMedicineCollection = false;
      if (this.patient) {
        this.patient.medicine_collection = false;
      }
    }
    this.syncDeliveryFlags();
    this.persistAppointmentDeliveryFlag(this.prescription.appointment_id);
  }

  setMedicineCollection(active: boolean) {
    this.isMedicineCollection = !!active;
    if (this.isMedicineCollection) {
      this.appointmentDeliveryType = null;
    }
    if (this.patient) {
      this.patient.medicine_collection = this.isMedicineCollection;
    }
    this.syncDeliveryFlags();
  }

  toggleHxPanel(panel: 'past' | 'family'): void {
    this.hxPanelOpen[panel] = !this.hxPanelOpen[panel];
  }

  toggleOtPanel(panel: 'general' | 'physical' | 'exam' | 'systemic' | 'constitutional' | 'mental'): void {
    this.otPanelOpen[panel] = !this.otPanelOpen[panel];
  }

  private hasOtFieldsData(keys: string[]): boolean {
    const others = this.prescription?.others || {};
    return keys.some((key) => this.hasHxText(others[key]));
  }

  hasOtGeneralData(): boolean {
    return this.hasOtFieldsData(['pallor', 'cyanosis', 'clubbing', 'icterus']);
  }

  hasOtPhysicalData(): boolean {
    return this.hasOtFieldsData(['nail', 'hair', 'tongue', 'spine', 'corn', 'mole', 'warts']);
  }

  hasOtSystemicData(): boolean {
    return this.hasOtFieldsData(['stool', 'urine', 'sleep', 'parsp']);
  }

  hasOtConstitutionalData(): boolean {
    return this.hasOtFieldsData(['thirst', 'craving', 'aversion', 'thermals']);
  }

  hasOtMentalData(): boolean {
    return this.hasOtFieldsData(['mentals', 'dreams', 'lm']);
  }

  hasOtExamData(): boolean {
    const p = this.prescription;
    return (
      this.hasHxText(p?.respiratory_system) ||
      this.hasHxText(p?.cardiovascular_system) ||
      this.hasHxText(p?.central_nervous_system) ||
      this.hasHxText(p?.per_abdomen)
    );
  }

  hasOtData(): boolean {
    return (
      this.hasOtGeneralData() ||
      this.hasOtPhysicalData() ||
      this.hasOtExamData() ||
      this.hasOtSystemicData() ||
      this.hasOtConstitutionalData() ||
      this.hasOtMentalData()
    );
  }

  get otFilledSectionCount(): number {
    let count = 0;
    if (this.hasOtGeneralData()) count++;
    if (this.hasOtPhysicalData()) count++;
    if (this.hasOtExamData()) count++;
    if (this.hasOtSystemicData()) count++;
    if (this.hasOtConstitutionalData()) count++;
    if (this.hasOtMentalData()) count++;
    return count;
  }

  hasHxPastData(): boolean {
    return (
      this.hasHxText(this.prescription?.past_history) ||
      this.hasHxText(this.prescription?.menstrual_history)
    );
  }

  hasHxFamilyData(): boolean {
    const fh = this.prescription?.family_history;
    return (
      this.hasHxText(fh?.mother) ||
      this.hasHxText(fh?.father) ||
      this.hasHxText(fh?.other)
    );
  }

  private hasHxText(value: unknown): boolean {
    return !!String(value ?? '').trim();
  }

  private applyAppointmentFlowFromSource(source: any): void {
    const flow = resolveAppointmentFlow(source);
    this.appointmentDeliveryType = flow.deliveryType;
    this.isMedicineCollection = flow.medicineCollection;

    if (this.patient) {
      this.patient.medicine_collection = flow.medicineCollection;
    }

    this.syncDeliveryFlags();
  }

  private syncDeliveryFlags() {
    if (!this.prescription) {
      return;
    }

    this.prescription.delivery_type = this.appointmentDeliveryType;
    this.prescription.is_courier = !!this.appointmentDeliveryType;
  }

  private persistAppointmentDeliveryFlag(appointmentId: any) {
    const id = Number(appointmentId || 0);
    if (!id) {
      return;
    }

    this.appointmentService.updateAppointment({
      id,
      delivery_type: this.appointmentDeliveryType,
      is_courier: !!this.appointmentDeliveryType,
    }).subscribe({
      error: (err) => {
        console.error('Error updating appointment delivery type:', err);
      }
    });
  }

  private refreshTodayDraftState() {
    const draft = this.getTodayDraft();
    this.hasTodayDraft = !!draft;
    this.todayDraftSavedAt = draft?.saved_at || null;
  }

  private clearTodayDraftForPatient(patientIdOverride?: number) {
    const patientId = Number(patientIdOverride || this.getCurrentPatientId()) || 0;
    if (!patientId) {
      return;
    }

    localStorage.removeItem(this.getDraftStorageKey(patientId));
    this.hasTodayDraft = false;
    this.todayDraftSavedAt = null;
    this.draftStatus = 'idle';
    this.draftLastSavedAt = null;
    this.lastDraftFingerprint = this.getDraftFingerprint();
    this.draftSaveSuppressed = true;

    const parkParams = this.getDraftParkParams(patientId);
    this.prescriptionsService.deleteParkedWork(parkParams).subscribe({
      next: () => {},
      error: (err) => console.error('Server park delete failed:', err),
    });
  }

  private resetDraftUiState() {
    this.hasTodayDraft = false;
    this.todayDraftSavedAt = null;
    this.draftStatus = 'idle';
    this.draftLastSavedAt = null;
    this.lastDraftFingerprint = '';
    this.draftRestorePending = false;
    this.draftSaveSuppressed = false;
  }

  private formatDraftTimestamp(value: string | null): string {
    if (!value) {
      return '';
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return '';
    }

    return `at ${date.toLocaleTimeString('en-IN', {
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Asia/Kolkata',
    })}`;
  }

}

// Patient name, primary_contact, email, dob
